import { ChangeDetectionStrategy, Component, EventEmitter, HostListener, Input, NgModule, Output, Renderer2, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var IccDrawMathService = (function () {
    function IccDrawMathService() {
    }
    /**
     * @param {?} poly
     * @return {?}
     */
    IccDrawMathService.getAreaFromPoly = /**
     * @param {?} poly
     * @return {?}
     */
    function (poly) {
        var /** @type {?} */ angle, /** @type {?} */ area = 0, /** @type {?} */ circle;
        for (var /** @type {?} */ i = 0, /** @type {?} */ j = 1; i < poly.length; ++i, ++j, j %= poly.length) {
            area -= (Number(poly[i].x) * Number(poly[j].y) - Number(poly[j].x) * Number(poly[i].y)) / 2;
            if (poly[j].cr) {
                circle = this.getCircleCenter(poly[i], poly[j], poly[j].cr);
                // angle = poly[j].cw
                //     ? Math.atan2(poly[j].y - circle.cy, poly[j].x - circle.cx) - Math.atan2(poly[i].y - circle.cy, poly[i].x - circle.cx)
                //     : Math.atan2(poly[i].y - circle.cy, poly[i].x - circle.cx) - Math.atan2(poly[j].y - circle.cy, poly[j].x - circle.cx);
                // angle = poly[j].cw ? -angle : angle;
                angle = Math.atan2(poly[i].y - circle.cy, poly[i].x - circle.cx) - Math.atan2(poly[j].y - circle.cy, poly[j].x - circle.cx);
                angle = (angle + Math.PI * 2) % (Math.PI * 2);
                area -= (poly[j].cw ? 1 : -1) * Math.pow(poly[j].cr, 2) * (angle - Math.sin(angle)) / 2;
            }
        }
        return Number(area) || 0;
    };
    /**
     * @param {?} rect
     * @return {?}
     */
    IccDrawMathService.getAreaFromRect = /**
     * @param {?} rect
     * @return {?}
     */
    function (rect) {
        return (Number(rect.width) * Number(rect.height)) || 0;
    };
    /**
     * @param {?} point1
     * @param {?} point2
     * @param {?} radius
     * @return {?}
     */
    IccDrawMathService.getCircleCenter = /**
     * @param {?} point1
     * @param {?} point2
     * @param {?} radius
     * @return {?}
     */
    function (point1, point2, radius) {
        var /** @type {?} */ q = Math.sqrt(Math.pow((point2.x - point1.x), 2) + Math.pow((point2.y - point1.y), 2));
        var /** @type {?} */ baseX = Math.sqrt(Math.pow(radius, 2) - Math.pow((q / 2), 2)) * (point1.y - point2.y) / q;
        var /** @type {?} */ baseY = Math.sqrt(Math.pow(radius, 2) - Math.pow((q / 2), 2)) * (point2.x - point1.x) / q;
        return {
            cx: (point1.x + point2.x) / 2 - baseX,
            cy: (point1.y + point2.y) / 2 - baseY,
        };
    };
    /**
     * @param {?} point1
     * @param {?} point2
     * @param {?} point3
     * @return {?}
     */
    IccDrawMathService.getCircleRadius = /**
     * @param {?} point1
     * @param {?} point2
     * @param {?} point3
     * @return {?}
     */
    function (point1, point2, point3) {
        var /** @type {?} */ a = point1.x;
        var /** @type {?} */ b = point1.y;
        var /** @type {?} */ c = point2.x;
        var /** @type {?} */ d = point2.y;
        var /** @type {?} */ e = point3.x;
        var /** @type {?} */ f = point3.y;
        return {
            rx: 0.5 * ((a * a + b * b) * (e - c) + (c * c + d * d) * (a - e) + (e * e + f * f) * (c - a))
                / (b * (e - c) + d * (a - e) + f * (c - a)),
            ry: 0.5 * ((a * a + b * b) * (f - d) + (c * c + d * d) * (b - f) + (e * e + f * f) * (d - b))
                / (a * (f - d) + c * (b - f) + e * (d - b)),
        };
    };
    /**
     * @param {?} poly
     * @return {?}
     */
    IccDrawMathService.getGravityFromPoly = /**
     * @param {?} poly
     * @return {?}
     */
    function (poly) {
        var /** @type {?} */ gravity = /** @type {?} */ ({});
        var /** @type {?} */ sum = 0;
        var /** @type {?} */ vsum = { x: 0, y: 0 };
        for (var /** @type {?} */ x = 0, /** @type {?} */ y = poly.length - 1; x < poly.length; y = x++) {
            var /** @type {?} */ p1 = poly[x];
            var /** @type {?} */ p2 = poly[y];
            var /** @type {?} */ cross = p1.x * p2.y - p1.y * p2.x;
            sum += cross;
            vsum.x += (p1.x + p2.x) * cross;
            vsum.y += (p1.y + p2.y) * cross;
        }
        var /** @type {?} */ z = 1 / (3 * sum);
        gravity.x = Math.ceil(vsum.x * z);
        gravity.y = Math.ceil(vsum.y * z);
        var /** @type {?} */ rect = this.getRectFromPoly(poly);
        gravity.width = Math.ceil(Math.min(gravity.x - rect.x, rect.x + rect.width - gravity.x));
        gravity.height = Math.ceil(Math.min(gravity.y - rect.y, rect.y + rect.height - gravity.y));
        gravity.horizontal = IccDrawMathService.intersectLineWithPoly([
            { x: rect.x, y: gravity.y },
            { x: rect.x + rect.width, y: gravity.y },
        ], poly);
        gravity.vertical = IccDrawMathService.intersectLineWithPoly([
            { x: gravity.x, y: rect.y },
            { x: gravity.x, y: rect.y + rect.height },
        ], poly);
        return gravity;
    };
    /**
     * @param {?} rect
     * @return {?}
     */
    IccDrawMathService.getGravityFromRect = /**
     * @param {?} rect
     * @return {?}
     */
    function (rect) {
        return {
            x: rect.x + rect.width / 2,
            y: rect.y + rect.height / 2,
        };
    };
    /**
     * @param {?} line
     * @return {?}
     */
    IccDrawMathService.getLineEquationOld = /**
     * @param {?} line
     * @return {?}
     */
    function (line) {
        var /** @type {?} */ div = line[1].x - line[0].x || 0.000001;
        var /** @type {?} */ m = (line[1].y - line[0].y) / div;
        var /** @type {?} */ b = -m * line[0].x + line[0].y;
        return { m: m, b: b };
    };
    /**
     * @param {?} line
     * @return {?}
     */
    IccDrawMathService.getLineEquation = /**
     * @param {?} line
     * @return {?}
     */
    function (line) {
        var /** @type {?} */ A, /** @type {?} */ B, /** @type {?} */ C;
        // if (line[1].cr) {
        //   const circle = this.getCircleCenter(line[0], line[1], line[1].cr);
        //   /** x² + y² + Ax + By + C = 0 */
        //   A = Number(-2 * circle.cx);
        //   B = Number(-2 * circle.cy);
        //   C = Number(Math.pow(circle.cx, 2) + Math.pow(circle.cy, 2) - Math.pow(line[1].cr, 2));
        // } else {
        /** Ax + By + C = 0 */
        A = Number(line[0].y - line[1].y);
        B = Number(line[1].x - line[0].x);
        C = Number(line[0].x * line[1].y - line[1].x * line[0].y);
        // }
        return { A: A, B: B, C: C };
    };
    /**
     * @param {?} line
     * @param {?=} poly
     * @return {?}
     */
    IccDrawMathService.getLineInfo = /**
     * @param {?} line
     * @param {?=} poly
     * @return {?}
     */
    function (line, poly) {
        if (poly === void 0) { poly = null; }
        var /** @type {?} */ angle, /** @type {?} */ circle, /** @type {?} */ length, /** @type {?} */ side;
        angle = Math.atan2(line[1].y - line[0].y, line[1].x - line[0].x);
        angle = (angle / Math.PI + 2) % 2;
        side = angle === 1 ? 'top'
            : angle === 0 ? 'bottom'
                : angle > 1 ? 'right'
                    : angle < 1 ? 'left'
                        : null;
        if (line[1].cr) {
            if (poly) {
                var /** @type {?} */ hasTop = false;
                var /** @type {?} */ hasBottom = false;
                for (var /** @type {?} */ curr = 0, /** @type {?} */ next = 1; curr < poly.length; ++curr, ++next, next %= poly.length) {
                    var side2 = IccDrawMathService.getLineInfo([poly[curr], poly[next]]).side;
                    if (side2 === 'top') {
                        hasTop = true;
                    }
                    if (side2 === 'bottom') {
                        hasBottom = true;
                    }
                }
                if (!hasTop && !hasBottom) {
                    side = 'top';
                }
                else if (!hasTop && angle > 0.5 && angle < 1.5) {
                    side = 'top';
                }
                else if (!hasBottom && (angle < 0.5 || angle > 1.5)) {
                    side = 'bottom';
                }
            }
            circle = this.getCircleCenter(line[0], line[1], line[1].cr);
            var /** @type {?} */ circleAngle = line[1].cw
                ? Math.atan2(line[1].y - circle.cy, line[1].x - circle.cx) - Math.atan2(line[0].y - circle.cy, line[0].x - circle.cx)
                : Math.atan2(line[0].y - circle.cy, line[0].x - circle.cx) - Math.atan2(line[1].y - circle.cy, line[1].x - circle.cx);
            circleAngle = (circleAngle / Math.PI + 2) % 2;
            length = Math.abs(line[1].cr * circleAngle * Math.PI);
        }
        else {
            length = Math.sqrt(Math.pow(Number(line[1].x) - Number(line[0].x), 2) + Math.pow(Number(line[1].y) - Number(line[0].y), 2));
        }
        return { angle: angle, circle: circle, length: length, side: side };
    };
    /**
     * @param {?} oldLine
     * @param {?} shift
     * @return {?}
     */
    IccDrawMathService.getLineShift = /**
     * @param {?} oldLine
     * @param {?} shift
     * @return {?}
     */
    function (oldLine, shift) {
        if (oldLine && oldLine[1] && oldLine[1].cr) {
            return this.getLineArcShift(oldLine, shift);
        }
        else {
            return this.getLinePolyShift(oldLine, shift);
        }
    };
    /**
     * @param {?} oldLine
     * @param {?} shift
     * @return {?}
     */
    IccDrawMathService.getLineArcShift = /**
     * @param {?} oldLine
     * @param {?} shift
     * @return {?}
     */
    function (oldLine, shift) {
        var /** @type {?} */ circle = this.getCircleCenter(oldLine[0], oldLine[1], oldLine[1].cr);
        var /** @type {?} */ lineAngle0 = Math.atan2(circle.cy - oldLine[0].y, circle.cx - oldLine[0].x) / Math.PI;
        var /** @type {?} */ lineAngle1 = Math.atan2(circle.cy - oldLine[1].y, circle.cx - oldLine[1].x) / Math.PI;
        var /** @type {?} */ lineShift = Number.isFinite(shift) ? shift : shift.top;
        return [
            {
                x: this.round(oldLine[0].x + (Math.cos(lineAngle0 * Math.PI) * lineShift)),
                y: this.round(oldLine[0].y + (Math.sin(lineAngle0 * Math.PI) * lineShift)),
            },
            {
                cr: oldLine[1].cr - lineShift,
                x: this.round(oldLine[1].x + (Math.cos(lineAngle1 * Math.PI) * lineShift)),
                y: this.round(oldLine[1].y + (Math.sin(lineAngle1 * Math.PI) * lineShift)),
            },
        ];
    };
    /**
     * @param {?} line
     * @param {?} shift
     * @return {?}
     */
    IccDrawMathService.getLinePolyShift = /**
     * @param {?} line
     * @param {?} shift
     * @return {?}
     */
    function (line, shift) {
        var _a = this.getLineInfo(line), angle = _a.angle, side = _a.side;
        var /** @type {?} */ lineAngle = angle - 0.500001;
        var /** @type {?} */ lineShift = Number.isFinite(shift) ? shift : shift[side];
        return [
            {
                x: this.round(line[0].x + (Math.cos(lineAngle * Math.PI) * lineShift)),
                y: this.round(line[0].y + (Math.sin(lineAngle * Math.PI) * lineShift)),
            },
            {
                x: this.round(line[1].x + (Math.cos(lineAngle * Math.PI) * lineShift)),
                y: this.round(line[1].y + (Math.sin(lineAngle * Math.PI) * lineShift)),
            }
        ];
    };
    /**
     * @param {?} line1
     * @param {?} line2
     * @return {?}
     */
    IccDrawMathService.getLinesIntersection = /**
     * @param {?} line1
     * @param {?} line2
     * @return {?}
     */
    function (line1, line2) {
        if (line1[1].cr && line2[1].cr) {
            return this.getLinesArcArcIntersection(line1, line2);
        }
        else if (line1[1].cr) {
            return this.getLinesPolyArcIntersection(line2, line1, true);
        }
        else if (line2[1].cr) {
            return this.getLinesPolyArcIntersection(line1, line2, false);
        }
        else {
            return this.getLinesPolyPolyIntersection(line1, line2);
        }
    };
    /**
     * @param {?} line1
     * @param {?} line2
     * @return {?}
     */
    IccDrawMathService.getLinesArcArcIntersection = /**
     * @param {?} line1
     * @param {?} line2
     * @return {?}
     */
    function (line1, line2) {
        return line1[1];
    };
    /**
     * @param {?} line1
     * @param {?} line2
     * @param {?} arc
     * @return {?}
     */
    IccDrawMathService.getLinesPolyArcIntersection = /**
     * @param {?} line1
     * @param {?} line2
     * @param {?} arc
     * @return {?}
     */
    function (line1, line2, arc) {
        var /** @type {?} */ intersection = {
            cr: arc ? line2[1].cr : null,
            x: 0,
            y: 0,
        };
        var /** @type {?} */ circle = this.getCircleCenter(line2[0], line2[1], line2[1].cr);
        var /** @type {?} */ lineEq = this.getLineEquationOld(line1);
        var _a = this.getLinesPolyPolyIntersection(line1, line2), x = _a.x, y = _a.y;
        var /** @type {?} */ delta = Math.pow(line2[1].cr, 2) * (1 + Math.pow(lineEq.m, 2)) - Math.pow(circle.cy - lineEq.m * circle.cx - lineEq.b, 2);
        if (delta >= 0) {
            var /** @type {?} */ x1 = (circle.cx + circle.cy * lineEq.m - lineEq.b * lineEq.m + Math.sqrt(delta)) / (1 + Math.pow(lineEq.m, 2));
            var /** @type {?} */ x2 = (circle.cx + circle.cy * lineEq.m - lineEq.b * lineEq.m - Math.sqrt(delta)) / (1 + Math.pow(lineEq.m, 2));
            var /** @type {?} */ y1 = lineEq.m * x1 + lineEq.b;
            var /** @type {?} */ y2 = lineEq.m * x2 + lineEq.b;
            var /** @type {?} */ d1 = Math.sqrt(Math.pow(x1 - x, 2) + Math.pow(y1 - y, 2));
            var /** @type {?} */ d2 = Math.sqrt(Math.pow(x2 - x, 2) + Math.pow(y2 - y, 2));
            intersection.x = d1 < d2 ? x1 : x2;
            intersection.y = d1 < d2 ? y1 : y2;
        }
        else {
            intersection.x = x;
            intersection.y = y;
        }
        return intersection;
    };
    /**
     * @param {?} line1
     * @param {?} line2
     * @return {?}
     */
    IccDrawMathService.getLinesPolyPolyIntersection = /**
     * @param {?} line1
     * @param {?} line2
     * @return {?}
     */
    function (line1, line2) {
        var /** @type {?} */ x, /** @type {?} */ y;
        var /** @type {?} */ line1eq = this.getLineEquation(line1);
        var /** @type {?} */ line2eq = this.getLineEquation(line2);
        if (line1eq.A * line2eq.B - line2eq.A * line1eq.B) {
            x = (line1eq.B * line2eq.C - line2eq.B * line1eq.C) / (line1eq.A * line2eq.B - line2eq.A * line1eq.B);
            y = (line2eq.A * line1eq.C - line1eq.A * line2eq.C) / (line1eq.A * line2eq.B - line2eq.A * line1eq.B);
        }
        return { x: x, y: y };
        // const l1 = this.getLineEquationOld(line1);
        // const l2 = this.getLineEquationOld(line2);
        // const dm = l2.m - l1.m || 0.000001;
        // return {
        //   x: this.round((l1.b - l2.b) / dm),
        //   y: this.round((l1.b * l2.m - l2.b * l1.m) / dm),
        // };
    };
    /**
     * @param {?} innerPoly
     * @param {?} outerPoly
     * @return {?}
     */
    IccDrawMathService.getParallelPoly = /**
     * @param {?} innerPoly
     * @param {?} outerPoly
     * @return {?}
     */
    function (innerPoly, outerPoly) {
        var /** @type {?} */ poly = innerPoly.map(function () { return null; });
        var /** @type {?} */ line1, /** @type {?} */ line1eq, /** @type {?} */ line2, /** @type {?} */ line2eq;
        for (var /** @type {?} */ currInner = 0, /** @type {?} */ nextInner = 1; currInner < innerPoly.length; ++currInner, ++nextInner, nextInner %= innerPoly.length) {
            line1 = [innerPoly[currInner], innerPoly[nextInner]];
            line1eq = this.getLineEquation(line1);
            poly[currInner] = this.getLineInfo(line1, innerPoly).side;
            for (var /** @type {?} */ currOuter = 0, /** @type {?} */ nextOuter = 1; currOuter < outerPoly.length; ++currOuter, ++nextOuter, nextOuter %= outerPoly.length) {
                line2 = [outerPoly[currOuter], outerPoly[nextOuter]];
                line2eq = this.getLineEquation(line2);
                /** odcinek linii */
                if (this.round(line1eq.A / line1eq.C, 5) === this.round(line2eq.A / line2eq.C, 5)
                    && this.round(line1eq.B / line1eq.C, 5) === this.round(line2eq.B / line2eq.C, 5)) {
                    poly[currInner] = currOuter;
                    break;
                }
                /** fragment łuku */
                if (innerPoly[nextInner].cr && outerPoly[nextOuter].cr) {
                    var /** @type {?} */ innerCircle = IccDrawMathService.getCircleCenter(innerPoly[currInner], innerPoly[nextInner], innerPoly[nextInner].cr);
                    // const outerCircle = IccDrawMathService.getCircleCenter(outerPoly[currOuter], outerPoly[nextOuter], outerPoly[nextOuter].cr);
                    var /** @type {?} */ circleCenter = { x: this.round(innerCircle.cx, 2), y: this.round(innerCircle.cy, 2) };
                    var /** @type {?} */ currInnerAngle = IccDrawMathService.getLineInfo([circleCenter, innerPoly[currInner]]).angle;
                    var /** @type {?} */ nextInnerAngle = IccDrawMathService.getLineInfo([circleCenter, innerPoly[nextInner]]).angle;
                    var /** @type {?} */ currOuterAngle = IccDrawMathService.getLineInfo([circleCenter, outerPoly[currOuter]]).angle;
                    var /** @type {?} */ nextOuterAngle = IccDrawMathService.getLineInfo([circleCenter, outerPoly[nextOuter]]).angle;
                    if (currInnerAngle <= currOuterAngle && nextInnerAngle >= nextOuterAngle) {
                        poly[currInner] = currOuter;
                        break;
                    }
                }
            }
        }
        return poly;
    };
    /**
     * @param {?} poly
     * @return {?}
     */
    IccDrawMathService.getPerimeterFromPoly = /**
     * @param {?} poly
     * @return {?}
     */
    function (poly) {
        var /** @type {?} */ perimeter = 0;
        for (var /** @type {?} */ i = 0, /** @type {?} */ j = 1; i < poly.length; ++i, ++j, j %= poly.length) {
            perimeter += this.getLineInfo([poly[i], poly[j]]).length;
        }
        return Number(perimeter) || 0;
    };
    /**
     * @param {?} rect
     * @return {?}
     */
    IccDrawMathService.getPerimeterFromRect = /**
     * @param {?} rect
     * @return {?}
     */
    function (rect) {
        return (Number(rect.width) + Number(rect.height)) * 2 || 0;
    };
    /**
     * @param {?} rect
     * @return {?}
     */
    IccDrawMathService.getPolyFromRect = /**
     * @param {?} rect
     * @return {?}
     */
    function (rect) {
        return [
            { x: rect.x, y: rect.y },
            { x: rect.x, y: rect.y + rect.height },
            { x: rect.x + rect.width, y: rect.y + rect.height },
            { x: rect.x + rect.width, y: rect.y },
        ];
    };
    /**
     * @param {?} shape
     * @return {?}
     */
    IccDrawMathService.getPolyFromShape = /**
     * @param {?} shape
     * @return {?}
     */
    function (shape) {
        var /** @type {?} */ polygon = [];
        switch (shape.shape) {
            case 'arc':
                polygon = this.getPolyFromArcShape(shape);
                break;
            case 'circle':
                polygon.push({ cr: shape.d / 2, x: 0, y: shape.d / 2 });
                polygon.push({ cr: shape.d / 2, x: shape.d / 2, y: shape.d });
                polygon.push({ cr: shape.d / 2, x: shape.d, y: shape.d / 2 });
                polygon.push({ cr: shape.d / 2, x: shape.d / 2, y: 0 });
                break;
            default:
                polygon.push({ x: 0, y: shape.h1 });
                polygon.push({ x: shape.s1 + shape.s2 + shape.s3, y: shape.h1 });
                polygon.push({ x: shape.s1 + shape.s2 + shape.s3, y: shape.h1 - shape.h2 });
                polygon.push({ x: shape.s1 + shape.s2, y: 0 });
                polygon.push({ x: shape.s1, y: 0 });
                polygon.push({ x: 0, y: shape.h1 - shape.h3 });
                break;
        }
        polygon = polygon.filter(function (o, i, s) { return s.findIndex(function (t) { return t.x === o.x && t.y === o.y; }) === i; });
        return polygon;
    };
    /**
     * @param {?} shape
     * @return {?}
     */
    IccDrawMathService.getPolyFromArcShape = /**
     * @param {?} shape
     * @return {?}
     */
    function (shape) {
        var /** @type {?} */ circle = {};
        var /** @type {?} */ polygon = [];
        shape.s1 = shape.s1 || shape.width;
        polygon.push({ x: 0, y: shape.h1 + shape.h2 });
        polygon.push({ x: shape.s1, y: shape.h1 + shape.h2 });
        switch (shape.type) {
            case 'F':
                circle = this.getCircleRadius({ x: shape.s1, y: shape.h2 }, { x: shape.s1 / 2, y: 0 }, { x: 0, y: shape.h2 });
                polygon.push({ x: shape.s1, y: shape.h2 });
                polygon.push({ cr: circle.rx, x: shape.s1 / 2, y: 0 });
                polygon.push({ cr: circle.rx, x: 0, y: shape.h2 });
                break;
            case 'R':
                circle = this.getCircleRadius({ x: shape.s1, y: shape.h2 }, { x: 0, y: 0 }, { x: -shape.s1, y: shape.h2 });
                polygon.push({ x: shape.s1, y: shape.h2 });
                polygon.push({ cr: circle.rx, x: 0, y: 0 });
                break;
            case 'L':
                circle = this.getCircleRadius({ x: 0, y: shape.h2 }, { x: shape.s1, y: 0 }, { x: shape.s1 * 2, y: shape.h2 });
                polygon.push({ x: shape.s1, y: 0 });
                polygon.push({ cr: circle.rx, x: 0, y: shape.h2 });
                break;
        }
        if (!shape.h1) {
            polygon.unshift(polygon.pop());
        }
        return polygon;
    };
    /**
     * @param {?} oldPolygon
     * @param {?} shift
     * @return {?}
     */
    IccDrawMathService.getPolyShift = /**
     * @param {?} oldPolygon
     * @param {?} shift
     * @return {?}
     */
    function (oldPolygon, shift) {
        var _this = this;
        var /** @type {?} */ newLines = [];
        var /** @type {?} */ newPolygon = [];
        for (var /** @type {?} */ curr = 0, /** @type {?} */ next = 1; curr < oldPolygon.length; ++curr, ++next, next %= oldPolygon.length) {
            var /** @type {?} */ oldLine = [oldPolygon[curr], oldPolygon[next]];
            var /** @type {?} */ newLine = this.getLineShift(oldLine, Array.isArray(shift) ? shift[curr] : shift);
            newLines.push(newLine);
        }
        for (var /** @type {?} */ curr = 0, /** @type {?} */ prev = oldPolygon.length - 1; curr < oldPolygon.length; ++curr, ++prev, prev %= oldPolygon.length) {
            var /** @type {?} */ intersection = this.getLinesIntersection(newLines[prev], newLines[curr]);
            newPolygon.push(intersection);
        }
        var /** @type {?} */ newRect = this.getRectFromPoly(newPolygon);
        var /** @type {?} */ top, /** @type {?} */ left, /** @type {?} */ right, /** @type {?} */ bottom;
        for (var /** @type {?} */ curr = 0, /** @type {?} */ next = 1; curr < newPolygon.length; ++curr, ++next, next %= newPolygon.length) {
            var /** @type {?} */ info = this.getLineInfo([newPolygon[curr], newPolygon[next]]);
            switch (info.angle) {
                case 0:
                    bottom = newPolygon[curr].y;
                    break;
                case 1:
                    top = newPolygon[curr].y;
                    break;
                case 0.5:
                    left = newPolygon[curr].x;
                    break;
                case 1.5:
                    right = newPolygon[curr].x;
                    break;
            }
        }
        for (var /** @type {?} */ curr = 0, /** @type {?} */ next = 1; curr < newPolygon.length; ++curr, ++next, next %= newPolygon.length) {
            newPolygon[curr].x = Math.max(newPolygon[curr].x, left || newRect.x);
            newPolygon[curr].x = Math.min(newPolygon[curr].x, right || newRect.x + newRect.width);
            newPolygon[curr].y = Math.max(newPolygon[curr].y, top || newRect.y);
            newPolygon[curr].y = Math.min(newPolygon[curr].y, bottom || newRect.y + newRect.height);
        }
        return newPolygon.filter(function (o, i, s) {
            return s.findIndex(function (t) { return _this.round(t.x) === _this.round(o.x) && _this.round(t.y) === _this.round(o.y); }) === i;
        });
    };
    /**
     * @param {?} outerPoly
     * @param {?} innerPoly
     * @param {?=} jointAngle
     * @return {?}
     */
    IccDrawMathService.getPolygons = /**
     * @param {?} outerPoly
     * @param {?} innerPoly
     * @param {?=} jointAngle
     * @return {?}
     */
    function (outerPoly, innerPoly, jointAngle) {
        if (jointAngle === void 0) { jointAngle = []; }
        var /** @type {?} */ joints = [];
        var /** @type {?} */ polygons = [];
        var /** @type {?} */ arcs = 0;
        var /** @type {?} */ length = innerPoly.length;
        for (var /** @type {?} */ a = length - 1, /** @type {?} */ b = 0, /** @type {?} */ c = 1; b < length; ++a, ++b, ++c, a %= length, c %= length) {
            joints[b] = null;
            if (jointAngle[b] === 'L') {
                joints[b] = IccDrawMathService.getLinesIntersection([innerPoly[a], innerPoly[b]], [outerPoly[b], outerPoly[c]]);
            }
            if (jointAngle[b] === 'R') {
                joints[b] = IccDrawMathService.getLinesIntersection([innerPoly[b], innerPoly[c]], [outerPoly[a], outerPoly[b]]);
            }
        }
        if (outerPoly.length !== length) {
            return [];
        }
        for (var /** @type {?} */ a = length - 1, /** @type {?} */ b = 0, /** @type {?} */ c = 1; b < length; ++a, ++b, ++c, a %= length, c %= length) {
            if (arcs % 2 === 1 && outerPoly[b].cr && outerPoly[c].cr) {
                polygons[polygons.length - 1].splice(2, 1, {
                    x: joints[c] && jointAngle[c] === 'R' ? joints[c].x : outerPoly[c].x,
                    y: joints[c] && jointAngle[c] === 'R' ? joints[c].y : outerPoly[c].y,
                    cr: outerPoly[c].cr,
                    cw: false,
                }, {
                    x: joints[c] && jointAngle[c] === 'L' ? joints[c].x : innerPoly[c].x,
                    y: joints[c] && jointAngle[c] === 'L' ? joints[c].y : innerPoly[c].y,
                }, {
                    x: joints[b] && jointAngle[b] === 'R' ? joints[b].x : innerPoly[b].x,
                    y: joints[b] && jointAngle[b] === 'R' ? joints[b].y : innerPoly[b].y,
                    cr: innerPoly[c].cr,
                    cw: true,
                });
            }
            else {
                polygons.push([
                    {
                        x: joints[b] && jointAngle[b] === 'L' ? joints[b].x : outerPoly[b].x,
                        y: joints[b] && jointAngle[b] === 'L' ? joints[b].y : outerPoly[b].y,
                    },
                    {
                        x: joints[c] && jointAngle[c] === 'R' ? joints[c].x : outerPoly[c].x,
                        y: joints[c] && jointAngle[c] === 'R' ? joints[c].y : outerPoly[c].y,
                        cr: outerPoly[c].cr,
                        cw: false,
                    },
                    {
                        x: joints[c] && jointAngle[c] === 'L' ? joints[c].x : innerPoly[c].x,
                        y: joints[c] && jointAngle[c] === 'L' ? joints[c].y : innerPoly[c].y,
                    },
                    {
                        x: joints[b] && jointAngle[b] === 'R' ? joints[b].x : innerPoly[b].x,
                        y: joints[b] && jointAngle[b] === 'R' ? joints[b].y : innerPoly[b].y,
                        cr: innerPoly[c].cr,
                        cw: true,
                    },
                ]);
            }
            arcs += outerPoly[c].cr ? 1 : 0;
        }
        return polygons;
    };
    /**
     * @param {?} poly
     * @return {?}
     */
    IccDrawMathService.getRectFromPoly = /**
     * @param {?} poly
     * @return {?}
     */
    function (poly) {
        var /** @type {?} */ minX = Math.min.apply(Math, poly.map(function (o) { return o.x; }));
        var /** @type {?} */ minY = Math.min.apply(Math, poly.map(function (o) { return o.y; }));
        var /** @type {?} */ maxX = Math.max.apply(Math, poly.map(function (o) { return o.x; }));
        var /** @type {?} */ maxY = Math.max.apply(Math, poly.map(function (o) { return o.y; }));
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY,
        };
    };
    /**
     * @param {?} rect
     * @param {?} shift
     * @return {?}
     */
    IccDrawMathService.getRectShift = /**
     * @param {?} rect
     * @param {?} shift
     * @return {?}
     */
    function (rect, shift) {
        return {
            x: rect.x + (Number(shift.left) || 0),
            y: rect.y + (Number(shift.top) || 0),
            width: rect.width - (Number(shift.left) || 0) - (Number(shift.right) || 0),
            height: rect.height - (Number(shift.top) || 0) - (Number(shift.bottom) || 0),
        };
    };
    /**
     * @param {?} outerRect
     * @param {?} innerRect
     * @param {?=} side
     * @return {?}
     */
    IccDrawMathService.getRelativePosition = /**
     * @param {?} outerRect
     * @param {?} innerRect
     * @param {?=} side
     * @return {?}
     */
    function (outerRect, innerRect, side) {
        var _this = this;
        var /** @type {?} */ position = {};
        var /** @type {?} */ relative = {};
        position.top = (innerRect.y - outerRect.y) * 100 / (outerRect.height - outerRect.y);
        position.left = (innerRect.x - outerRect.x) * 100 / (outerRect.width - outerRect.x);
        position.right = 100 - position.left - ((innerRect.width - outerRect.x) * 100 / (outerRect.width - outerRect.x));
        position.bottom = 100 - position.top - ((innerRect.height - outerRect.y) * 100 / (outerRect.height - outerRect.y));
        Object.keys(position).map(function (key) {
            relative[key] = _this.round(position[key]) + "%";
        });
        if (side === 'outer') {
            relative = {
                top: relative.top,
                left: relative.right,
                right: relative.left,
                bottom: relative.bottom,
            };
        }
        return relative;
    };
    /**
     * @param {?} line
     * @param {?} poly
     * @return {?}
     */
    IccDrawMathService.intersectLineWithPoly = /**
     * @param {?} line
     * @param {?} poly
     * @return {?}
     */
    function (line, poly) {
        var /** @type {?} */ rect = this.getRectFromPoly(poly);
        for (var /** @type {?} */ curr = 0, /** @type {?} */ next = 1; curr < poly.length; curr++, next++, next %= poly.length) {
            var /** @type {?} */ intersection = this.getLinesIntersection(line, [poly[curr], poly[next]]);
            if (Number.isFinite(intersection.x) && Number.isFinite(intersection.y)
                && rect.y <= intersection.y && intersection.y <= rect.y + rect.height) {
                var /** @type {?} */ info = this.getLineInfo([poly[curr], poly[next]]);
                var /** @type {?} */ info0 = this.getLineInfo([poly[curr], line[0]]);
                var /** @type {?} */ info1 = this.getLineInfo([poly[curr], line[1]]);
                if ((2 + info0.angle - info.angle) % 2 < 1) {
                    line[0] = intersection;
                }
                if ((2 + info1.angle - info.angle) % 2 < 1) {
                    line[1] = intersection;
                }
            }
        }
        return line;
    };
    /**
     * @param {?} poly
     * @param {?} line
     * @param {?} side
     * @return {?}
     */
    IccDrawMathService.intersectPolyWithLine = /**
     * @param {?} poly
     * @param {?} line
     * @param {?} side
     * @return {?}
     */
    function (poly, line, side) {
        var _this = this;
        var /** @type {?} */ polygon = [];
        for (var /** @type {?} */ curr = 0, /** @type {?} */ next = 1; curr < poly.length; curr++, next++, next %= poly.length) {
            var /** @type {?} */ isInside = [];
            switch (side) {
                case 'top':
                    isInside[0] = poly[curr].y <= line[0].y;
                    isInside[1] = poly[next].y <= line[0].y;
                    break;
                case 'left':
                    isInside[0] = poly[curr].x <= line[0].x;
                    isInside[1] = poly[next].x <= line[0].x;
                    break;
                case 'right':
                    isInside[0] = poly[curr].x >= line[0].x;
                    isInside[1] = poly[next].x >= line[0].x;
                    break;
                case 'bottom':
                    isInside[0] = poly[curr].y >= line[0].y;
                    isInside[1] = poly[next].y >= line[0].y;
                    break;
            }
            if (isInside[0] && isInside[1]) {
                polygon.push(poly[curr]);
                polygon.push(poly[next]);
            }
            if (isInside[0] && !isInside[1]) {
                polygon.push(poly[curr]);
                polygon.push(this.getLinesIntersection([poly[curr], poly[next]], line));
            }
            if (!isInside[0] && isInside[1]) {
                polygon.push(this.getLinesIntersection(line, [poly[curr], poly[next]]));
                polygon.push(poly[next]);
            }
        }
        polygon = polygon.filter(function (o, i, s) { return s.findIndex(function (t) { return _this.round(t.x) === _this.round(o.x) && _this.round(t.y) === _this.round(o.y); }) === i; });
        return polygon;
    };
    /**
     * @param {?} poly
     * @param {?} rect
     * @return {?}
     */
    IccDrawMathService.intersectPolyWithRect = /**
     * @param {?} poly
     * @param {?} rect
     * @return {?}
     */
    function (poly, rect) {
        rect = this.getPolyFromRect(rect);
        poly = this.intersectPolyWithLine(poly, [rect[0], rect[1]], 'right');
        poly = this.intersectPolyWithLine(poly, [rect[1], rect[2]], 'top');
        poly = this.intersectPolyWithLine(poly, [rect[2], rect[3]], 'left');
        poly = this.intersectPolyWithLine(poly, [rect[3], rect[0]], 'bottom');
        poly = this.sortPoly(poly);
        return poly;
    };
    /**
     * @param {?} poly
     * @param {?} center
     * @param {?} angle
     * @return {?}
     */
    IccDrawMathService.rotatePoly = /**
     * @param {?} poly
     * @param {?} center
     * @param {?} angle
     * @return {?}
     */
    function (poly, center, angle) {
        var /** @type {?} */ cos = Math.cos(angle * Math.PI);
        var /** @type {?} */ sin = Math.sin(angle * Math.PI);
        poly = poly.map(function (point) {
            return {
                x: cos * (point.x - center.x) - sin * (point.y - center.y) + center.x,
                y: sin * (point.x - center.x) + cos * (point.y - center.y) + center.y,
            };
        });
        return poly;
    };
    /**
     * @param {?} poly
     * @return {?}
     */
    IccDrawMathService.sortPoly = /**
     * @param {?} poly
     * @return {?}
     */
    function (poly) {
        var /** @type {?} */ min = Math.min.apply(Math, poly.map(function (o) { return o.x; }));
        for (var /** @type {?} */ curr = 0, /** @type {?} */ next = 1; curr < poly.length; curr++, next++, next %= poly.length) {
            if (curr > 0 && poly[curr].x === min && poly[next].x > min) {
                poly.push.apply(poly, poly.splice(0, curr));
                break;
            }
        }
        return poly;
    };
    /**
     * @param {?} value
     * @param {?=} decimal
     * @return {?}
     */
    IccDrawMathService.round = /**
     * @param {?} value
     * @param {?=} decimal
     * @return {?}
     */
    function (value, decimal) {
        if (decimal === void 0) { decimal = 2; }
        value = Math.round(value * Math.pow(10, decimal)) / Math.pow(10, decimal);
        return value;
    };
    return IccDrawMathService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var IccDrawDimensionsService = (function () {
    function IccDrawDimensionsService() {
    }
    /**
     * @param {?} details
     * @return {?}
     */
    IccDrawDimensionsService.getBreakpoints = /**
     * @param {?} details
     * @return {?}
     */
    function (details) {
        var /** @type {?} */ breakpoints = {
            horizontal: [
                details.y || 0,
                details.height || 0,
            ],
            vertical: [
                details.x || 0,
                details.width || 0,
            ],
        };
        for (var _i = 0, _a = details.mullions || []; _i < _a.length; _i++) {
            var mullion = _a[_i];
            breakpoints[mullion.direction].push(mullion.position);
        }
        
        for (var _b = 0, _c = details.sashes || []; _b < _c.length; _b++) {
            var sash = _c[_b];
            for (var _d = 0, _e = sash.intMullions || []; _d < _e.length; _d++) {
                var mullion = _e[_d];
                breakpoints[mullion.direction].push((mullion.direction === 'vertical' ? sash.x : sash.y) + mullion.position);
            }
            
        }
        
        for (var _f = 0, _g = ['horizontal', 'vertical']; _f < _g.length; _f++) {
            var direction = _g[_f];
            breakpoints[direction] = breakpoints[direction].filter(function (v, i, a) { return a.indexOf(v) === i; }).sort(function (a, b) { return a - b; });
        }
        return breakpoints;
    };
    /**
     * @param {?} details
     * @param {?} node
     * @param {?} options
     * @return {?}
     */
    IccDrawDimensionsService.getDimensions = /**
     * @param {?} details
     * @param {?} node
     * @param {?} options
     * @return {?}
     */
    function (details, node, options) {
        var /** @type {?} */ dimensions = {
            horizontal: [],
            vertical: [],
        };
        var /** @type {?} */ breakpoints = this.getBreakpoints(details);
        if (options.type === 'extended') {
            for (var _i = 0, _a = ['horizontal', 'vertical']; _i < _a.length; _i++) {
                var direction = _a[_i];
                for (var /** @type {?} */ i = 0; i < breakpoints[direction].length - 1; i++) {
                    dimensions[direction].push({
                        id: i,
                        letter: null,
                        major: [],
                        minor: [],
                        sashes: [],
                        start: breakpoints[direction][i],
                        stop: breakpoints[direction][i + 1],
                    });
                }
            }
            this.getDetailsData(dimensions, details);
            this.getNodeData(dimensions, node);
        }
        else if (options.type === 'outer') {
            dimensions.horizontal.push({
                major: [node.rect.x, node.rect.x + node.rect.width],
                minor: [node.rect.x, node.rect.x + node.rect.width].concat(breakpoints.vertical),
            });
            dimensions.vertical.push({
                major: [node.rect.y, node.rect.y + node.rect.height],
                minor: [node.rect.y, node.rect.y + node.rect.height].concat(breakpoints.horizontal),
            });
        }
        else {
            dimensions.horizontal.push({
                major: [details.x || 0, details.width || 0],
                minor: breakpoints.vertical,
            });
            dimensions.vertical.push({
                major: [details.y || 0, details.height || 0],
                minor: breakpoints.horizontal,
            });
        }
        for (var _b = 0, _c = ['horizontal', 'vertical']; _b < _c.length; _b++) {
            var direction = _c[_b];
            for (var _d = 0, _e = dimensions[direction]; _d < _e.length; _d++) {
                var dimension = _e[_d];
                dimension.major = dimension.major.map(Math.round).filter(function (v, i, a) { return a.indexOf(v) === i; }).sort(function (a, b) { return a - b; });
                dimension.minor = dimension.minor.map(Math.round).filter(function (v, i, a) { return a.indexOf(v) === i; }).sort(function (a, b) { return a - b; });
            }
        }
        this.getLetters(dimensions);
        return dimensions;
    };
    /**
     * @param {?} dimensions
     * @param {?} details
     * @return {?}
     */
    IccDrawDimensionsService.getDetailsData = /**
     * @param {?} dimensions
     * @param {?} details
     * @return {?}
     */
    function (dimensions, details) {
        var _loop_1 = function (sash) {
            dimensions.horizontal.filter(function (o) {
                return (sash.y <= o.start && o.start < sash.y + sash.height)
                    || (sash.y < o.stop && o.stop <= sash.y + sash.height);
            }).map(function (dimension) {
                dimension.sashes.push(sash.id);
                dimension.major.push(sash.x, sash.x + sash.width);
            });
            dimensions.vertical.filter(function (o) {
                return (sash.x <= o.start && o.start < sash.x + sash.width)
                    || (sash.x < o.stop && o.stop <= sash.x + sash.width);
            }).map(function (dimension) {
                dimension.sashes.push(sash.id);
                dimension.major.push(sash.y, sash.y + sash.height);
            });
            var _loop_2 = function (intSash) {
                dimensions.horizontal.filter(function (o) {
                    return (sash.y + intSash.y <= o.start && o.start < sash.y + intSash.y + intSash.height)
                        || (sash.y + intSash.y < o.stop && o.stop <= sash.y + intSash.y + intSash.height);
                }).map(function (dimension) {
                    dimension.sashes.push(intSash.id);
                });
                dimensions.vertical.filter(function (o) {
                    return (sash.x + intSash.x <= o.start && o.start < sash.x + intSash.x + intSash.width)
                        || (sash.x + intSash.x < o.stop && o.stop <= sash.x + intSash.x + intSash.width);
                }).map(function (dimension) {
                    dimension.sashes.push(intSash.id);
                });
            };
            for (var _i = 0, _a = sash.intSashes || []; _i < _a.length; _i++) {
                var intSash = _a[_i];
                _loop_2(intSash);
            }
        };
        for (var _i = 0, _a = details.sashes || []; _i < _a.length; _i++) {
            var sash = _a[_i];
            _loop_1(sash);
        }
    };
    /**
     * @param {?} dimensions
     * @param {?} node
     * @param {?} options
     * @return {?}
     */
    IccDrawDimensionsService.getElements = /**
     * @param {?} dimensions
     * @param {?} node
     * @param {?} options
     * @return {?}
     */
    function (dimensions, node, options) {
        var /** @type {?} */ elements = [];
        var /** @type {?} */ letters = {
            horizontal: [],
            vertical: [],
        };
        for (var _i = 0, _a = ['horizontal', 'vertical']; _i < _a.length; _i++) {
            var direction = _a[_i];
            for (var _b = 0, _c = dimensions[direction]; _b < _c.length; _b++) {
                var dimension = _c[_b];
                if (options.type === 'extended') {
                    elements.push({
                        class: [direction, 'letter', 'center'],
                        innerHtml: dimension.letter,
                        style: direction === 'horizontal' ? {
                            top: this.getRelative(dimension.start, node.rect.y, node.rect.height, false),
                            bottom: this.getRelative(dimension.stop, node.rect.y, node.rect.height, true),
                            left: "-30px",
                            width: "20px",
                        } : {
                            left: this.getRelative(dimension.start, node.rect.x, node.rect.width, false),
                            right: this.getRelative(dimension.stop, node.rect.x, node.rect.width, true),
                            top: "-30px",
                            height: "20px",
                        },
                    });
                }
                if (letters[direction].indexOf(dimension.letter) === -1) {
                    letters[direction].push(dimension.letter);
                    if (options.type === 'extended') {
                        elements.push({
                            class: [direction, 'letter', 'center'],
                            innerHtml: dimension.letter,
                            style: direction === 'horizontal' ? {
                                bottom: "-" + 50 * letters[direction].length + "px",
                                left: "-30px",
                                width: "20px",
                                height: "40px",
                            } : {
                                right: "-" + 70 * letters[direction].length + "px",
                                top: "-30px",
                                width: "60px",
                                height: "20px",
                            },
                        });
                    }
                    for (var _d = 0, _e = ['major', 'minor']; _d < _e.length; _d++) {
                        var type = _e[_d];
                        for (var /** @type {?} */ i = 0, /** @type {?} */ j = 1; i < dimension[type].length; i++, j++) {
                            if (j < dimension[type].length) {
                                elements.push({
                                    class: [direction, type, 'center'],
                                    innerHtml: IccDrawMathService.round((dimension[type][j] - dimension[type][i]) / (options.ratio || 1), 2),
                                    style: direction === 'horizontal' ? {
                                        bottom: "-" + (50 * letters[direction].length - (type === 'major' ? 0 : 20)) + "px",
                                        left: this.getRelative(dimension[type][i], node.rect.x, node.rect.width, false),
                                        right: this.getRelative(dimension[type][j], node.rect.x, node.rect.width, true),
                                        height: "20px",
                                    } : {
                                        right: "-" + (70 * letters[direction].length - (type === 'major' ? 0 : 30)) + "px",
                                        top: this.getRelative(dimension[type][i], node.rect.y, node.rect.height, false),
                                        bottom: this.getRelative(dimension[type][j], node.rect.y, node.rect.height, true),
                                        width: "30px",
                                    },
                                });
                            }
                            elements.push({
                                class: [direction, type, 'line'],
                                style: direction === 'horizontal' ? {
                                    bottom: "-" + (50 * letters[direction].length - (type === 'major' ? 15 : 20)) + "px",
                                    left: this.getRelative(dimension[type][i], node.rect.x, node.rect.width, false),
                                    right: this.getRelative(dimension[type][j], node.rect.x, node.rect.width, true),
                                    height: "5px",
                                } : {
                                    right: "-" + (70 * letters[direction].length - (type === 'major' ? 25 : 30)) + "px",
                                    top: this.getRelative(dimension[type][i], node.rect.y, node.rect.height, false),
                                    bottom: this.getRelative(dimension[type][j], node.rect.y, node.rect.height, true),
                                    width: "5px",
                                },
                            });
                        }
                    }
                }
            }
        }
        return elements;
    };
    /**
     * @param {?} dimensions
     * @return {?}
     */
    IccDrawDimensionsService.getLetters = /**
     * @param {?} dimensions
     * @return {?}
     */
    function (dimensions) {
        var /** @type {?} */ letter = 'A';
        for (var _i = 0, _a = ['vertical', 'horizontal']; _i < _a.length; _i++) {
            var direction = _a[_i];
            for (var _b = 0, _c = dimensions[direction]; _b < _c.length; _b++) {
                var d1 = _c[_b];
                var _loop_3 = function (d2) {
                    if (d1.id > d2.id
                        && d1.major.length === d2.major.length && d1.major.every(function (v, i) { return v === d2.major[i]; })
                        && d1.minor.length === d2.minor.length && d1.minor.every(function (v, i) { return v === d2.minor[i]; })) {
                        d1.letter = d2.letter;
                        return "break";
                    }
                };
                for (var _d = 0, _e = dimensions[direction]; _d < _e.length; _d++) {
                    var d2 = _e[_d];
                    var state_1 = _loop_3(d2);
                    if (state_1 === "break")
                        break;
                }
                if (!d1.letter) {
                    d1.letter = letter;
                    letter = String.fromCharCode(letter.charCodeAt(0) + 1);
                }
            }
        }
    };
    /**
     * @param {?} dimensions
     * @param {?} node
     * @return {?}
     */
    IccDrawDimensionsService.getNodeData = /**
     * @param {?} dimensions
     * @param {?} node
     * @return {?}
     */
    function (dimensions, node) {
        var _this = this;
        var /** @type {?} */ functionName = node.constructor.name ? "get" + node.constructor.name + "Data" : null;
        if (functionName && typeof this[functionName] === 'function') {
            this[functionName](dimensions, node);
        }
        if (node.children && node.children.length) {
            node.children.map(function (child) { return _this.getNodeData(dimensions, child); });
        }
    };
    /**
     * @param {?} dimensions
     * @param {?} node
     * @return {?}
     */
    IccDrawDimensionsService.getBaseNodeData = /**
     * @param {?} dimensions
     * @param {?} node
     * @return {?}
     */
    function (dimensions, node) {
        dimensions.horizontal.map(function (dimension) {
            dimension.major.push(node.rect.x, node.rect.x + node.rect.width);
            dimension.minor.push(node.rect.x, node.rect.x + node.rect.width);
        });
        dimensions.vertical.map(function (dimension) {
            dimension.major.push(node.rect.y, node.rect.y + node.rect.height);
            dimension.minor.push(node.rect.y, node.rect.y + node.rect.height);
        });
    };
    /**
     * @param {?} dimensions
     * @param {?} node
     * @return {?}
     */
    IccDrawDimensionsService.getShapeNodeData = /**
     * @param {?} dimensions
     * @param {?} node
     * @return {?}
     */
    function (dimensions, node) {
        dimensions.horizontal.map(function (dimension) {
            dimension.major.push(node.rect.x, node.rect.x + node.rect.width);
            dimension.minor.push(node.rect.x, node.rect.x + node.rect.width);
        });
        dimensions.vertical.map(function (dimension) {
            dimension.major.push(node.rect.y, node.rect.y + node.rect.height);
            dimension.minor.push(node.rect.y, node.rect.y + node.rect.height);
        });
    };
    /**
     * @param {?} dimensions
     * @param {?} node
     * @return {?}
     */
    IccDrawDimensionsService.getAlignmentNodeData = /**
     * @param {?} dimensions
     * @param {?} node
     * @return {?}
     */
    function (dimensions, node) {
        dimensions.horizontal.filter(function (o) {
            return (o.start <= node.rect.y && node.rect.y < o.stop)
                || (o.start < node.rect.y + node.rect.height && node.rect.y + node.rect.height <= o.stop);
        }).map(function (dimension) {
            dimension.minor.push(node.rect.x, node.rect.x + node.rect.width);
        });
        dimensions.vertical.filter(function (o) {
            return (o.start <= node.rect.x && node.rect.x < o.stop)
                || (o.start < node.rect.x + node.rect.width && node.rect.x + node.rect.width <= o.stop);
        }).map(function (dimension) {
            dimension.minor.push(node.rect.y, node.rect.y + node.rect.height);
        });
    };
    /**
     * @param {?} dimensions
     * @param {?} node
     * @return {?}
     */
    IccDrawDimensionsService.getExtensionsNodeData = /**
     * @param {?} dimensions
     * @param {?} node
     * @return {?}
     */
    function (dimensions, node) {
        node.extensions.map(function (extension) {
            dimensions.horizontal.map(function (dimension) {
                dimension.minor.push(extension.rect.x, extension.rect.x + extension.rect.width);
            });
            dimensions.vertical.map(function (dimension) {
                dimension.minor.push(extension.rect.y, extension.rect.y + extension.rect.height);
            });
        });
    };
    /**
     * @param {?} dimensions
     * @param {?} node
     * @return {?}
     */
    IccDrawDimensionsService.getFrameNodeData = /**
     * @param {?} dimensions
     * @param {?} node
     * @return {?}
     */
    function (dimensions, node) {
        dimensions.horizontal.map(function (dimension) {
            (_a = dimension.minor).push.apply(_a, node.poly.map(function (o) { return o.x; }));
            var _a;
        });
        dimensions.vertical.map(function (dimension) {
            (_a = dimension.minor).push.apply(_a, node.poly.map(function (o) { return o.y; }));
            var _a;
        });
    };
    /**
     * @param {?} dimensions
     * @param {?} node
     * @return {?}
     */
    IccDrawDimensionsService.getSashFrameNodeData = /**
     * @param {?} dimensions
     * @param {?} node
     * @return {?}
     */
    function (dimensions, node) {
        dimensions.horizontal.filter(function (o) { return o.sashes.some(function (e) { return e === node.sash.id; }); }).map(function (dimension) {
            (_a = dimension.minor).push.apply(_a, node.poly.map(function (o) { return o.x; }));
            var _a;
        });
        dimensions.vertical.filter(function (o) { return o.sashes.some(function (e) { return e === node.sash.id; }); }).map(function (dimension) {
            (_a = dimension.minor).push.apply(_a, node.poly.map(function (o) { return o.y; }));
            var _a;
        });
    };
    /**
     * @param {?} dimensions
     * @param {?} node
     * @return {?}
     */
    IccDrawDimensionsService.getGlazingBeadNodeData = /**
     * @param {?} dimensions
     * @param {?} node
     * @return {?}
     */
    function (dimensions, node) {
        dimensions.horizontal.filter(function (o) { return o.sashes.some(function (e) { return e === node.sash.id; }); }).map(function (dimension) {
            (_a = dimension.minor).push.apply(_a, node.poly.map(function (o) { return o.x; }));
            var _a;
        });
        dimensions.vertical.filter(function (o) { return o.sashes.some(function (e) { return e === node.sash.id; }); }).map(function (dimension) {
            (_a = dimension.minor).push.apply(_a, node.poly.map(function (o) { return o.y; }));
            var _a;
        });
    };
    /**
     * @param {?} dimensions
     * @param {?} node
     * @return {?}
     */
    IccDrawDimensionsService.getMullionNodeData = /**
     * @param {?} dimensions
     * @param {?} node
     * @return {?}
     */
    function (dimensions, node) {
        dimensions.horizontal.map(function (dimension) {
            if (node.rect.y <= dimension.stop && node.rect.y + node.rect.height >= dimension.start) {
                dimension.minor.push(node.rect.x, node.rect.x + node.rect.width);
            }
        });
        dimensions.vertical.map(function (dimension) {
            if (node.rect.x <= dimension.stop && node.rect.x + node.rect.width >= dimension.start) {
                dimension.minor.push(node.rect.y, node.rect.y + node.rect.height);
            }
        });
    };
    /**
     * @param {?} dimensions
     * @param {?} node
     * @return {?}
     */
    IccDrawDimensionsService.getMuntinNodeData = /**
     * @param {?} dimensions
     * @param {?} node
     * @return {?}
     */
    function (dimensions, node) {
        var /** @type {?} */ direction, /** @type {?} */ position;
        if (node.muntin.start.x === node.muntin.end.x) {
            direction = 'horizontal';
            position = node.poly[0].x;
        }
        if (node.muntin.start.y === node.muntin.end.y) {
            direction = 'vertical';
            position = node.poly[0].y;
        }
        if (direction && position) {
            dimensions[direction].filter(function (o) { return o.sashes.some(function (e) { return e === node.sash.id; }); }).map(function (dimension) {
                dimension.minor.push(Math.round(position - node.size / 2));
                dimension.minor.push(Math.round(position + node.size / 2));
            });
        }
    };
    /**
     * @param {?} dimensions
     * @param {?} node
     * @return {?}
     */
    IccDrawDimensionsService.getRensonNodeData = /**
     * @param {?} dimensions
     * @param {?} node
     * @return {?}
     */
    function (dimensions, node) {
        dimensions.vertical.filter(function (o) { return o.sashes.some(function (e) { return e === node.sash.id; }); }).map(function (dimension) {
            dimension.minor.push(node.rect.y + node.rect.height);
        });
    };
    /**
     * @param {?} position
     * @param {?} rectPosition
     * @param {?} rectLength
     * @param {?} reverse
     * @return {?}
     */
    IccDrawDimensionsService.getRelative = /**
     * @param {?} position
     * @param {?} rectPosition
     * @param {?} rectLength
     * @param {?} reverse
     * @return {?}
     */
    function (position, rectPosition, rectLength, reverse) {
        position = (position - rectPosition) / rectLength;
        return Math.round((reverse ? 1 - position : position) * 1e4) / 1e2 + "%";
    };
    return IccDrawDimensionsService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var IccDrawDimensionsComponent = (function () {
    function IccDrawDimensionsComponent() {
        this.dimensions = {};
        this.elements = [];
        this.margins = {};
        this.timestamp = 0;
    }
    /**
     * @return {?}
     */
    IccDrawDimensionsComponent.prototype.ngDoCheck = /**
     * @return {?}
     */
    function () {
        if (this.details && this.details.timestamp !== this.timestamp) {
            this.timestamp = this.details.timestamp;
            this.dimensions = {};
            this.elements = [];
            if (this.options && this.options.type === 'extended') {
                this.dimensions = IccDrawDimensionsService.getDimensions(this.details, this.node, this.options);
                this.elements = IccDrawDimensionsService.getElements(this.dimensions, this.node, this.options);
            }
            this.margins = this.getMargins();
        }
    };
    /**
     * @return {?}
     */
    IccDrawDimensionsComponent.prototype.getMargins = /**
     * @return {?}
     */
    function () {
        if (this.elements && this.elements.length) {
            var /** @type {?} */ marginTop = this.options && this.options.type === 'extended' ? "30px" : "0";
            var /** @type {?} */ marginLeft = this.options && this.options.type === 'extended' ? "30px" : "0";
            var /** @type {?} */ marginRight = this.dimensions.vertical.reduce(function (r, o) { return r.indexOf(o.letter) !== -1 ? r : r.concat(o.letter); }, []).length * 70 + "px";
            var /** @type {?} */ marginBottom = this.dimensions.horizontal.reduce(function (r, o) { return r.indexOf(o.letter) !== -1 ? r : r.concat(o.letter); }, []).length * 50 + "px";
            return {
                margin: marginTop + " " + marginRight + " " + marginBottom + " " + marginLeft,
            };
        }
        else {
            return {};
        }
    };
    IccDrawDimensionsComponent.decorators = [
        { type: Component, args: [{
                    selector: 'icc-draw-dimensions',
                    styles: [":host * { box-sizing: border-box; margin: 0; padding: 0; } .icc-draw-dimensions { color: #000; font: 400 14px/1em Arial; } .icc-draw-dimensions .center { display: -webkit-box; display: -webkit-flex; display: flex; -webkit-box-orient: vertical; -webkit-box-pack: center; align-items: center; justify-content: center; } .icc-draw-dimensions .horizontal, .icc-draw-dimensions .vertical { /* background: rgba(255,0,0,0.1); */ position: absolute; } .icc-draw-dimensions .letter { font-weight: 700; } .icc-draw-dimensions .major.line.horizontal { border-left: 1px solid #000; } .icc-draw-dimensions .minor.line.horizontal { border-left: 1px solid #000; border-bottom: 1px solid #000; } .icc-draw-dimensions .major.line.vertical { border-top: 1px solid #000; } .icc-draw-dimensions .minor.line.vertical { border-top: 1px solid #000; border-right: 1px solid #000; } .icc-draw-dimensions .major.center { font-size: 0.8em; font-weight: 700; } .icc-draw-dimensions .minor.center { font-size: 0.6em; } .icc-draw-dimensions .major.center.horizontal { align-items: flex-end; } .icc-draw-dimensions .minor.center.horizontal { align-items: flex-start; } "],
                    template: "<div class=\"icc-draw-dimensions\"> <div *ngFor=\"let element of elements\" [ngClass]=\"element.class\" [ngStyle]=\"element.style\" [innerHTML]=\"element.innerHtml ? element.innerHtml : ''\" ></div> </div> ",
                },] },
    ];
    /** @nocollapse */
    IccDrawDimensionsComponent.ctorParameters = function () { return []; };
    IccDrawDimensionsComponent.propDecorators = {
        "details": [{ type: Input },],
        "node": [{ type: Input },],
        "options": [{ type: Input },],
    };
    return IccDrawDimensionsComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var InterfaceButton = (function () {
    function InterfaceButton(params) {
        Object.assign(this, params);
    }
    return InterfaceButton;
}());
var InterfaceGroup = (function () {
    function InterfaceGroup(params) {
        this.buttons = [];
        this.fields = [];
        Object.assign(this, params);
    }
    return InterfaceGroup;
}());
var IccDrawInterfaceService = (function () {
    function IccDrawInterfaceService() {
    }
    /**
     * @param {?} groups
     * @param {?} node
     * @return {?}
     */
    IccDrawInterfaceService.getInterfaceGroups = /**
     * @param {?} groups
     * @param {?} node
     * @return {?}
     */
    function (groups, node) {
        var _this = this;
        if (node.options && node.options.buttons && node.options.buttons.length) {
            this.getInterfaceGroup(groups, node, node.options.buttons);
        }
        if (node.children && node.children.length) {
            node.children.map(function (child) { return _this.getInterfaceGroups(groups, child); });
        }
        if (groups.length) {
            groups.map(function (group) {
                group.buttons.map(function (button) {
                    if (button.uuid && button.uuid !== 'move' && !groups.some(function (e) { return e.uuid === button.uuid; })) {
                        group.buttons.splice(group.buttons.indexOf(button), 1);
                    }
                });
            });
        }
    };
    /**
     * @param {?} groups
     * @param {?} node
     * @param {?} buttons
     * @param {?=} rect
     * @param {?=} uuid
     * @return {?}
     */
    IccDrawInterfaceService.getInterfaceGroup = /**
     * @param {?} groups
     * @param {?} node
     * @param {?} buttons
     * @param {?=} rect
     * @param {?=} uuid
     * @return {?}
     */
    function (groups, node, buttons, rect, uuid) {
        var _this = this;
        var /** @type {?} */ positions = {
            top: [],
            left: [],
            right: [],
            bottom: [],
            center: [],
            rect: [],
        };
        buttons.map(function (button) {
            var /** @type {?} */ interfaceButton = new InterfaceButton({
                class: button.class,
                innerHtml: button.innerHtml,
                onClick: button.onClick,
                onMove: button.onMove,
                title: button.title,
            });
            if (button.onMove) {
                interfaceButton.uuid = 'move';
            }
            if (button.buttons && button.buttons.length) {
                interfaceButton.uuid = node.getUUID();
                if (button.fields === 'muntins') {
                    _this.getMuntinsFields(node).map(function (field) {
                        _this.getInterfaceGroup(groups, node, button.buttons, field, interfaceButton.uuid);
                    });
                }
                else {
                    _this.getInterfaceGroup(groups, node, button.buttons, rect, interfaceButton.uuid);
                }
            }
            if (button.positions && button.positions.length) {
                for (var _i = 0, _a = button.positions; _i < _a.length; _i++) {
                    var position = _a[_i];
                    if (!button.condition || button.condition(node.onClick({ index: position }))) {
                        positions[position].push(interfaceButton);
                    }
                }
            }
            else {
                if (!button.condition || button.condition(node.onClick({ index: 'center' }))) {
                    positions.center.push(interfaceButton);
                }
            }
        });
        Object.keys(positions).map(function (position) {
            if (positions[position] && positions[position].length) {
                var /** @type {?} */ interfaceGroup = new InterfaceGroup({
                    buttons: positions[position].map(function (button) { return Object.assign({}, button); }),
                    node: node,
                    rect: rect ? rect : node.poly ? IccDrawMathService.getRectFromPoly(node.poly) : null,
                    side: position,
                    uuid: uuid,
                });
                groups.push(interfaceGroup);
            }
        });
    };
    /**
     * @param {?} groups
     * @return {?}
     */
    IccDrawInterfaceService.setInterfaceGroups = /**
     * @param {?} groups
     * @return {?}
     */
    function (groups) {
        groups.map(function (group) {
            if (group.rect) {
                group.style = {};
                switch (group.side) {
                    case 'top':
                        group.gravity = { x: group.rect.x + group.rect.width / 2, y: group.rect.y };
                        group.style.marginLeft = -25 * group.buttons.length + "px";
                        group.style.height = "50px";
                        break;
                    case 'left':
                        group.gravity = { x: group.rect.x, y: group.rect.y + group.rect.height / 2 };
                        group.style.marginTop = -25 * group.buttons.length + "px";
                        group.style.width = "50px";
                        break;
                    case 'right':
                        group.gravity = { x: group.rect.x + group.rect.width, y: group.rect.y + group.rect.height / 2 };
                        group.style.marginTop = -25 * group.buttons.length + "px";
                        group.style.width = "50px";
                        break;
                    case 'bottom':
                        group.gravity = { x: group.rect.x + group.rect.width / 2, y: group.rect.y + group.rect.height - 60 };
                        group.style.marginLeft = -25 * group.buttons.length + "px";
                        group.style.height = "50px";
                        break;
                    case 'center':
                        group.gravity = { x: group.rect.x + group.rect.width / 2, y: group.rect.y + group.rect.height / 2 };
                        group.style.marginLeft = "-50px";
                        group.style.marginTop = "-50px";
                        group.style.width = "100px";
                        group.style.height = "100px";
                        break;
                    case 'rect':
                        group.style = IccDrawMathService.getRelativePosition(group.node.root.rect, group.rect);
                        break;
                }
                if (group.gravity) {
                    group.style.left = (group.gravity.x - group.node.root.rect.x) * 100 / group.node.root.rect.width + "%";
                    group.style.top = (group.gravity.y - group.node.root.rect.y) * 100 / group.node.root.rect.height + "%";
                }
            }
        });
    };
    /**
     * @param {?} node
     * @return {?}
     */
    IccDrawInterfaceService.getMuntinsFields = /**
     * @param {?} node
     * @return {?}
     */
    function (node) {
        var /** @type {?} */ fields = [];
        var /** @type {?} */ poly, /** @type {?} */ rect;
        // const nodeRect = node.rect;
        var /** @type {?} */ nodeRect = IccDrawMathService.getRectFromPoly(node.poly);
        var /** @type {?} */ muntinsH = node.parent.children.filter(function (node) { return node.muntin && node.rect.width && !node.rect.height; });
        var /** @type {?} */ muntinsV = node.parent.children.filter(function (node) { return node.muntin && !node.rect.width && node.rect.height; });
        var /** @type {?} */ breakpointsH = muntinsV.map(function (node) { return node.rect.x; }).concat(nodeRect.x, nodeRect.x + nodeRect.width).sort(function (a, b) { return a - b; });
        var /** @type {?} */ breakpointsV = muntinsH.map(function (node) { return node.rect.y; }).concat(nodeRect.y, nodeRect.y + nodeRect.height).sort(function (a, b) { return a - b; });
        var _loop_1 = function (indexV) {
            var /** @type {?} */ lastBreakpointH = breakpointsH[0];
            var _loop_2 = function (indexH) {
                if (muntinsV.some(function (node) {
                    return node.rect.x === breakpointsH[indexH + 1]
                        && node.rect.y < breakpointsV[indexV + 1]
                        && node.rect.y + node.rect.height > breakpointsV[indexV];
                }) || nodeRect.x + nodeRect.width === breakpointsH[indexH + 1]) {
                    rect = {
                        x: lastBreakpointH,
                        y: breakpointsV[indexV],
                        width: breakpointsH[indexH + 1] - lastBreakpointH,
                        height: breakpointsV[indexV + 1] - breakpointsV[indexV],
                    };
                    poly = IccDrawMathService.intersectPolyWithRect(node.poly, rect);
                    if (poly && poly.length) {
                        fields.push(IccDrawMathService.getRectFromPoly(poly));
                    }
                    lastBreakpointH = breakpointsH[indexH + 1];
                }
            };
            for (var /** @type {?} */ indexH = 0; indexH < breakpointsH.length - 1; indexH++) {
                _loop_2(indexH);
            }
        };
        for (var /** @type {?} */ indexV = 0; indexV < breakpointsV.length - 1; indexV++) {
            _loop_1(indexV);
        }
        return fields;
    };
    return IccDrawInterfaceService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var IccDrawInterfaceComponent = (function () {
    function IccDrawInterfaceComponent(renderer) {
        var _this = this;
        this.renderer = renderer;
        this.clicked = new EventEmitter();
        this.groups = [];
        this.move = {
            actions: {
                onClick: function () { },
                onMove: function () { },
            },
            direction: null,
            inputs: {
                next: 0,
                prev: 0,
                ratio: 1,
            },
            listeners: {
                mousemove: function () { },
                mouseup: function () { },
            },
            min: 0,
            max: 0,
            node: null,
            position: {
                curr: 0,
                min: 0,
                minGlass: 0,
                max: 0,
                maxGlass: 0,
                next: 0,
                node: 0,
                old: 0,
                prev: 0,
            },
            rect: {},
            shift: {
                next: 0,
                prev: 0,
            },
            style: {},
            update: function () {
                var /** @type {?} */ response = _this.move.node.onMove();
                var /** @type {?} */ fields = response.direction === 'vertical' ? ['x', 'width'] : ['y', 'height'];
                _this.move.direction = response.direction;
                _this.move.min = response.min || 0;
                _this.move.max = response.max || null;
                _this.move.position.minGlass = response.positionMin;
                _this.move.position.min = response.position - response.prev;
                _this.move.position.max = response.position + response.next;
                _this.move.position.maxGlass = response.positionMax;
                _this.move.position.node = response.position;
                _this.move.position.old = response.position;
                _this.move.rect = response.rect;
                if (_this.options.moveShift) {
                    _this.move.shift.next = response.rect[fields[0]] + response.rect[fields[1]] - response.shift[fields[0]] - response.shift[fields[1]];
                    _this.move.shift.prev = response.shift[fields[0]] - response.rect[fields[0]];
                }
                else {
                    _this.move.shift.next = 0;
                    _this.move.shift.prev = 0;
                }
                _this.updatePosition(response.position);
            },
        };
    }
    /**
     * @param {?} event
     * @return {?}
     */
    IccDrawInterfaceComponent.prototype.click = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (this.uuid) {
            this.move.node = null;
            this.uuid = undefined;
            this.clicked.next(true);
            this.interfaceClickHandler && this.interfaceClickHandler();
        }
    };
    /**
     * @return {?}
     */
    IccDrawInterfaceComponent.prototype.ngOnChanges = /**
     * @return {?}
     */
    function () {
        this.groups = [];
        IccDrawInterfaceService.getInterfaceGroups(this.groups, this.node);
        IccDrawInterfaceService.setInterfaceGroups(this.groups);
    };
    /**
     * @param {?} button
     * @param {?} group
     * @return {?}
     */
    IccDrawInterfaceComponent.prototype.onButtonClick = /**
     * @param {?} button
     * @param {?} group
     * @return {?}
     */
    function (button, group) {
        this.uuid = button.uuid;
        this.clicked.next(true);
        if (button.onMove) {
            this.move.actions.onClick = button.onClick;
            this.move.actions.onMove = button.onMove;
            this.move.node = group.node;
            this.move.update();
        }
        else if (button.onClick) {
            button.onClick(group.node.onClick({ index: group.side, rect: group.rect }));
        }
        this.interfaceClickHandler && this.interfaceClickHandler();
    };
    /**
     * @return {?}
     */
    IccDrawInterfaceComponent.prototype.onChangeNext = /**
     * @return {?}
     */
    function () {
        this.move.inputs.next = parseFloat(this.move.inputs.next);
        this.move.position.next = (this.move.inputs.next * (this.move.inputs.ratio || 1)) + this.move.shift.next;
        this.updatePosition(this.move.position.max - this.move.position.next);
        this.submitPosition();
    };
    /**
     * @return {?}
     */
    IccDrawInterfaceComponent.prototype.onChangePrev = /**
     * @return {?}
     */
    function () {
        this.move.inputs.prev = parseFloat(this.move.inputs.prev);
        this.move.position.prev = (this.move.inputs.prev * (this.move.inputs.ratio || 1)) + this.move.shift.prev;
        this.updatePosition(this.move.position.min + this.move.position.prev);
        this.submitPosition();
    };
    /**
     * @return {?}
     */
    IccDrawInterfaceComponent.prototype.onClickCancel = /**
     * @return {?}
     */
    function () {
        if (this.move.position.curr !== this.move.position.old) {
            this.updatePosition(this.move.position.old);
            this.submitPosition();
        }
    };
    /**
     * @return {?}
     */
    IccDrawInterfaceComponent.prototype.onClickSubmit = /**
     * @return {?}
     */
    function () {
        this.move.actions.onClick(this.move.node.onClick({
            index: 'move',
        }));
        // this.uuid = undefined;
    };
    /**
     * @return {?}
     */
    IccDrawInterfaceComponent.prototype.onStartMoving = /**
     * @return {?}
     */
    function () {
        this.move.listeners.mousemove = this.renderer.listen('document', 'mousemove', this.onPointerMove.bind(this));
        this.move.listeners.touchmove = this.renderer.listen('document', 'touchmove', this.onPointerMove.bind(this));
        this.move.listeners.mouseup = this.renderer.listen('document', 'mouseup', this.onPointerUp.bind(this));
        this.move.listeners.touchend = this.renderer.listen('document', 'touchend', this.onPointerUp.bind(this));
    };
    /**
     * @return {?}
     */
    IccDrawInterfaceComponent.prototype.submitPosition = /**
     * @return {?}
     */
    function () {
        if (this.move.node) {
            this.move.actions.onMove(this.move.node.onMove({
                difference: this.move.position.node - this.move.position.curr,
                position: this.move.position.curr,
            }));
            this.move.position.node = this.move.position.curr;
        }
    };
    /**
     * @param {?} curr
     * @return {?}
     */
    IccDrawInterfaceComponent.prototype.updatePosition = /**
     * @param {?} curr
     * @return {?}
     */
    function (curr) {
        this.move.position.curr = Number(curr) || 0;
        this.move.position.curr = Math.max(this.move.position.curr, this.move.position.min + this.move.position.minGlass + this.move.shift.prev + this.move.min);
        this.move.position.curr = Math.min(this.move.position.curr, this.move.position.max - this.move.position.maxGlass - this.move.shift.next - this.move.min);
        if (this.move.max) {
            this.move.position.curr = Math.min(this.move.position.curr, this.move.max);
            this.move.position.curr = Math.max(this.move.position.curr, this.move.position.min + this.move.position.max - this.move.max);
        }
        this.move.position.next = this.move.position.max - this.move.position.curr;
        this.move.position.prev = this.move.position.curr - this.move.position.min;
        this.move.inputs.next = IccDrawMathService.round((this.move.position.next - this.move.shift.next) / (this.move.inputs.ratio || 1), 2);
        this.move.inputs.prev = IccDrawMathService.round((this.move.position.prev - this.move.shift.prev) / (this.move.inputs.ratio || 1), 2);
        var /** @type {?} */ rect = IccDrawMathService.getRectFromPoly(this.move.node.poly);
        if (this.move.direction === 'vertical') {
            rect.x = this.move.position.curr + this.move.rect.x;
            rect.width = 0;
        }
        else {
            rect.y = this.move.position.curr + this.move.rect.y;
            rect.height = 0;
        }
        this.move.style = IccDrawMathService.getRelativePosition(this.move.node.root.rect, rect, this.move.node.root.side);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    IccDrawInterfaceComponent.prototype.onPointerMove = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        event.preventDefault();
        if (this.move.node && this.svg) {
            var /** @type {?} */ point = this.svg.createSVGPoint();
            point.x = event.clientX || event.changedTouches[0].clientX;
            point.y = event.clientY || event.changedTouches[0].clientY;
            point = point.matrixTransform(this.svg.getScreenCTM().inverse());
            var /** @type {?} */ position = this.move.direction === 'vertical'
                ? point.x - this.move.rect.x
                : point.y - this.move.rect.y;
            if (event.altKey) {
                position = Math.round(position / 100) * 100;
            }
            else if (event.ctrlKey) {
                position = Math.round(position / 10) * 10;
            }
            else if (event.shiftKey) {
                position = Math.round(position * 10) / 10;
            }
            else {
                position = Math.round(position);
            }
            this.updatePosition(position);
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    IccDrawInterfaceComponent.prototype.onPointerUp = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.submitPosition();
        this.move.listeners.mousemove();
        this.move.listeners.touchmove();
        this.move.listeners.mouseup();
        this.move.listeners.touchend();
    };
    IccDrawInterfaceComponent.decorators = [
        { type: Component, args: [{
                    selector: 'icc-draw-interface',
                    styles: [":host * { box-sizing: border-box; margin: 0; outline: none; padding: 0; } .icc-draw-interface { bottom: 0; left: 0; position: absolute; right: 0; top: 0; } .icc-draw-interface > div { opacity: 0; position: absolute; pointer-events: none; transition: all 100ms ease-in-out; } .icc-draw-interface > div.active { opacity: 1; } .icc-draw-interface > div:not(.rect) { align-content: center; align-items: center; display: flex; flex-wrap: wrap; justify-content: center; margin: -25px 0 0 -25px; text-align: center; } .icc-draw-interface > div > span { display: block; } .icc-draw-interface > div.active > span { pointer-events: all; } .icc-draw-interface > div > span:hover { cursor: pointer; } .icc-draw-interface > div.rect > span { /* background: rgba(255, 0, 0, 0.2); */ bottom: -10px; left: -10px; position: absolute; right: -10px; top: -10px; transition: all 100ms ease-in-out; } .icc-draw-interface > div.rect > span:hover { background: rgba(255, 0, 0, 0.2); } .icc-draw-interface > div:not(.rect) > span { background: #fff url() center center no-repeat; border: none; border-radius: 20px; box-shadow: 2px 2px 2px 0px rgba(0,0,0,0.5); font: 700 12px/40px Arial; height: 40px; margin: 5px; padding: 0px; text-align: center; transition: all 100ms ease-in-out; width: 40px; } .icc-draw-interface > div:not(.rect) > span:active, .icc-draw-interface > div:not(.rect) > span:focus, .icc-draw-interface > div:not(.rect) > span:hover { box-shadow: 3px 3px 3px 1px rgba(0,0,0,0.5); } .icc-draw-move { border: 1px dotted #f00; position: absolute; } .icc-draw-move > div { height: 0; left: 50%; position: relative; top: 50%; width: 0; } .icc-draw-move > div > .move { left: -20px; top: -20px; } .icc-draw-move.vertical > div > .prev, .icc-draw-move.horizontal > div > .cancel { left: -70px; top: -20px; } .icc-draw-move.vertical > div > .next, .icc-draw-move.horizontal > div > .submit { left: 30px; top: -20px; } .icc-draw-move.horizontal > div > .prev, .icc-draw-move.vertical > div > .cancel { left: -20px; top: -70px; } .icc-draw-move.horizontal > div > .next, .icc-draw-move.vertical > div > .submit { left: -20px; top: 30px; } .icc-draw-move > div > * { background: #fff url() center center no-repeat; border: none; border-radius: 20px; box-shadow: 2px 2px 2px 0px rgba(0,0,0,0.5); display: block; font: 700 12px/40px Arial; height: 40px; padding: 0px; position: absolute; text-align: center; transition: all 100ms ease-in-out; width: 40px; } .icc-draw-move > div > *:active, .icc-draw-move > div > *:focus, .icc-draw-move > div > *:hover { box-shadow: 3px 3px 3px 1px rgba(0,0,0,0.5); } .icc-draw-move > div > .cancel:hover, .icc-draw-move > div > .submit:hover { cursor: pointer; } .icc-draw-move > div > .move:hover { cursor: move; } .icc-draw-move > div > input:hover { cursor: text; } "],
                    template: "<div class=\"icc-draw-interface\" [ngStyle]=\"{'pointer-events': uuid ? 'all' : 'none'}\" > <div *ngFor=\"let group of groups\" (click)=\"$event.stopPropagation()\" [ngClass]=\"{'active': group.uuid === uuid}\" [ngStyle]=\"group.style\" class=\"{{group.side}}\" > <span *ngFor=\"let button of group.buttons\" (click)=\"onButtonClick(button, group)\" [innerHTML]=\"button.innerHtml ? button.innerHtml : ''\" [ngClass]=\"button.class\" [ngStyle]=\"button.style\" [attr.title]=\"button.title\" > </span> </div> </div> <div *ngIf=\"move.node && uuid === 'move'\" class=\"icc-draw-move\" (click)=\"$event.stopPropagation()\" [ngClass]=\"move.direction\" [ngStyle]=\"move.style\" > <div> <input class=\"prev\" [(ngModel)]=\"move.inputs.prev\" (change)=\"onChangePrev()\" placeholder=\"before\" type=\"text\"> <input class=\"next\" [(ngModel)]=\"move.inputs.next\" (change)=\"onChangeNext()\" placeholder=\"after\" type=\"text\"> <span class=\"cancel ico-move-cancel\" *ngIf=\"move.actions.onClick\" (click)=\"onClickCancel()\"></span> <span class=\"submit ico-move-submit\" *ngIf=\"move.actions.onClick\" (click)=\"onClickSubmit()\"></span> <span class=\"move\" [ngClass]=\"move.direction === 'horizontal' ? 'ico-move-horizontal' : 'ico-move-vertical'\" (mousedown)=\"onStartMoving()\" (touchstart)=\"onStartMoving()\"></span> </div> </div> ",
                },] },
    ];
    /** @nocollapse */
    IccDrawInterfaceComponent.ctorParameters = function () { return [
        { type: Renderer2, },
    ]; };
    IccDrawInterfaceComponent.propDecorators = {
        "node": [{ type: Input },],
        "options": [{ type: Input },],
        "svg": [{ type: Input },],
        "interfaceClickHandler": [{ type: Input },],
        "clicked": [{ type: Output },],
        "click": [{ type: HostListener, args: ['document:click', ['$event'],] },],
    };
    return IccDrawInterfaceComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var IccDrawDetails = (function () {
    function IccDrawDetails(params) {
        if (params === void 0) { params = {}; }
        this.shape = {};
        this.usedProfiles = [];
        if (params.$version < 5) {
            params.mullions = params.dividers;
            for (var _i = 0, _a = params.mullions || []; _i < _a.length; _i++) {
                var mullion = _a[_i];
                mullion.perpendicularMullions = mullion.adjacentDividers;
            }
            for (var _b = 0, _c = params.sashes || []; _b < _c.length; _b++) {
                var sash = _c[_b];
                sash.intMullions = sash.intDividers;
                sash.nearMullions = sash.nearDividers;
                for (var _d = 0, _e = sash.intMullions || []; _d < _e.length; _d++) {
                    var mullion = _e[_d];
                    mullion.perpendicularMullions = mullion.adjacentDividers;
                }
                for (var _f = 0, _g = sash.intSashes || []; _f < _g.length; _f++) {
                    var intSash = _g[_f];
                    intSash.intMullions = intSash.intDividers;
                    intSash.nearMullions = intSash.nearDividers;
                    for (var _h = 0, _j = intSash.intMullions || []; _h < _j.length; _h++) {
                        var mullion = _j[_h];
                        mullion.perpendicularMullions = mullion.adjacentDividers;
                    }
                }
            }
        }
        Object.assign(this, params);
    }
    return IccDrawDetails;
}());
var IccDrawOptions = (function () {
    function IccDrawOptions(params) {
        if (params === void 0) { params = {}; }
        this.base = {
            kickerLowThreshold: false,
            side: 'inner',
            ventilator: true,
        };
        this.colors = {
            glassStartColor: '#cbdff4',
            glassStopColor: '#f0fbff',
        };
        this.dimensions = {
            multiplier: 1,
            ratio: 1,
            type: 'inner',
        };
        this.indexes = {
            multiplier: 1,
        };
        this.interface = {
            moveShift: true,
        };
        Object.assign(this, params);
    }
    /**
     * @return {?}
     */
    IccDrawOptions.prototype.onInterfaceClick = /**
     * @return {?}
     */
    function () { };
    
    return IccDrawOptions;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var SvgGradient = (function () {
    function SvgGradient(params) {
        if (params === void 0) { params = {}; }
        this.id = null;
        this.steps = [];
        Object.assign(this, params);
    }
    return SvgGradient;
}());
var SvgPattern = (function () {
    function SvgPattern(params) {
        if (params === void 0) { params = {}; }
        this.color = null;
        this.image = null;
        this.id = null;
        this.patternTransform = null;
        this.patternUnits = 'userSpaceOnUse';
        this.width = 1;
        this.height = 1;
        this.x = 0;
        this.y = 0;
        Object.assign(this, params);
    }
    return SvgPattern;
}());
var SvgPath = (function () {
    function SvgPath(params) {
        if (params === void 0) { params = {}; }
        this.d = '';
        this.fill = 'transparent';
        this.stroke = null;
        this.strokeDasharray = null;
        this.strokeWidth = null;
        this.vectorEffect = 'non-scaling-stroke';
        Object.assign(this, params);
    }
    return SvgPath;
}());
var SvgText = (function () {
    function SvgText(params) {
        if (params === void 0) { params = {}; }
        this.dominantBaseline = 'central';
        this.fill = 'transparent';
        this.fontSize = null;
        this.stroke = null;
        this.strokeWidth = null;
        this.textAnchor = 'middle';
        this.transform = null;
        this.value = '';
        this.x = 0;
        this.y = 0;
        Object.assign(this, params);
    }
    return SvgText;
}());
var IccDrawSvgService = (function () {
    function IccDrawSvgService() {
    }
    /**
     * @param {?=} params
     * @return {?}
     */
    IccDrawSvgService.getGradient = /**
     * @param {?=} params
     * @return {?}
     */
    function (params) {
        var /** @type {?} */ svgGradient = new SvgGradient(params);
        return svgGradient;
    };
    /**
     * @param {?=} params
     * @return {?}
     */
    IccDrawSvgService.getPattern = /**
     * @param {?=} params
     * @return {?}
     */
    function (params) {
        var /** @type {?} */ svgPattern = new SvgPattern(params);
        return svgPattern;
    };
    /**
     * @param {?} polygon
     * @param {?} closedPath
     * @param {?} side
     * @param {?=} params
     * @return {?}
     */
    IccDrawSvgService.getPath = /**
     * @param {?} polygon
     * @param {?} closedPath
     * @param {?} side
     * @param {?=} params
     * @return {?}
     */
    function (polygon, closedPath, side, params) {
        var /** @type {?} */ svgPath = new SvgPath(params);
        // svgPath.fill = '#' + ((1<<24)*Math.random()|0).toString(16);
        if (polygon && polygon.length > 0) {
            if (closedPath) {
                polygon = polygon.concat([polygon[0]]);
            }
            svgPath.d = polygon.map(function (o, i) {
                var x = o.x, y = o.y, cr = o.cr, cw = o.cw;
                if (side === 'outer') {
                    x = -x;
                    cw = !cw;
                }
                if (i === 0) {
                    return "M " + Math.round(x) + " " + Math.round(y);
                }
                else if (cr) {
                    return "A " + cr + " " + cr + " 0 0 " + (cw ? 1 : 0) + " " + Math.round(x) + " " + Math.round(y);
                }
                else {
                    return "L " + Math.round(x) + " " + Math.round(y);
                }
            }).join(' ');
        }
        return svgPath;
    };
    /**
     * @param {?} text
     * @param {?=} params
     * @return {?}
     */
    IccDrawSvgService.getText = /**
     * @param {?} text
     * @param {?=} params
     * @return {?}
     */
    function (text, params) {
        var /** @type {?} */ svgText = new SvgText(params);
        Object.assign(svgText, text);
        return svgText;
    };
    return IccDrawSvgService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var BaseNode = (function () {
    function BaseNode(parentNode, childrenNodes, params, options) {
        if (parentNode === void 0) { parentNode = null; }
        if (childrenNodes === void 0) { childrenNodes = null; }
        if (params === void 0) { params = {}; }
        if (options === void 0) { options = {}; }
        this.root = null;
        this.parent = null;
        this.children = [];
        this.uri = window.location.href;
        this.poly = [];
        this.rect = { x: 0, y: 0, width: 0, height: 0 };
        this.svg = {
            gradients: [],
            patterns: [],
            paths: [],
            texts: [],
        };
        this.options = {};
        Object.assign(this.options, options);
        this.root = this;
        this.uuid = this.getUUID();
        if (this.uri.indexOf('file:///') > -1) {
            this.uri = '';
        }
        this.setParent(parentNode);
        this.setChildren(childrenNodes);
        Object.assign(this, params);
    }
    /**
     * @return {?}
     */
    BaseNode.prototype.getUUID = /**
     * @return {?}
     */
    function () {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var /** @type {?} */ r = Math.random() * 16 | 0;
            var /** @type {?} */ v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    };
    /**
     * @param {?=} params
     * @return {?}
     */
    BaseNode.prototype.onClick = /**
     * @param {?=} params
     * @return {?}
     */
    function (params) {
        return {};
    };
    /**
     * @param {?=} childrenNodes
     * @return {?}
     */
    BaseNode.prototype.setChildren = /**
     * @param {?=} childrenNodes
     * @return {?}
     */
    function (childrenNodes) {
        var _this = this;
        if (childrenNodes) {
            childrenNodes.map(function (node) {
                node.root = _this.root;
                node.parent = _this;
                _this.children.push(node);
            });
        }
    };
    /**
     * @param {?=} parentNode
     * @return {?}
     */
    BaseNode.prototype.setParent = /**
     * @param {?=} parentNode
     * @return {?}
     */
    function (parentNode) {
        if (parentNode) {
            this.root = parentNode.root;
            this.parent = parentNode;
            this.parent.children.push(this);
        }
    };
    return BaseNode;
}());

var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var AlignmentNode = (function (_super) {
    __extends(AlignmentNode, _super);
    function AlignmentNode(parentNode, childrenNodes, params, options) {
        if (parentNode === void 0) { parentNode = null; }
        if (childrenNodes === void 0) { childrenNodes = null; }
        if (params === void 0) { params = {}; }
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, parentNode, childrenNodes, params, options) || this;
        _this.alignment = {};
        _this.alignments = [];
        _this.mullions = [];
        _this.usedProfiles = [];
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(_this, params);
        var /** @type {?} */ alignmentProfile = _this.usedProfiles.find(function (o) { return o.id === _this.alignment.profileId; }) || {};
        if (_this.root.side !== 'outer') {
            _this.width = Number(alignmentProfile.width) || 45;
        }
        else {
            _this.width = Number(alignmentProfile.widthOut) || 45;
        }
        /** math: obliczenie współrzędnych figury */
        /** math: obliczenie współrzędnych figury */
        _this.rect = {
            x: _this.parent.parent.rect.x + (_this.alignment.direction === 'horizontal' ? _this.alignment.shift : _this.alignment.position),
            y: _this.parent.parent.rect.y + (_this.alignment.direction === 'vertical' ? _this.alignment.shift : _this.alignment.position),
            width: _this.alignment.direction === 'horizontal' ? _this.alignment.length : _this.width,
            height: _this.alignment.direction === 'vertical' ? _this.alignment.length : _this.width,
        };
        _this.shiftFrame();
        _this.poly = IccDrawMathService.intersectPolyWithRect(_this.parent.poly, _this.rect);
        _this.rect = IccDrawMathService.getRectFromPoly(_this.poly);
        _this.shiftRect(_this.alignment.id);
        _this.poly = IccDrawMathService.getPolyFromRect(_this.rect);
        /** svg: rysowanie ścieżek */
        /** svg: rysowanie ścieżek */
        _this.svg.paths.push(IccDrawSvgService.getPath(_this.poly, true, _this.root.side, {
            stroke: '#bbb',
            // fill: '#f5f5f5',
            fill: "url('" + _this.root.uri + "#iccDraw-" + (_this.sash ? 'sash' : 'frame') + "-" + _this.root.uuid + "')",
        }));
        return _this;
    }
    /**
     * @param {?=} params
     * @return {?}
     */
    AlignmentNode.prototype.onClick = /**
     * @param {?=} params
     * @return {?}
     */
    function (params) {
        if (params === void 0) { params = {}; }
        return Object.assign({
            alignment: this.alignment,
            sash: this.sash,
        }, params);
    };
    /**
     * @return {?}
     */
    AlignmentNode.prototype.shiftFrame = /**
     * @return {?}
     */
    function () {
        if (this.alignment.side === 'left' && this.alignment.position === 0) {
            this.rect.x = this.parent.rect.x;
        }
        if (this.alignment.side === 'right' && this.alignment.position === this.parent.parent.rect.width) {
            this.rect.x = this.parent.rect.x + this.parent.rect.width;
        }
        if (this.alignment.side === 'top' && this.alignment.position === 0) {
            this.rect.y = this.parent.rect.y;
        }
        if (this.alignment.side === 'bottom' && this.alignment.position === this.parent.parent.rect.height) {
            this.rect.y = this.parent.rect.y + this.parent.rect.height;
        }
        if (this.alignment.side === 'right') {
            this.rect.x -= this.rect.width;
        }
        if (this.alignment.side === 'bottom') {
            this.rect.y -= this.rect.height;
        }
    };
    /**
     * @param {?} id
     * @param {?=} side
     * @return {?}
     */
    AlignmentNode.prototype.shiftRect = /**
     * @param {?} id
     * @param {?=} side
     * @return {?}
     */
    function (id, side) {
        var _this = this;
        var /** @type {?} */ alignment = this.alignments.find(function (o) { return o.id === id; }) || {};
        var /** @type {?} */ sides = this.alignment.direction === 'horizontal' ? ['left', 'right'] : ['top', 'bottom'];
        if (alignment && alignment.id) {
            if (this.alignment.id === alignment.id) {
                sides.map(function (side) {
                    alignment.perpendicularAlignments[side].map(function (id) { return _this.shiftRect(id, side); });
                    alignment.perpendicularMullions[side].map(function (id) { return _this.shiftMullion(id, side); });
                });
            }
            else {
                this.shiftAlignment(alignment.id, side);
            }
            alignment.parallelAlignments[side || this.alignment.side].map(function (id) { return _this.shiftRect(id, side); });
            alignment.parallelMullions[side || this.alignment.side].map(function (id) { return _this.shiftMullion(id, side); });
        }
    };
    /**
     * @param {?} id
     * @param {?=} side
     * @return {?}
     */
    AlignmentNode.prototype.shiftAlignment = /**
     * @param {?} id
     * @param {?=} side
     * @return {?}
     */
    function (id, side) {
        var /** @type {?} */ alignment = this.alignments.find(function (o) { return o.id === id; }) || {};
        var /** @type {?} */ alignmentProfile = this.usedProfiles.find(function (o) { return o.id === alignment.profileId; }) || {};
        if (this.root.side !== 'outer') {
            this.shiftSide(Number(alignmentProfile.width) || 45, side);
        }
        else {
            this.shiftSide(Number(alignmentProfile.widthOut) || 45, side);
        }
    };
    /**
     * @param {?} id
     * @param {?=} side
     * @return {?}
     */
    AlignmentNode.prototype.shiftMullion = /**
     * @param {?} id
     * @param {?=} side
     * @return {?}
     */
    function (id, side) {
        var /** @type {?} */ mullion = this.mullions.find(function (o) { return o.id === id; }) || {};
        var /** @type {?} */ mullionProfile = this.usedProfiles.find(function (o) { return o.id === mullion.profileId; }) || {};
        if (this.root.side !== 'outer') {
            this.shiftSide((Number(mullionProfile.width) || 45) / 2, side);
        }
        else {
            this.shiftSide((Number(mullionProfile.widthOut) || 45) / 2, side);
        }
    };
    /**
     * @param {?} width
     * @param {?=} side
     * @return {?}
     */
    AlignmentNode.prototype.shiftSide = /**
     * @param {?} width
     * @param {?=} side
     * @return {?}
     */
    function (width, side) {
        if (side) {
            switch (side) {
                case 'top':
                    this.rect.height -= width;
                    this.rect.y += width;
                    break;
                case 'left':
                    this.rect.width -= width;
                    this.rect.x += width;
                    break;
                case 'right':
                    this.rect.width -= width;
                    break;
                case 'bottom':
                    this.rect.height -= width;
                    break;
            }
        }
        else {
            switch (this.alignment.side) {
                case 'top':
                    this.rect.y += width;
                    break;
                case 'left':
                    this.rect.x += width;
                    break;
                case 'right':
                    this.rect.x -= width;
                    break;
                case 'bottom':
                    this.rect.y -= width;
                    break;
            }
        }
    };
    return AlignmentNode;
}(BaseNode));

var __extends$1 = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var ColorsNode = (function (_super) {
    __extends$1(ColorsNode, _super);
    function ColorsNode(parentNode, childrenNodes, params, options) {
        if (parentNode === void 0) { parentNode = null; }
        if (childrenNodes === void 0) { childrenNodes = null; }
        if (params === void 0) { params = {}; }
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, parentNode, childrenNodes, params, options) || this;
        _this.colors = {
            frame: {},
            sash: {},
        };
        _this.muntins = {
            colorInner: {},
            colorOuter: {},
        };
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(_this.colors, params.colors);
        Object.assign(_this.muntins, params.muntins);
        /** svg: gradient szyby */
        /** svg: gradient szyby */
        _this.svg.gradients.push(IccDrawSvgService.getGradient({
            id: "iccDraw-glazing-" + _this.root.uuid,
            steps: [
                { color: _this.options.glassStartColor || '#cbdff4', offset: '0%' },
                { color: _this.options.glassStopColor || '#f0fbff', offset: '100%' },
            ],
        }));
        /**
         * svg: kolor ramy
         */
        var /** @type {?} */ frame = _this.colors.frame[_this.root.side] && _this.colors.frame[_this.root.side].id
            ? _this.colors.frame[_this.root.side]
            : _this.colors.frame.core && _this.colors.frame.core.id
                ? _this.colors.frame.core
                : null;
        var /** @type {?} */ frameColor = frame && frame.color ? frame.color : 'fff';
        var /** @type {?} */ frameImage = frame && frame.color_img ? frame.color_img : null;
        _this.svg.patterns.push(IccDrawSvgService.getPattern({
            id: "iccDraw-frame-" + _this.root.uuid,
            color: frameColor ? "#" + frameColor : null,
            image: frameImage ? "/files/windowcolor/" + frameImage : null,
            height: _this.root.rect.height,
            width: _this.root.rect.width,
        }));
        /**
         * svg: kolor skrzydła
         */
        var /** @type {?} */ sash = _this.colors.sash[_this.root.side] && _this.colors.sash[_this.root.side].id
            ? _this.colors.sash[_this.root.side]
            : _this.colors.sash.core && _this.colors.sash.core.id
                ? _this.colors.sash.core
                : null;
        var /** @type {?} */ sashColor = sash && sash.color ? sash.color : 'fff';
        var /** @type {?} */ sashImage = sash && sash.color_img ? sash.color_img : null;
        _this.svg.patterns.push(IccDrawSvgService.getPattern({
            id: "iccDraw-sash-" + _this.root.uuid,
            color: sashColor ? "#" + sashColor : null,
            image: sashImage ? "/files/windowcolor/" + sashImage : null,
            height: _this.root.rect.height,
            width: _this.root.rect.width,
        }));
        /**
         * svg: kolor szprosów
         */
        var /** @type {?} */ muntinsColor = _this.root.side === 'inner' && _this.muntins.colorInner && _this.muntins.colorInner.color
            ? _this.muntins.colorInner.color
            : _this.root.side === 'outer' && _this.muntins.colorOuter && _this.muntins.colorOuter.color
                ? _this.muntins.colorOuter.color
                : 'fff';
        var /** @type {?} */ muntinsImage = _this.root.side === 'inner' && _this.muntins.colorInner && _this.muntins.colorInner.color_img
            ? _this.muntins.colorInner.color_img
            : _this.root.side === 'outer' && _this.muntins.colorOuter && _this.muntins.colorOuter.color_img
                ? _this.muntins.colorOuter.color_img
                : null;
        _this.svg.patterns.push(IccDrawSvgService.getPattern({
            id: "iccDraw-muntins-" + _this.root.uuid,
            color: muntinsColor ? "#" + muntinsColor : null,
            image: muntinsImage ? "/files/windowcolor/" + muntinsImage : null,
            height: _this.root.rect.height,
            width: _this.root.rect.width,
        }));
        /** svg: wzór dla słupka ruchomego */
        return _this;
    }
    return ColorsNode;
}(BaseNode));

var __extends$2 = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var DimensionNode = (function (_super) {
    __extends$2(DimensionNode, _super);
    function DimensionNode(parentNode, childrenNodes, params, options) {
        if (parentNode === void 0) { parentNode = null; }
        if (childrenNodes === void 0) { childrenNodes = null; }
        if (params === void 0) { params = {}; }
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, parentNode, childrenNodes, params, options) || this;
        _this.breakpoints = [];
        _this.lines = [];
        _this.texts = [];
        _this.multiplier = 1;
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(_this, params);
        Object.keys(_this.baseRect).map(function (key) { return _this.baseRect[key] = IccDrawMathService.round(_this.baseRect[key]); });
        _this.multiplier = Math.max(_this.baseRect.width - _this.baseRect.x, _this.baseRect.height - _this.baseRect.y) * (_this.options.multiplier || 1);
        /** math: obliczenie wymiarów */
        /** math: obliczenie wymiarów */
        _this.getPosition();
        _this.getBreakpoints();
        _this.getDimensions();
        /** svg: rysowanie ścieżek */
        for (var _i = 0, _a = _this.lines; _i < _a.length; _i++) {
            var line = _a[_i];
            _this.svg.paths.push(IccDrawSvgService.getPath(line, false, _this.root.side, {
                stroke: '#000',
            }));
        }
        /** svg: rysowanie tekstów */
        for (var _b = 0, _c = _this.texts; _b < _c.length; _b++) {
            var text = _c[_b];
            _this.svg.texts.push(IccDrawSvgService.getText(text, {
                fill: '#000',
                fontSize: Math.round(_this.multiplier / 35),
            }));
        }
        return _this;
    }
    /**
     * @return {?}
     */
    DimensionNode.prototype.getBreakpoints = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.type === 'horizontal') {
            this.breakpoints.push(this.details.x || 0);
            this.breakpoints.push(this.details.width || 0);
            this.breakpoints.push(this.baseRect.x || 0);
            this.breakpoints.push(this.baseRect.x + this.baseRect.width || 0);
            if (this.shape && this.shape.shape && this.shape.shape.shape) {
                switch (this.shape.shape.shape) {
                    case 'circle':
                    case 'arc':
                        break;
                    default:
                        if (this.shape.poly && this.shape.poly.length) {
                            for (var _i = 0, _a = this.shape.poly; _i < _a.length; _i++) {
                                var point = _a[_i];
                                this.breakpoints.push(point.x || 0);
                            }
                        }
                }
            }
            if (this.details.rollerShutter && this.details.rollerShutter.shutters && this.details.rollerShutter.shutters.length
                && this.details.type === 'roller_shutter' || this.options.extendedRollerInWindow === 'full') {
                var /** @type {?} */ x = 0;
                for (var _b = 0, _c = this.details.rollerShutter.shutters; _b < _c.length; _b++) {
                    var shutter = _c[_b];
                    x += shutter.width;
                    this.breakpoints.push(x);
                }
            }
        }
        else {
            this.breakpoints.push(this.details.y || 0);
            this.breakpoints.push(this.details.height || 0);
            this.breakpoints.push(this.baseRect.y || 0);
            this.breakpoints.push(this.baseRect.y + this.baseRect.height || 0);
            if (this.shape && this.shape.shape && this.shape.shape.shape) {
                switch (this.shape.shape.shape) {
                    case 'circle':
                        break;
                    case 'arc':
                        this.breakpoints.push(this.shape.shape.h2 || 0);
                        break;
                    default:
                        if (this.shape.poly && this.shape.poly.length) {
                            for (var _d = 0, _e = this.shape.poly; _d < _e.length; _d++) {
                                var point = _e[_d];
                                this.breakpoints.push(point.y || 0);
                            }
                        }
                }
            }
            if (this.details.rollerShutter && this.details.rollerShutter.shutters && this.details.rollerShutter.shutters.length
                && this.details.type === 'roller_shutter' || this.options.extendedRollerInWindow === 'full') {
                for (var _f = 0, _g = this.details.rollerShutter.shutters; _f < _g.length; _f++) {
                    var shutter = _g[_f];
                    this.breakpoints.push(shutter.height);
                }
            }
        }
        if (this.details.mullions && this.details.mullions.length) {
            for (var _h = 0, _j = this.details.mullions.filter(function (o) { return o.direction !== _this.type; }); _h < _j.length; _h++) {
                var mullion = _j[_h];
                this.breakpoints.push(mullion.position || 0);
            }
        }
        if (this.details.sashes && this.details.sashes.length) {
            for (var _k = 0, _l = this.details.sashes; _k < _l.length; _k++) {
                var sash = _l[_k];
                if (sash.intMullions && sash.intMullions.length) {
                    for (var _m = 0, _o = sash.intMullions.filter(function (o) { return o.direction !== _this.type; }); _m < _o.length; _m++) {
                        var mullion = _o[_m];
                        this.breakpoints.push((this.type === 'horizontal' ? sash.x : sash.y) + mullion.position || 0);
                    }
                }
            }
        }
        this.breakpoints = this.breakpoints.map(IccDrawMathService.round).filter(function (v, i, a) { return a.indexOf(v) === i; }).sort(function (a, b) { return a - b; });
    };
    /**
     * @return {?}
     */
    DimensionNode.prototype.getDimensions = /**
     * @return {?}
     */
    function () {
        var /** @type {?} */ width = this.details.type === 'roller_shutter' || this.options.extendedRollerInWindow === 'full'
            ? this.details.rollerShutter.shutters.map(function (o) { return o.width; }).reduce(function (a, b) { return a + b; }, 0)
            : this.details.width;
        var /** @type {?} */ height = this.details.type === 'roller_shutter' || this.options.extendedRollerInWindow === 'full'
            ? this.details.rollerShutter.shutters.map(function (o) { return o.height; }).reduce(function (a, b) { return a > b ? a : b; }, 0)
            : this.details.height;
        if (this.type === 'horizontal') {
            this.lines.push([
                { x: this.baseRect.x, y: this.rect.y + this.rect.height / 2 },
                { x: this.baseRect.x + this.baseRect.width, y: this.rect.y + this.rect.height / 2 },
            ]);
        }
        else {
            this.lines.push([
                { x: this.rect.x + this.rect.width / 2, y: this.baseRect.y },
                { x: this.rect.x + this.rect.width / 2, y: this.baseRect.y + this.baseRect.height },
            ]);
        }
        for (var /** @type {?} */ i = -1, /** @type {?} */ j = 0; j < this.breakpoints.length; i++, j++) {
            if (this.type === 'horizontal') {
                this.lines.push([
                    { x: this.breakpoints[j], y: this.rect.y },
                    { x: this.breakpoints[j], y: this.rect.y + (j && j < this.breakpoints.length - 1 ? this.rect.height / 2 : this.rect.height) },
                ]);
                if (i !== -1 && this.breakpoints[i] >= 0 && this.breakpoints[j] <= width) {
                    var /** @type {?} */ value = IccDrawMathService.round((this.breakpoints[j] - this.breakpoints[i]) / (this.options.ratio || 1), 2);
                    var /** @type {?} */ x = (this.breakpoints[j] + this.breakpoints[i]) / 2;
                    x = this.root.side !== 'outer' ? x : -x;
                    var /** @type {?} */ y = this.rect.y + this.rect.height / 4;
                    this.texts.push({ value: value, x: x, y: y });
                }
                else {
                    var /** @type {?} */ value = "" + IccDrawMathService.round(width / (this.options.ratio || 1), 2);
                    var /** @type {?} */ x = this.rect.x + this.rect.width / 2;
                    x = this.root.side !== 'outer' ? x : -x;
                    var /** @type {?} */ y = this.rect.y + this.rect.height * 3 / 4;
                    if (this.baseRect.x < 0) {
                        value = -this.baseRect.x + " + " + value;
                    }
                    if (this.baseRect.x + this.baseRect.width > width) {
                        value = value + " + " + (this.baseRect.x + this.baseRect.width - width);
                    }
                    this.texts.push({ value: value, x: x, y: y });
                }
            }
            else {
                this.lines.push([
                    { x: this.rect.x, y: this.breakpoints[j] },
                    { x: this.rect.x + (j && j < this.breakpoints.length - 1 ? this.rect.width / 2 : this.rect.width), y: this.breakpoints[j] },
                ]);
                if (i !== -1 && this.breakpoints[i] >= 0 && this.breakpoints[j] <= height) {
                    var /** @type {?} */ value = IccDrawMathService.round((this.breakpoints[j] - this.breakpoints[i]) / (this.options.ratio || 1), 2);
                    var /** @type {?} */ x = this.rect.x + this.rect.width / 4;
                    x = this.root.side !== 'outer' ? x : -x;
                    var /** @type {?} */ y = (this.breakpoints[j] + this.breakpoints[i]) / 2;
                    this.texts.push({ transform: "rotate(270," + x + "," + y + ")", value: value, x: x, y: y });
                }
                else {
                    var /** @type {?} */ value = "" + IccDrawMathService.round(height / (this.options.ratio || 1), 2);
                    var /** @type {?} */ x = this.rect.x + this.rect.width * 3 / 4;
                    x = this.root.side !== 'outer' ? x : -x;
                    var /** @type {?} */ y = this.rect.y + this.rect.height / 2;
                    if (this.baseRect.y < 0) {
                        value = value + " + " + -this.baseRect.y;
                    }
                    if (this.baseRect.y + this.baseRect.height > height) {
                        value = this.baseRect.y + this.baseRect.height - height + " + " + value;
                    }
                    this.texts.push({ transform: "rotate(270," + x + "," + y + ")", value: value, x: x, y: y });
                }
            }
        }
    };
    /**
     * @return {?}
     */
    DimensionNode.prototype.getPosition = /**
     * @return {?}
     */
    function () {
        var /** @type {?} */ dimensionSize = Math.ceil(this.multiplier / 30);
        if (this.type === 'horizontal') {
            this.rect.x = this.baseRect.x;
            this.rect.y = this.parent.rect.y + this.parent.rect.height + dimensionSize;
            this.rect.width = this.baseRect.width;
            this.rect.height = dimensionSize * 2;
            this.parent.rect.height += dimensionSize * 3;
        }
        else {
            this.rect.x = this.parent.rect.x + this.parent.rect.width + dimensionSize;
            this.rect.y = this.baseRect.y;
            this.rect.width = dimensionSize * 2;
            this.rect.height = this.baseRect.height;
            this.parent.rect.width += dimensionSize * 3;
        }
    };
    return DimensionNode;
}(BaseNode));

var __extends$3 = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var DowelHolesNode = (function (_super) {
    __extends$3(DowelHolesNode, _super);
    function DowelHolesNode(parentNode, childrenNodes, params, options) {
        if (parentNode === void 0) { parentNode = null; }
        if (childrenNodes === void 0) { childrenNodes = null; }
        if (params === void 0) { params = {}; }
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, parentNode, childrenNodes, params, options) || this;
        _this.accessories = {};
        _this.dowelHoles = {};
        _this.sashes = [];
        _this.distanceFromEdge = 200;
        _this.distanceBetween = 700;
        _this.intersections = {};
        _this.lines = [];
        _this.width = 20;
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(_this, params);
        /** class: znalezienie pasujących akcesoriów */
        Object.keys(_this.accessories).map(function (side) {
            _this.dowelHoles[side] = _this.accessories[side].find(function (o) { return o.type === 'dowel_hole'; });
            _this.intersections[side] = [];
        });
        /** math: obliczenie pozycji na rysunku */
        /** math: obliczenie pozycji na rysunku */
        _this.sashes.map(function (sash) {
            Object.keys(sash.nearMullions || {}).map(function (side) {
                if (sash.nearMullions[side] === -1 && _this.dowelHoles[side]) {
                    var /** @type {?} */ position = (['top', 'bottom'].indexOf(side) !== -1 ? sash.x : sash.y) + _this.distanceFromEdge;
                    var /** @type {?} */ length_1 = (['top', 'bottom'].indexOf(side) !== -1 ? sash.width : sash.height) - 2 * _this.distanceFromEdge;
                    var /** @type {?} */ count = length_1 > 0 ? Math.ceil(length_1 / _this.distanceBetween) : 0;
                    var /** @type {?} */ distance = count > 0 ? length_1 / count : 0;
                    for (var /** @type {?} */ i = 0; i <= count; i++) {
                        _this.intersections[side].push(position);
                        position += distance;
                    }
                }
            });
        });
        /** math: przygotowanie linii na rysunku */
        /** math: przygotowanie linii na rysunku */
        _this.parent.polygons.map(function (poly) {
            var /** @type {?} */ line = IccDrawMathService.getLineInfo([poly[0], poly[1]], poly);
            if (_this.intersections[line.side] && _this.intersections[line.side].length) {
                _this.intersections[line.side].map(function (position) {
                    var /** @type {?} */ rect = {
                        x: ['top', 'bottom'].indexOf(line.side) !== -1 ? position - _this.width / 2 : _this.root.rect.x,
                        y: ['top', 'bottom'].indexOf(line.side) === -1 ? position - _this.width / 2 : _this.root.rect.y,
                        width: ['top', 'bottom'].indexOf(line.side) !== -1 ? _this.width : _this.root.rect.width,
                        height: ['top', 'bottom'].indexOf(line.side) === -1 ? _this.width : _this.root.rect.height,
                    };
                    _this.lines.push(IccDrawMathService.intersectPolyWithRect(poly, rect));
                });
            }
        });
        /** svg: rysowanie ścieżek */
        // this.svg.patterns.push(IccDrawSvgService.getPattern({
        //     id: `iccDraw-dowelHoles-${this.uuid}`,
        //     color: '#bbb',
        // }));
        /** svg: rysowanie ścieżek */
        // this.svg.patterns.push(IccDrawSvgService.getPattern({
        //     id: `iccDraw-dowelHoles-${this.uuid}`,
        //     color: '#bbb',
        // }));
        _this.lines.map(function (line) {
            _this.svg.paths.push(IccDrawSvgService.getPath(line, true, _this.root.side, {
                // fill: `url(#iccDraw-dowelHoles-${this.uuid})`,
                fill: '#bbb',
            }));
        });
        return _this;
    }
    /**
     * @param {?=} params
     * @return {?}
     */
    DowelHolesNode.prototype.onClick = /**
     * @param {?=} params
     * @return {?}
     */
    function (params) {
        if (params === void 0) { params = {}; }
        return Object.assign({
            dowelHoles: this.dowelHoles,
        }, params);
    };
    return DowelHolesNode;
}(BaseNode));

var __extends$4 = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var ExtensionsNode = (function (_super) {
    __extends$4(ExtensionsNode, _super);
    function ExtensionsNode(parentNode, childrenNodes, params, options) {
        if (parentNode === void 0) { parentNode = null; }
        if (childrenNodes === void 0) { childrenNodes = null; }
        if (params === void 0) { params = {}; }
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, parentNode, childrenNodes, params, options) || this;
        _this.sideProfiles = {};
        _this.usedProfiles = [];
        _this.extensions = [];
        _this.shift = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
        };
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(_this, params);
        _this.rect = _this.parent.rect;
        _this.poly = _this.parent.poly;
        /** math: obliczenie współrzędnych figury */
        Object.keys(_this.shift).map(function (side) {
            if (_this.sideProfiles && _this.sideProfiles[side] && _this.sideProfiles[side].length) {
                _this.sideProfiles[side].map(function (extension) {
                    var /** @type {?} */ extensionProfile = _this.usedProfiles.find(function (o) { return o.id === extension.profileId; }) || {};
                    var /** @type {?} */ line;
                    var /** @type {?} */ poly;
                    var /** @type {?} */ rect;
                    poly = IccDrawMathService.getPolyFromRect(_this.rect);
                    if (_this.root.side !== 'outer') {
                        _this.shift[side] -= Number(extension.width) || Number(extensionProfile.width) || 45;
                    }
                    else {
                        _this.shift[side] -= Number(extension.widthOut) || Number(extensionProfile.widthOut) || 45;
                    }
                    _this.poly = IccDrawMathService.getPolyShift(_this.parent.poly, _this.shift);
                    _this.rect = IccDrawMathService.getRectFromPoly(_this.poly);
                    switch (side) {
                        case 'left':
                            line = [poly[0], poly[1]];
                            break;
                        case 'right':
                            line = [poly[2], poly[3]];
                            break;
                        case 'top':
                            line = [poly[3], poly[0]];
                            break;
                        case 'bottom':
                            line = [poly[1], poly[2]];
                            break;
                    }
                    poly = IccDrawMathService.intersectPolyWithLine(_this.poly, line, side);
                    rect = IccDrawMathService.getRectFromPoly(poly);
                    _this.extensions.push({ extension: extension, poly: poly, rect: rect, side: side });
                });
            }
        });
        /** svg: rysowanie ścieżek */
        /** svg: rysowanie ścieżek */
        _this.extensions.map(function (extension) {
            var /** @type {?} */ color = extension.extension.color;
            if (color && color.frame && color.frame[_this.root.side]) {
                _this.svg.patterns.push(IccDrawSvgService.getPattern({
                    id: "iccDraw-extension-" + extension.extension.id + "-" + _this.uuid,
                    color: color.frame[_this.root.side].color
                        ? "#" + color.frame[_this.root.side].color
                        : '#fff',
                    image: color.frame[_this.root.side].color_img
                        ? "/files/windowcolor/" + color.frame[_this.root.side].color_img
                        : null,
                    height: extension.rect.height,
                    width: extension.rect.width,
                }));
                _this.svg.paths.push(IccDrawSvgService.getPath(extension.poly, true, _this.root.side, {
                    fill: "url('" + _this.root.uri + "#iccDraw-extension-" + extension.extension.id + "-" + _this.uuid + "')",
                    stroke: '#bbb',
                }));
            }
            else {
                _this.svg.paths.push(IccDrawSvgService.getPath(extension.poly, true, _this.root.side, {
                    fill: "url('" + _this.root.uri + "#iccDraw-frame-" + _this.root.uuid + "')",
                    stroke: '#bbb',
                }));
            }
        });
        return _this;
    }
    /**
     * @param {?=} params
     * @return {?}
     */
    ExtensionsNode.prototype.onClick = /**
     * @param {?=} params
     * @return {?}
     */
    function (params) {
        if (params === void 0) { params = {}; }
        return Object.assign({
            extensions: this.extensions,
        }, params);
    };
    return ExtensionsNode;
}(BaseNode));

var __extends$5 = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var FrameNode = (function (_super) {
    __extends$5(FrameNode, _super);
    function FrameNode(parentNode, childrenNodes, params, options) {
        if (parentNode === void 0) { parentNode = null; }
        if (childrenNodes === void 0) { childrenNodes = null; }
        if (params === void 0) { params = {}; }
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, parentNode, childrenNodes, params, options) || this;
        _this.lowThreshold = false;
        _this.profiles = [];
        _this.usedProfiles = [];
        _this.polygons = [];
        _this.width = [];
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(_this, params);
        /** class: przygotowanie zestawu profili  */
        /** class: przygotowanie zestawu profili  */
        _this.setProfiles();
        var /** @type {?} */ outerSash = _this.usedProfiles.some(function (el) { return el.type === 'sash' && el.options && el.options.includes('outward_opening'); });
        var /** @type {?} */ outerSide = _this.root.side === 'outer';
        /** math: obliczenie przesunięcia */
        Object.keys(_this.parent.poly).forEach(function (index) {
            var /** @type {?} */ frame = _this.profiles[index] || _this.profiles[0] || {};
            var /** @type {?} */ frameProfile = _this.usedProfiles.find(function (o) { return o.id === frame.profileId; }) || _this.usedProfiles.find(function (o) { return o.type === 'frame'; }) || {};
            if ((!_this.root.side && outerSash)
                || outerSide !== outerSash
                || (_this.lowThreshold && !_this.root.options.kickerLowThreshold && Number(index) === 0)) {
                _this.width[index] = Number(frameProfile.widthOut || 70);
            }
            else {
                _this.width[index] = Number(frameProfile.width || 45);
            }
        });
        /** math: obliczenie współrzędnych figury */
        /** math: obliczenie współrzędnych figury */
        _this.poly = IccDrawMathService.getPolyShift(_this.parent.poly, _this.width);
        _this.rect = IccDrawMathService.getRectFromPoly(_this.poly);
        /**
         * math: przygotowanie zestawów profili
         */
        var /** @type {?} */ jointAngle = _this.profiles.map(function (profile) { return profile.jointAngle || 'E'; });
        _this.polygons = IccDrawMathService.getPolygons(_this.parent.poly, _this.poly, jointAngle);
        /** svg: rysowanie ścieżek */
        for (var _i = 0, _a = _this.polygons; _i < _a.length; _i++) {
            var polygon = _a[_i];
            _this.svg.paths.push(IccDrawSvgService.getPath(polygon, true, _this.root.side, {
                stroke: '#bbb',
                fill: "url('" + _this.root.uri + "#iccDraw-frame-" + _this.root.uuid + "')",
            }));
        }
        return _this;
    }
    /**
     * @param {?=} params
     * @return {?}
     */
    FrameNode.prototype.onClick = /**
     * @param {?=} params
     * @return {?}
     */
    function (params) {
        if (params === void 0) { params = {}; }
        return Object.assign({
            profiles: this.profiles,
        }, params);
    };
    /**
     * @return {?}
     */
    FrameNode.prototype.setProfiles = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (!Array.isArray(this.profiles) || !this.profiles.length) {
            this.profiles = this.parent.poly.map(function () { return {}; });
        }
        if (this.profiles.length && this.profiles.length < this.parent.poly.length) {
            var /** @type {?} */ profiles_1 = [];
            this.parent.poly.forEach(function (v, i) { return profiles_1.push(_this.profiles[i] || _this.profiles[i - 1] || _this.profiles[0]); });
            this.profiles = profiles_1;
        }
    };
    return FrameNode;
}(BaseNode));

var __extends$6 = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var GlazingNode = (function (_super) {
    __extends$6(GlazingNode, _super);
    function GlazingNode(parentNode, childrenNodes, params, options) {
        if (parentNode === void 0) { parentNode = null; }
        if (childrenNodes === void 0) { childrenNodes = null; }
        if (params === void 0) { params = {}; }
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, parentNode, childrenNodes, params, options) || this;
        _this.glazing = {};
        _this.mullions = [];
        _this.profiles = [];
        _this.renson = null;
        _this.sash = {};
        _this.usedProfiles = [];
        _this.parallelPoly = [];
        _this.parallelProfiles = [];
        _this.shift = [];
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(_this, params);
        var /** @type {?} */ outerSash = _this.usedProfiles.some(function (el) { return el.type === 'sash' && el.options && el.options.includes('outward_opening'); });
        var /** @type {?} */ outerSide = _this.root.side === 'outer';
        /** math: obliczenie odstępu na szklenie */
        /** math: obliczenie odstępu na szklenie */
        _this.parallelPoly = IccDrawMathService.getParallelPoly(_this.parent.poly, _this.parent.parent.poly);
        _this.parallelPoly.reduce(function (prev, outer, inner) {
            _this.shift[inner] = 0;
            if (Number.isInteger(outer)) {
                var /** @type {?} */ profileId_1 = (_this.parent.parent.profiles[outer] || _this.parent.parent.profiles[0] || {}).profileId;
                var /** @type {?} */ profile = _this.usedProfiles.find(function (o) { return o.id === profileId_1; }) || _this.usedProfiles.find(function (o) { return o.type === (_this.parent.parent.sash ? 'sash' : 'frame'); }) || {};
                _this.parallelProfiles[inner] = profile.id;
                if (_this.parent.parent.sash) {
                    if ((!_this.root.side && outerSash) || outerSide) {
                        _this.shift[inner] -= Number(profile.widthOut) || 60;
                        _this.shift[inner] += isFinite(profile.rebateWidthOut) ? Number(profile.rebateWidthOut) : 0;
                    }
                    else {
                        _this.shift[inner] -= Number(profile.width) || 60;
                        _this.shift[inner] += isFinite(profile.rebateWidth) ? Number(profile.rebateWidth) : 0;
                    }
                }
                else {
                    if ((!_this.root.side && outerSash) || outerSide !== outerSash) {
                        _this.shift[inner] -= Number(profile.widthOut) || 70;
                    }
                    else {
                        _this.shift[inner] -= Number(profile.width) || 45;
                    }
                }
                _this.shift[inner] += Number(profile.spaceGlass) || 45;
            }
            else {
                var /** @type {?} */ profileId_2 = (_this.mullions.find(function (o) { return o.id === _this.sash.nearMullions[outer]; }) || {}).profileId;
                var /** @type {?} */ profile = _this.usedProfiles.find(function (o) { return o.id === profileId_2; }) || _this.usedProfiles.find(function (o) { return o.type === 'divider'; }) || {};
                _this.parallelProfiles[inner] = profile.id;
                if ((!_this.root.side && outerSash) || outerSide !== outerSash) {
                    _this.shift[inner] -= Number(profile.widthOut || 90) / 2;
                }
                else {
                    _this.shift[inner] -= Number(profile.width || 45) / 2;
                }
                _this.shift[inner] += Number(profile.spaceGlass) || 25;
            }
        }, []);
        /** math: obliczenie współrzędnych figury */
        /** math: obliczenie współrzędnych figury */
        _this.poly = IccDrawMathService.getPolyShift(_this.parent.poly, _this.shift);
        _this.rect = IccDrawMathService.getRectFromPoly(_this.poly);
        /** math: wysokość rensona */
        if (_this.renson) {
            var /** @type {?} */ rensonHeight = Number(_this.renson.height) || 100;
            _this.poly = IccDrawMathService.intersectPolyWithLine(_this.poly, [
                { x: _this.rect.x, y: _this.rect.y + rensonHeight },
                { x: _this.rect.x + _this.rect.width, y: _this.rect.y + rensonHeight },
            ], 'bottom');
            _this.rect = IccDrawMathService.getRectFromPoly(_this.poly);
        }
        /** svg: rysowanie ścieżek */
        if (_this.glazing.color && _this.glazing.color[_this.root.side]) {
            _this.svg.patterns.push(IccDrawSvgService.getPattern({
                id: "iccDraw-glazing-" + _this.uuid,
                color: _this.glazing.color[_this.root.side].color
                    ? "#" + _this.glazing.color[_this.root.side].color
                    : '#fff',
                image: _this.glazing.color[_this.root.side].color_img
                    ? "/files/windowcolor/" + _this.glazing.color[_this.root.side].color_img
                    : null,
                height: _this.rect.height,
                width: _this.rect.width,
            }));
            _this.svg.paths.push(IccDrawSvgService.getPath(_this.poly, true, _this.root.side, {
                fill: "url('" + _this.root.uri + "#iccDraw-glazing-" + _this.uuid + "')",
                stroke: '#bbb',
            }));
        }
        else if (_this.glazing.type === 'pvc_panels') {
            _this.svg.paths.push(IccDrawSvgService.getPath(_this.poly, true, _this.root.side, {
                fill: "url('" + _this.root.uri + "#iccDraw-" + (_this.sash && !_this.sash.intSashes ? 'sash' : 'frame') + "-" + _this.root.uuid + "')",
                stroke: '#bbb',
            }));
        }
        else {
            _this.svg.paths.push(IccDrawSvgService.getPath(_this.poly, true, _this.root.side, {
                fill: "url('" + _this.root.uri + "#iccDraw-glazing-" + _this.root.uuid + "')",
                stroke: '#bbb',
            }));
        }
        /** svg: dodatkowe grafiki dla paneli ozdobnych */
        if (_this.glazing.overlay_width && _this.glazing.overlay_height) {
            var /** @type {?} */ overlayRect_1 = {
                x: _this.rect.x,
                y: _this.rect.y,
                width: Number(_this.glazing.overlay_width) || _this.rect.width,
                height: Number(_this.glazing.overlay_height) || _this.rect.height,
            };
            switch (_this.glazing.overlay_position_x) {
                case 'center':
                    overlayRect_1.x -= (overlayRect_1.width - _this.rect.width) / 2;
                    break;
                case 'right':
                    overlayRect_1.x -= overlayRect_1.width - _this.rect.width;
                    break;
            }
            switch (_this.glazing.overlay_position_y) {
                case 'center':
                    overlayRect_1.y -= (overlayRect_1.height - _this.rect.height) / 2;
                    break;
                case 'bottom':
                    overlayRect_1.y -= overlayRect_1.height - _this.rect.height;
                    break;
            }
            if (_this.glazing.overlay_color && _this.glazing.overlay_paths) {
                _this.svg.patterns.push(IccDrawSvgService.getPattern({
                    id: "iccDraw-glazing-overlay-color-" + _this.uuid,
                    color: _this.glazing.overlay_color.inner.color ? "#" + _this.glazing.overlay_color.inner.color : null,
                    image: _this.glazing.overlay_color.inner.color_img ? "/files/windowcolor/" + _this.glazing.overlay_color.inner.color_img : null,
                    height: overlayRect_1.height,
                    width: overlayRect_1.width,
                    x: overlayRect_1.x,
                    y: overlayRect_1.y,
                }));
                var /** @type {?} */ paths = _this.glazing.overlay_paths || [];
                if (paths && !Array.isArray(paths)) {
                    paths = JSON.parse(paths);
                }
                paths.map(function (path) {
                    if (path && !Array.isArray(path)) {
                        path = JSON.parse(path);
                    }
                    var /** @type {?} */ poly = path.map(function (point) {
                        return {
                            x: Number(point[0]) + overlayRect_1.x,
                            y: Number(point[1]) + overlayRect_1.y,
                            cr: point[2],
                            cw: point[3],
                        };
                    });
                    poly = IccDrawMathService.intersectPolyWithRect(poly, _this.rect);
                    _this.svg.paths.push(IccDrawSvgService.getPath(poly, true, _this.root.side, {
                        fill: "url('" + _this.root.uri + "#iccDraw-glazing-overlay-color-" + _this.uuid + "')",
                    }));
                });
            }
            if (_this.glazing.overlay_image) {
                _this.svg.patterns.push(IccDrawSvgService.getPattern({
                    id: "iccDraw-glazing-overlay-image-" + _this.uuid,
                    image: "/files/filling/" + _this.glazing.overlay_image,
                    height: overlayRect_1.height,
                    width: overlayRect_1.width,
                    x: overlayRect_1.x,
                    y: overlayRect_1.y,
                }));
                _this.svg.paths.push(IccDrawSvgService.getPath(_this.poly, true, _this.root.side, {
                    fill: "url('" + _this.root.uri + "#iccDraw-glazing-overlay-image-" + _this.uuid + "')",
                }));
            }
        }
        return _this;
    }
    /**
     * @param {?=} params
     * @return {?}
     */
    GlazingNode.prototype.onClick = /**
     * @param {?=} params
     * @return {?}
     */
    function (params) {
        if (params === void 0) { params = {}; }
        return Object.assign({
            glazing: this.glazing,
            sash: this.sash,
        }, params);
    };
    return GlazingNode;
}(BaseNode));

var __extends$7 = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var GlazingBeadNode = (function (_super) {
    __extends$7(GlazingBeadNode, _super);
    function GlazingBeadNode(parentNode, childrenNodes, params, options) {
        if (parentNode === void 0) { parentNode = null; }
        if (childrenNodes === void 0) { childrenNodes = null; }
        if (params === void 0) { params = {}; }
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, parentNode, childrenNodes, params, options) || this;
        _this.profiles = {};
        _this.sash = {};
        _this.usedProfiles = [];
        _this.parentPoly = [];
        _this.parentRect = {};
        _this.polygons = [];
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(_this, params);
        /**
         * math: obliczenie przesunięcia
         */
        var /** @type {?} */ profile = _this.profiles ? _this.usedProfiles.find(function (o) { return o.id === _this.profiles.profileId; }) : null;
        _this.width = profile ? Number(profile.width) : 20;
        /** math: obliczenie współrzędnych figury */
        /** math: obliczenie współrzędnych figury */
        _this.poly = IccDrawMathService.getPolyShift(_this.parent.poly, _this.width);
        _this.rect = IccDrawMathService.getRectFromPoly(_this.poly);
        /** math: odfiltrowanie zbliżonych punktów */
        /** math: odfiltrowanie zbliżonych punktów */
        _this.poly = _this.poly.filter(function (p, i) { return !i || Math.abs(p.x - _this.poly[i - 1].x) > 3 || Math.abs(p.y - _this.poly[i - 1].y) > 3; });
        /** math: przesunięcie figury względem rodzica */
        /** math: przesunięcie figury względem rodzica */
        _this.parentPoly = IccDrawMathService.getPolyShift(_this.poly, -_this.width);
        _this.parentRect = IccDrawMathService.getRectFromPoly(_this.parentPoly);
        /** math: przygotowanie zestawów profili */
        /** math: przygotowanie zestawów profili */
        _this.polygons = IccDrawMathService.getPolygons(_this.parentPoly, _this.poly);
        /** svg: rysowanie ścieżek */
        for (var _i = 0, _a = _this.polygons; _i < _a.length; _i++) {
            var polygon = _a[_i];
            _this.svg.paths.push(IccDrawSvgService.getPath(polygon, true, _this.root.side, {
                stroke: '#bbb',
                fill: "url('" + _this.root.uri + "#iccDraw-" + (typeof _this.sash.parentId !== 'undefined' ? 'sash' : 'frame') + "-" + _this.root.uuid + "')",
            }));
        }
        return _this;
    }
    /**
     * @param {?=} params
     * @return {?}
     */
    GlazingBeadNode.prototype.onClick = /**
     * @param {?=} params
     * @return {?}
     */
    function (params) {
        if (params === void 0) { params = {}; }
        return Object.assign({
            profiles: this.profiles,
            sash: this.sash,
        }, params);
    };
    return GlazingBeadNode;
}(BaseNode));

var __extends$8 = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var HandleNode = (function (_super) {
    __extends$8(HandleNode, _super);
    function HandleNode(parentNode, childrenNodes, params, options) {
        if (parentNode === void 0) { parentNode = null; }
        if (childrenNodes === void 0) { childrenNodes = null; }
        if (params === void 0) { params = {}; }
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, parentNode, childrenNodes, params, options) || this;
        _this.sash = {};
        _this.sashes = [];
        _this.handle = {
            height: 30,
            width: 80,
        };
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(_this, params);
        var /** @type {?} */ polygons = [];
        var /** @type {?} */ position = {};
        var /** @type {?} */ angle, /** @type {?} */ index, /** @type {?} */ firstLine, /** @type {?} */ secondLine;
        /** math: obliczenie pozycji klamki */
        if (['DS', 'DSC', 'ODS', 'ODSC', 'DRP', 'DOP', 'FD', 'FDO'].indexOf(_this.sash.type.type) === -1) {
            switch (_this.sash.type.handlePosition) {
                case 'L':
                case 'R':
                    position.y = _this.sash.handleHeight
                        ? _this.sash.y + _this.sash.height - _this.sash.handleHeight
                        : (2 * _this.parent.rect.y + _this.parent.rect.height) / 2;
                    firstLine = IccDrawMathService.intersectLineWithPoly([
                        { x: _this.root.rect.x, y: position.y },
                        { x: _this.root.rect.x + _this.root.rect.width, y: position.y },
                    ], _this.parent.parentPoly);
                    secondLine = IccDrawMathService.intersectLineWithPoly([
                        { x: _this.root.rect.x, y: position.y },
                        { x: _this.root.rect.x + _this.root.rect.width, y: position.y },
                    ], _this.parent.poly);
                    index = _this.sash.type.handlePosition === 'L' ? 0 : 1;
                    position.x = Math.ceil((firstLine[index].x + secondLine[index].x) / 2);
                    var /** @type {?} */ adjacentSash = _this.sashes.find(function (el) {
                        return el.y === _this.sash.y && el.height === _this.sash.height && (_this.sash.type.handlePosition === 'L'
                            ? el.x + el.width === _this.sash.x
                            : el.x === _this.sash.x + _this.sash.width);
                    });
                    if (adjacentSash && adjacentSash.type && adjacentSash.type.type === 'DSC') {
                        position.x = _this.sash.x + (_this.sash.type.handlePosition === 'L' ? 0 : _this.sash.width);
                        _this.svg.paths.push(IccDrawSvgService.getPath([
                            { x: position.x - (_this.handle.height), y: _this.parent.parentRect.y + _this.parent.parentRect.height },
                            { x: position.x + (_this.handle.height), y: _this.parent.parentRect.y + _this.parent.parentRect.height },
                            { x: position.x + (_this.handle.height), y: _this.parent.parentRect.y },
                            { x: position.x - (_this.handle.height), y: _this.parent.parentRect.y },
                        ], true, _this.root.side, {
                            stroke: '#bbb',
                            fill: "url('" + _this.root.uri + "#iccDraw-sash-" + _this.root.uuid + "')",
                        }));
                    }
                    break;
                case 'T':
                case 'B':
                    position.x = _this.parent.rect.x + _this.parent.rect.width / 2 + 5;
                    firstLine = IccDrawMathService.intersectLineWithPoly([
                        { x: position.x, y: _this.root.rect.y },
                        { x: position.x, y: _this.root.rect.y + _this.root.rect.height },
                    ], _this.parent.parentPoly);
                    secondLine = IccDrawMathService.intersectLineWithPoly([
                        { x: position.x, y: _this.root.rect.y },
                        { x: position.x, y: _this.root.rect.y + _this.root.rect.height },
                    ], _this.parent.poly);
                    index = _this.sash.type.handlePosition === 'T' ? 0 : 1;
                    var /** @type {?} */ firstY = _this.parent.parentPoly.length === 3 && _this.parent.parentPoly[2].x === _this.parent.sash.width / 2
                        ? _this.parent.parentPoly[2].y
                        : firstLine[index].y
                            ? firstLine[index].y
                            : secondLine[index].y
                                ? secondLine[index].y - (_this.parent.width.reduce(function (a, b) { return a + b; }, 0) / _this.parent.width.length || 60)
                                : (_this.parent.parentRect.y + (_this.sash.type.handlePosition === 'T' ? 0 : _this.parent.parentRect.height));
                    var /** @type {?} */ secondY = _this.parent.poly.length === 3 && _this.parent.poly[2].x === _this.parent.sash.width / 2
                        ? _this.parent.poly[2].y
                        : secondLine[index].y
                            ? secondLine[index].y
                            : firstLine[index].y
                                ? firstLine[index].y + (_this.parent.width.reduce(function (a, b) { return a + b; }, 0) / _this.parent.width.length || 60)
                                : (_this.parent.rect.y + (_this.sash.type.handlePosition === 'T' ? 0 : _this.parent.rect.height));
                    position.y = Math.ceil((firstY + secondY) / 2);
                    break;
            }
        }
        if (position.x && position.y) {
            /** math: obrócenie klamki wg profilu ramy skrzydła */
            switch (_this.sash.type.handlePosition) {
                case 'L':
                case 'R':
                    firstLine = IccDrawMathService.intersectLineWithPoly([
                        { x: _this.parent.rect.x, y: position.y - 20 },
                        { x: _this.parent.rect.x + _this.parent.rect.width, y: position.y - 20 },
                    ], _this.parent.parentPoly);
                    secondLine = IccDrawMathService.intersectLineWithPoly([
                        { x: _this.parent.rect.x, y: position.y + 20 },
                        { x: _this.parent.rect.x + _this.parent.rect.width, y: position.y + 20 },
                    ], _this.parent.parentPoly);
                    index = _this.sash.type.handlePosition === 'L' ? 0 : 1;
                    break;
                case 'T':
                case 'B':
                    firstLine = IccDrawMathService.intersectLineWithPoly([
                        { x: position.x - 20, y: _this.parent.rect.y },
                        { x: position.x - 20, y: _this.parent.rect.y + _this.parent.rect.height },
                    ], _this.parent.parentPoly);
                    secondLine = IccDrawMathService.intersectLineWithPoly([
                        { x: position.x + 20, y: _this.parent.rect.y },
                        { x: position.x + 20, y: _this.parent.rect.y + _this.parent.rect.height },
                    ], _this.parent.parentPoly);
                    index = _this.sash.type.handlePosition === 'T' ? 0 : 1;
                    break;
            }
            angle = IccDrawMathService.getLineInfo([firstLine[index], secondLine[index]]).angle;
            /** math: rysowanie klamki */
            polygons.push(IccDrawMathService.rotatePoly([
                { x: position.x - (_this.handle.width / 2), y: position.y + (_this.handle.height / 2) },
                { x: position.x + (_this.handle.width / 2), y: position.y + (_this.handle.height / 2) },
                { x: position.x + (_this.handle.width / 2), y: position.y - (_this.handle.height / 2) },
                { x: position.x - (_this.handle.width / 2), y: position.y - (_this.handle.height / 2) },
            ], position, angle));
            if (_this.sash.type.type === 'DRA' || _this.sash.type.type === 'DOA') {
                angle += _this.sash.type.handlePosition === 'L' ? -0.5 : 0.5;
            }
            else if (_this.sash.type.type === 'HS') {
                angle += 1;
            }
            polygons.push(IccDrawMathService.rotatePoly([
                { x: position.x - (_this.handle.height / 3), y: position.y + (_this.handle.height * 1 / 3) },
                { x: position.x + (_this.handle.width * 5 / 3), y: position.y + (_this.handle.height * 1 / 3) },
                { x: position.x + (_this.handle.width * 5 / 3), y: position.y - (_this.handle.height / 3) },
                { x: position.x - (_this.handle.height / 3), y: position.y - (_this.handle.height / 3) },
            ], position, angle));
        }
        /** svg: rysowanie ścieżek */
        for (var _i = 0, polygons_1 = polygons; _i < polygons_1.length; _i++) {
            var polygon = polygons_1[_i];
            _this.svg.paths.push(IccDrawSvgService.getPath(polygon, true, _this.root.side, {
                stroke: '#bbb',
                fill: '#fff',
            }));
        }
        return _this;
    }
    return HandleNode;
}(BaseNode));

var __extends$9 = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var IndexesNode = (function (_super) {
    __extends$9(IndexesNode, _super);
    function IndexesNode(parentNode, childrenNodes, params, options) {
        if (parentNode === void 0) { parentNode = null; }
        if (childrenNodes === void 0) { childrenNodes = null; }
        if (params === void 0) { params = {}; }
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, parentNode, childrenNodes, params, options) || this;
        _this.indexes = [];
        _this.nodes = [];
        _this.sashes = [];
        _this.multiplier = 1;
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(_this, params);
        _this.multiplier = Math.max(_this.root.rect.width - _this.root.rect.x, _this.root.rect.height - _this.root.rect.y) * (_this.options.multiplier || 1);
        /** node: znalezienie wszystkich pól */
        /** node: znalezienie wszystkich pól */
        _this.nodes = _this.getNodes(_this.root, _this.root.side);
        /** node: przygotowanie indeksów */
        /** node: przygotowanie indeksów */
        _this.nodes.map(function (node) {
            var /** @type {?} */ sash = null;
            var /** @type {?} */ value = node.sash.index;
            if (typeof node.sash.parentId !== 'undefined') {
                sash = _this.sashes.find(function (e) { return e.id === node.sash.parentId; });
                if (sash.intSashes && sash.intSashes.length > 1 && sash.index != null && node.sash.index != null) {
                    value = sash.index + "." + node.sash.index;
                }
                else if (sash.index != null) {
                    value = sash.index;
                }
            }
            if (value != null) {
                var /** @type {?} */ x = node.rect.x + node.rect.width - 50;
                if (_this.root.side === 'outer') {
                    x = -node.rect.x - 50;
                }
                _this.indexes.push({
                    x: x,
                    y: node.rect.y + node.rect.height - 50,
                    value: value,
                });
            }
        });
        /** svg: rysowanie indeksów */
        /** svg: rysowanie indeksów */
        _this.indexes.map(function (index) {
            _this.svg.texts.push(IccDrawSvgService.getText(index, {
                fill: '#000',
                fontSize: Math.round(_this.multiplier / 35),
                dominantBaseline: 'baseline',
                textAnchor: 'end',
            }));
        });
        return _this;
    }
    /**
     * @param {?} node
     * @param {?} side
     * @param {?=} data
     * @return {?}
     */
    IndexesNode.prototype.getNodes = /**
     * @param {?} node
     * @param {?} side
     * @param {?=} data
     * @return {?}
     */
    function (node, side, data) {
        var _this = this;
        if (data === void 0) { data = []; }
        if (node.constructor.name === 'GlazingNode') {
            data.push(node);
        }
        node.children.map(function (child) { return data = _this.getNodes(child, side, data); });
        return data;
    };
    return IndexesNode;
}(BaseNode));

var __extends$10 = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var MullionNode = (function (_super) {
    __extends$10(MullionNode, _super);
    function MullionNode(parentNode, childrenNodes, params, options) {
        if (parentNode === void 0) { parentNode = null; }
        if (childrenNodes === void 0) { childrenNodes = null; }
        if (params === void 0) { params = {}; }
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, parentNode, childrenNodes, params, options) || this;
        _this.mullion = {};
        _this.mullions = [];
        _this.sash = {};
        _this.sashes = [];
        _this.sashNodes = [];
        _this.usedProfiles = [];
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(_this, params);
        var /** @type {?} */ mullionProfile = _this.usedProfiles.find(function (o) { return o.id === _this.mullion.profileId; }) || _this.usedProfiles.find(function (o) { return o.type === 'divider'; }) || {};
        var /** @type {?} */ outerSash = _this.usedProfiles.some(function (el) { return el.type === 'sash' && el.optinos && el.options.includes('outward_opening'); });
        var /** @type {?} */ outerSide = _this.root.side === 'outer';
        if ((!_this.root.side && outerSash) || outerSide !== outerSash) {
            _this.width = Number(mullionProfile.widthOut || 90);
        }
        else {
            _this.width = Number(mullionProfile.width || 45);
        }
        /**
         * math: znalezienie sąsiadujących słupków
         */
        var /** @type {?} */ shift = { top: 0, left: 0, right: 0, bottom: 0 };
        if (_this.mullion.direction === 'vertical') {
            shift.top = _this.mullions.filter(function (o) {
                return o.direction === 'horizontal'
                    && o.perpendicularMullions.bottom.filter(function (id) { return id === _this.mullion.id; }).length > 0;
            }).length > 0 ? _this.width / 2 : 0;
            shift.bottom = _this.mullions.filter(function (o) {
                return o.direction === 'horizontal'
                    && o.perpendicularMullions.top.filter(function (id) { return id === _this.mullion.id; }).length > 0;
            }).length > 0 ? _this.width / 2 : 0;
        }
        if (_this.mullion.direction === 'horizontal') {
            shift.left = _this.mullions.filter(function (o) {
                return o.direction === 'vertical'
                    && o.perpendicularMullions.right.filter(function (id) { return id === _this.mullion.id; }).length > 0;
            }).length > 0 ? _this.width / 2 : 0;
            shift.right = _this.mullions.filter(function (o) {
                return o.direction === 'vertical'
                    && o.perpendicularMullions.left.filter(function (id) { return id === _this.mullion.id; }).length > 0;
            }).length > 0 ? _this.width / 2 : 0;
        }
        /** math: obliczenie wymiarów słupka */
        /** math: obliczenie wymiarów słupka */
        _this.rect.x = _this.mullion.direction === 'vertical'
            ? _this.mullion.position - (_this.width / 2)
            : _this.mullion.adjacentSashes.top.reduce(function (prev, sId) {
                var /** @type {?} */ adjacentSash = _this.sashes.filter(function (s) { return s.id === sId; });
                return adjacentSash.length > 0 && prev > adjacentSash[0].x ? adjacentSash[0].x : prev;
            }, Number.MAX_VALUE);
        _this.rect.y = _this.mullion.direction === 'horizontal'
            ? _this.mullion.position - (_this.width / 2)
            : _this.mullion.adjacentSashes.left.reduce(function (prev, sId) {
                var /** @type {?} */ adjacentSash = _this.sashes.filter(function (s) { return s.id === sId; });
                return adjacentSash.length > 0 && prev > adjacentSash[0].y ? adjacentSash[0].y : prev;
            }, Number.MAX_VALUE);
        _this.rect.x += _this.parent.parent.rect.x;
        _this.rect.y += _this.parent.parent.rect.y;
        _this.rect.width = _this.mullion.direction === 'horizontal' ? _this.mullion.length : _this.width;
        _this.rect.height = _this.mullion.direction === 'vertical' ? _this.mullion.length : _this.width;
        /** math: obliczenie części wspólnej figur */
        /** math: obliczenie części wspólnej figur */
        _this.rect = IccDrawMathService.getRectShift(_this.rect, shift);
        _this.poly = IccDrawMathService.intersectPolyWithRect(_this.parent.poly, _this.rect);
        _this.rect = IccDrawMathService.getRectFromPoly(_this.poly);
        var _a = _this.getMullionPosition(), positionMin = _a.positionMin, positionMax = _a.positionMax, prev = _a.prev, next = _a.next;
        _this.positionMin = positionMin;
        _this.positionMax = positionMax;
        _this.prev = prev;
        _this.next = next;
        /** svg: rysowanie ścieżek */
        /** svg: rysowanie ścieżek */
        _this.svg.paths.push(IccDrawSvgService.getPath(_this.poly, true, _this.root.side, {
            stroke: '#bbb',
            fill: "url('" + _this.root.uri + "#iccDraw-" + (_this.sash ? 'sash' : 'frame') + "-" + _this.root.uuid + "')",
        }));
        return _this;
    }
    /**
     * @param {?=} params
     * @return {?}
     */
    MullionNode.prototype.onClick = /**
     * @param {?=} params
     * @return {?}
     */
    function (params) {
        if (params === void 0) { params = {}; }
        return Object.assign({
            mullion: this.mullion,
            sash: this.sash,
        }, params);
    };
    /**
     * @param {?=} params
     * @return {?}
     */
    MullionNode.prototype.onMove = /**
     * @param {?=} params
     * @return {?}
     */
    function (params) {
        if (params === void 0) { params = {}; }
        return Object.assign({
            min: this.options.minPosition || 0,
            max: this.options.maxPosition || null,
            positionMin: this.positionMin,
            positionMax: this.positionMax,
            prev: this.mullion.position - this.prev,
            next: this.next - this.mullion.position,
            direction: this.mullion.direction,
            position: this.mullion.position,
            mullion: this.mullion,
            rect: this.parent.parent.rect,
            sash: this.sash,
            shift: this.parent.parent.rect,
        }, params);
    };
    /**
     * @return {?}
     */
    MullionNode.prototype.getMullionPosition = /**
     * @return {?}
     */
    function () {
        var _this = this;
        var /** @type {?} */ sides = this.mullion.direction === 'vertical' ? ['left', 'right'] : ['top', 'bottom'];
        var /** @type {?} */ field = this.mullion.direction === 'vertical' ? ['x', 'width'] : ['y', 'height'];
        var /** @type {?} */ prev = Math.max.apply(Math, this.sashes
            .filter(function (sash) { return _this.mullion.adjacentSashes[sides[0]].includes(sash.id); })
            .map(function (sash) {
            if (sash.intMullions && sash.intMullions.some(function (mullion) { return mullion.direction === _this.mullion.direction; })) {
                return sash[field[0]] + Math.max.apply(Math, sash.intMullions.filter(function (mullion) { return mullion.direction === _this.mullion.direction; }).map(function (mullion) { return mullion.position; }));
            }
            else if (sash.nearMullions && sash.nearMullions[sides[0]] !== -1) {
                return _this.mullions.find(function (o) { return o.id === sash.nearMullions[sides[0]]; }).position;
            }
            else {
                return sash[field[0]];
            }
        }));
        var /** @type {?} */ positionMinNodes = this.sashes
            .filter(function (sash) { return _this.mullion.adjacentSashes[sides[0]].includes(sash.id); })
            .map(function (sash) { return _this.sashNodes.find(function (s) { return s.sash.id === sash.id; }); })
            .filter(function (node) { return node; })
            .reduce(function (acu, node) {
            acu.push.apply(acu, _this.getGlazingNodes(node));
            return acu;
        }, []);
        var /** @type {?} */ positionMin = positionMinNodes.reduce(function (acu, node) {
            return acu[1] < node.glazingBead.rect[field[0]] ?
                [
                    node.glazingBead.rect[field[0]] - node.sash.rect[field[0]],
                    node.glazingBead.rect[field[0]]
                ] : acu;
        }, [0, 0])[0]
            + positionMinNodes.reduce(function (acu, node) {
                return acu[1] < node.glazingBead.rect[field[0]] ?
                    [
                        (node.sash.rect[field[0]] + node.sash.rect[field[1]] - node.glazingBead.rect[field[0]] - node.glazingBead.rect[field[1]]),
                        node.glazingBead.rect[field[0]]
                    ] : acu;
            }, [0, 0])[0];
        var /** @type {?} */ next = Math.min.apply(Math, this.sashes
            .filter(function (sash) { return _this.mullion.adjacentSashes[sides[1]].includes(sash.id); })
            .map(function (sash) {
            if (sash.intMullions && sash.intMullions.some(function (mullion) { return mullion.direction === _this.mullion.direction; })) {
                return sash[field[0]] + Math.min.apply(Math, sash.intMullions.filter(function (mullion) { return mullion.direction === _this.mullion.direction; }).map(function (mullion) { return mullion.position; }));
            }
            else if (sash.nearMullions && sash.nearMullions[sides[1]] !== -1) {
                return _this.mullions.find(function (o) { return o.id === sash.nearMullions[sides[1]]; }).position;
            }
            else {
                return sash[field[0]] + sash[field[1]];
            }
        }));
        var /** @type {?} */ positionMaxNodes = this.sashes
            .filter(function (sash) { return _this.mullion.adjacentSashes[sides[1]].includes(sash.id); })
            .map(function (sash) { return _this.sashNodes.find(function (s) { return s.sash.id === sash.id; }); })
            .filter(function (node) { return node; })
            .reduce(function (acu, node) {
            acu.push.apply(acu, _this.getGlazingNodes(node));
            return acu;
        }, []);
        var /** @type {?} */ positionMax = positionMaxNodes.reduce(function (acu, node) {
            return acu[1] > node.glazingBead.rect[field[0]] ?
                [
                    (node.glazingBead.rect[field[0]] - node.sash.rect[field[0]]),
                    node.glazingBead.rect[field[0]]
                ] : acu;
        }, [0, Number.MAX_SAFE_INTEGER])[0]
            + positionMaxNodes.reduce(function (acu, node) {
                return acu[1] > node.glazingBead.rect[field[0]] ?
                    [
                        (node.sash.rect[field[0]] + node.sash.rect[field[1]] - node.glazingBead.rect[field[0]] - node.glazingBead.rect[field[1]]),
                        node.glazingBead.rect[field[0]]
                    ] : acu;
            }, [0, Number.MAX_SAFE_INTEGER])[0];
        return { positionMin: positionMin, positionMax: positionMax, prev: prev, next: next };
    };
    /**
     * @param {?} node
     * @param {?=} data
     * @param {?=} sashNode
     * @return {?}
     */
    MullionNode.prototype.getGlazingNodes = /**
     * @param {?} node
     * @param {?=} data
     * @param {?=} sashNode
     * @return {?}
     */
    function (node, data, sashNode) {
        var _this = this;
        if (data === void 0) { data = []; }
        if (sashNode === void 0) { sashNode = null; }
        if (node.constructor.name === 'SashNode') {
            sashNode = node;
        }
        if (node.constructor.name === 'GlazingBeadNode') {
            data.push({
                glazingBead: node,
                sash: sashNode
            });
        }
        node.children.map(function (child) { return (data = _this.getGlazingNodes(child, data, sashNode)); });
        return data;
    };
    return MullionNode;
}(BaseNode));

var __extends$11 = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var MuntinNode = (function (_super) {
    __extends$11(MuntinNode, _super);
    function MuntinNode(parentNode, childrenNodes, params, options) {
        if (parentNode === void 0) { parentNode = null; }
        if (childrenNodes === void 0) { childrenNodes = null; }
        if (params === void 0) { params = {}; }
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, parentNode, childrenNodes, params, options) || this;
        _this.muntins = {};
        _this.muntin = {};
        _this.sash = {};
        _this.system = {};
        _this.size = 10;
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(_this, params);
        _this.size = Number(_this.muntins.size) || _this.size;
        /** math: obliczenie współrzędnych figury */
        /** math: obliczenie współrzędnych figury */
        _this.getMuntinPoly();
        _this.poly.map(function (point) {
            point.x += _this.parent.rect.x;
            point.y += _this.parent.rect.y;
        });
        _this.poly = IccDrawMathService.intersectLineWithPoly(_this.poly, _this.parent.poly);
        _this.rect = IccDrawMathService.getRectFromPoly(_this.poly);
        /** svg: rysowanie ścieżek */
        /** svg: rysowanie ścieżek */
        _this.svg.paths.push(IccDrawSvgService.getPath(_this.poly, false, _this.root.side, {
            stroke: "url('" + _this.root.uri + "#iccDraw-muntins-" + _this.root.uuid + "')",
            strokeWidth: Math.ceil(_this.size / 2),
            vectorEffect: 'none',
        }));
        return _this;
    }
    /**
     * @param {?=} params
     * @return {?}
     */
    MuntinNode.prototype.onClick = /**
     * @param {?=} params
     * @return {?}
     */
    function (params) {
        if (params === void 0) { params = {}; }
        return Object.assign({
            muntin: this.muntin,
            sash: this.sash,
        }, params);
    };
    /**
     * @param {?=} params
     * @return {?}
     */
    MuntinNode.prototype.onMove = /**
     * @param {?=} params
     * @return {?}
     */
    function (params) {
        if (params === void 0) { params = {}; }
        var /** @type {?} */ glazingBeadNode = this.parent.children.find(function (o) { return o.constructor.name === 'GlazingBeadNode'; });
        var /** @type {?} */ direction = this.muntin.direction || (this.muntin.start && this.muntin.end ? (this.muntin.start.x === this.muntin.end.x ? 'vertical' :
            this.muntin.start.y === this.muntin.end.y ? 'horizontal' :
                null) : null);
        var /** @type {?} */ position = this.muntin.positionInSash || (direction ? (direction === 'vertical' ? this.muntin.start.x :
            direction === 'horizontal' ? this.muntin.start.y :
                null) : null);
        return Object.assign({
            min: this.options.minPosition || 0,
            max: this.options.maxPosition || null,
            positionMin: 0,
            positionMax: 0,
            prev: position,
            next: this.sash[direction === 'vertical' ? 'width' : 'height'] - position,
            direction: direction,
            position: position,
            muntin: this.muntin,
            rect: this.parent.rect,
            sash: this.sash,
            shift: glazingBeadNode ? glazingBeadNode.rect : this.parent.rect,
        }, params);
    };
    /**
     * @return {?}
     */
    MuntinNode.prototype.getMuntinPoly = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.muntin.direction) {
            this.poly = [
                {
                    x: this.muntin.direction === 'vertical' ? this.muntin.positionInSash : 0,
                    y: this.muntin.direction === 'horizontal' ? this.muntin.positionInSash : 0,
                },
                {
                    x: this.muntin.direction === 'vertical' ? this.muntin.positionInSash : this.parent.rect.width,
                    y: this.muntin.direction === 'horizontal' ? this.muntin.positionInSash : this.parent.rect.height,
                },
            ];
            if (Number.isInteger(this.muntin.startPinPoint)) {
                this.poly[0][this.muntin.direction === 'horizontal' ? 'x' : 'y'] =
                    this.sash.muntins[this.muntin.direction === 'horizontal' ? 'vertical' : 'horizontal']
                        .find(function (el) { return el.id === _this.muntin.startPinPoint; }).positionInSash;
            }
            if (Number.isInteger(this.muntin.endPinPoint)) {
                this.poly[1][this.muntin.direction === 'horizontal' ? 'x' : 'y'] =
                    this.sash.muntins[this.muntin.direction === 'horizontal' ? 'vertical' : 'horizontal']
                        .find(function (el) { return el.id === _this.muntin.endPinPoint; }).positionInSash;
            }
        }
        else {
            this.poly = [
                Object.assign({}, this.muntin.start),
                Object.assign({}, this.muntin.end),
            ];
        }
    };
    return MuntinNode;
}(BaseNode));

var __extends$12 = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var RenoNode = (function (_super) {
    __extends$12(RenoNode, _super);
    function RenoNode(parentNode, childrenNodes, params, options) {
        if (parentNode === void 0) { parentNode = null; }
        if (childrenNodes === void 0) { childrenNodes = null; }
        if (params === void 0) { params = {}; }
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, parentNode, childrenNodes, params, options) || this;
        _this.lowThreshold = false;
        _this.profiles = [];
        _this.usedProfiles = [];
        _this.shift = [];
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(_this, params);
        _this.setProfiles();
        var /** @type {?} */ frameNodes = _this.getFrameNodes(_this.root);
        _this.rect = _this.parent.rect;
        _this.poly = _this.parent.poly;
        if (_this.usedProfiles.some(function (el) { return el.options && el.options.indexOf('renovation_frame') !== -1; })) {
            /** math: przesunięcie względem bazowej figury */
            for (var /** @type {?} */ i = 0; i < frameNodes[0].parent.poly.length; i++) {
                var /** @type {?} */ frame = _this.profiles[i] || _this.profiles[0] || {};
                _this.shift[i] = -Number(frame.finWidth || 0);
            }
            /** math: obliczenie współrzędnych figury */
            /** math: obliczenie współrzędnych figury */
            _this.poly = IccDrawMathService.getPolyShift(frameNodes[0].parent.poly, _this.shift);
            _this.rect = IccDrawMathService.getRectFromPoly(IccDrawMathService.getPolyShift(_this.parent.poly, _this.shift));
            /** svg: rysowanie ścieżek */
            /** svg: rysowanie ścieżek */
            _this.svg.paths.push(IccDrawSvgService.getPath(_this.poly, true, _this.root.side, {
                stroke: '#bbb',
                strokeDasharray: '5,5',
            }));
        }
        return _this;
    }
    /**
     * @return {?}
     */
    RenoNode.prototype.setProfiles = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (!Array.isArray(this.profiles) || !this.profiles.length) {
            this.profiles = this.parent.poly.map(function () { return {}; });
        }
        if (this.profiles.length && this.profiles.length < this.parent.poly.length) {
            var /** @type {?} */ profiles_1 = [];
            this.parent.poly.forEach(function (v, i) { return profiles_1.push(_this.profiles[i] || _this.profiles[i - 1] || _this.profiles[0]); });
            this.profiles = profiles_1;
        }
    };
    /**
     * @param {?} node
     * @param {?=} data
     * @return {?}
     */
    RenoNode.prototype.getFrameNodes = /**
     * @param {?} node
     * @param {?=} data
     * @return {?}
     */
    function (node, data) {
        var _this = this;
        if (data === void 0) { data = []; }
        if (node.constructor.name === 'FrameNode') {
            data.push(node);
        }
        node.children.map(function (child) { return (data = _this.getFrameNodes(child, data)); });
        return data;
    };
    return RenoNode;
}(BaseNode));

var __extends$13 = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var RensonNode = (function (_super) {
    __extends$13(RensonNode, _super);
    function RensonNode(parentNode, childrenNodes, params, options) {
        if (parentNode === void 0) { parentNode = null; }
        if (childrenNodes === void 0) { childrenNodes = null; }
        if (params === void 0) { params = {}; }
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, parentNode, childrenNodes, params, options) || this;
        _this.stripes = {
            polygons: [],
            poly: [],
            rect: {},
        };
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(_this, params);
        _this.rect = IccDrawMathService.getRectFromPoly(_this.parent.poly);
        _this.rect.height = Number(_this.renson.height) || 100;
        _this.poly = IccDrawMathService.intersectPolyWithRect(_this.parent.poly, _this.rect);
        /** math: poziome paski w rensonie */
        /** math: poziome paski w rensonie */
        _this.stripes.poly = IccDrawMathService.getPolyShift(_this.poly, Math.round(_this.rect.height / 5));
        _this.stripes.rect = IccDrawMathService.getRectFromPoly(_this.stripes.poly);
        _this.stripes.polygons = [];
        [_this.stripes.rect.height / 4, _this.stripes.rect.height / 2, _this.stripes.rect.height * 3 / 4].map(function (height) {
            _this.stripes.polygons.push(IccDrawMathService.intersectPolyWithRect(_this.stripes.poly, {
                x: _this.stripes.rect.x,
                y: _this.stripes.rect.y + height,
                width: _this.stripes.rect.width,
                height: 0,
            }));
        });
        /** svg: rysowanie ścieżek */
        /** svg: rysowanie ścieżek */
        _this.svg.paths.push(IccDrawSvgService.getPath(_this.poly, true, _this.root.side, {
            stroke: '#bbb',
            fill: "#fff",
        }));
        _this.stripes.polygons.map(function (polygon) {
            _this.svg.paths.push(IccDrawSvgService.getPath(polygon, false, _this.root.side, {
                stroke: '#bbb',
                strokeDasharray: '5,5',
            }));
        });
        return _this;
    }
    /**
     * @param {?=} params
     * @return {?}
     */
    RensonNode.prototype.onClick = /**
     * @param {?=} params
     * @return {?}
     */
    function (params) {
        if (params === void 0) { params = {}; }
        return Object.assign({
            sash: this.sash,
        }, params);
    };
    return RensonNode;
}(BaseNode));

var __extends$14 = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var RollerShutterNode = (function (_super) {
    __extends$14(RollerShutterNode, _super);
    function RollerShutterNode(parentNode, childrenNodes, params, options) {
        if (parentNode === void 0) { parentNode = null; }
        if (childrenNodes === void 0) { childrenNodes = null; }
        if (params === void 0) { params = {}; }
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, parentNode, childrenNodes, params, options) || this;
        _this.rollerShutter = {};
        _this.stripes = {
            polygons: [],
            poly: [],
            rect: {},
        };
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(_this, params);
        _this.rect = _this.parent.rect;
        _this.poly = _this.parent.poly;
        if (_this.rollerShutter) {
            /** math: obliczenie współrzędnych figury */
            /** math: obliczenie współrzędnych figury */
            _this.rect = IccDrawMathService.getRectShift(_this.parent.rect, { top: -_this.rollerShutter.boxHeight });
            _this.poly = IccDrawMathService.getPolyFromRect(_this.rect);
            _this.poly.push(_this.poly.shift());
            /** math: poziome paski w rensonie */
            /** math: poziome paski w rensonie */
            _this.stripes.rect = Object.assign({}, _this.rect);
            _this.stripes.rect.height = _this.rollerShutter.boxHeight;
            _this.stripes.poly = IccDrawMathService.getPolyFromRect(_this.stripes.rect);
            _this.stripes.poly = IccDrawMathService.getPolyShift(_this.stripes.poly, Math.round(_this.stripes.rect.height / 4));
            _this.stripes.rect = IccDrawMathService.getRectFromPoly(_this.stripes.poly);
            _this.stripes.polygons = [];
            [0, _this.stripes.rect.height / 2, _this.stripes.rect.height].map(function (height) {
                _this.stripes.polygons.push(IccDrawMathService.intersectPolyWithRect(_this.stripes.poly, {
                    x: _this.stripes.rect.x,
                    y: _this.stripes.rect.y + height,
                    width: _this.stripes.rect.width,
                    height: 0,
                }));
            });
            /** svg: rysowanie ścieżek */
            /** svg: rysowanie ścieżek */
            _this.svg.paths.push(IccDrawSvgService.getPath(_this.poly, true, _this.root.side, {
                stroke: '#bbb',
                fill: "#fff",
            }));
            _this.stripes.polygons.map(function (polygon) {
                _this.svg.paths.push(IccDrawSvgService.getPath(polygon, false, _this.root.side, {
                    stroke: '#bbb',
                    strokeDasharray: '5,5',
                }));
            });
        }
        return _this;
    }
    /**
     * @param {?=} params
     * @return {?}
     */
    RollerShutterNode.prototype.onClick = /**
     * @param {?=} params
     * @return {?}
     */
    function (params) {
        if (params === void 0) { params = {}; }
        return Object.assign({
            rollerShutter: this.rollerShutter,
        }, params);
    };
    return RollerShutterNode;
}(BaseNode));

var __extends$15 = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var SashNode = (function (_super) {
    __extends$15(SashNode, _super);
    function SashNode(parentNode, childrenNodes, params, options) {
        if (parentNode === void 0) { parentNode = null; }
        if (childrenNodes === void 0) { childrenNodes = null; }
        if (params === void 0) { params = {}; }
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, parentNode, childrenNodes, params, options) || this;
        _this.alignments = [];
        _this.mullions = [];
        _this.sash = {};
        _this.usedProfiles = [];
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(_this, params);
        /** math: obliczenie współrzędnych figury */
        /** math: obliczenie współrzędnych figury */
        _this.rect.x = _this.parent.parent.rect.x + _this.sash.x;
        _this.rect.y = _this.parent.parent.rect.y + _this.sash.y;
        _this.rect.width = _this.sash.width;
        _this.rect.height = _this.sash.height;
        /**
         * math: odcięcie sąsiadujących słupków i wyrównań
         */
        var /** @type {?} */ rect = IccDrawMathService.getRectShift(_this.rect, _this.getMullionsShift());
        _this.poly = IccDrawMathService.intersectPolyWithRect(_this.parent.poly, rect);
        _this.poly = IccDrawMathService.getPolyShift(_this.poly, _this.getAlignmentsShift());
        // this.svg.paths.push(IccDrawSvgService.getPath(this.poly, true, this.root.side, { fill: '#' + ((1<<24)*Math.random()|0).toString(16) }));
        return _this;
    }
    /**
     * @param {?=} params
     * @return {?}
     */
    SashNode.prototype.onClick = /**
     * @param {?=} params
     * @return {?}
     */
    function (params) {
        if (params === void 0) { params = {}; }
        return Object.assign({
            sash: this.sash,
        }, params);
    };
    /**
     * @return {?}
     */
    SashNode.prototype.getAlignmentsShift = /**
     * @return {?}
     */
    function () {
        var _this = this;
        var /** @type {?} */ shift = { top: 0, left: 0, right: 0, bottom: 0 };
        if (this.sash.nearAlignments) {
            Object.keys(this.sash.nearAlignments).map(function (side) {
                if (_this.sash.nearAlignments[side] !== -1) {
                    shift[side] += _this.getAlignmentShift(_this.sash.nearAlignments[side], side);
                }
            });
        }
        return shift;
    };
    /**
     * @param {?} alignmentId
     * @param {?} side
     * @return {?}
     */
    SashNode.prototype.getAlignmentShift = /**
     * @param {?} alignmentId
     * @param {?} side
     * @return {?}
     */
    function (alignmentId, side) {
        var /** @type {?} */ alignment = this.alignments.find(function (o) { return o.id === alignmentId; }) || {};
        var /** @type {?} */ alignmentProfile = this.usedProfiles.find(function (o) { return o.id === alignment.profileId; }) || {};
        var /** @type {?} */ shift;
        if (this.root.side !== 'outer') {
            shift = Number(alignmentProfile.width) || 45;
        }
        else {
            shift = Number(alignmentProfile.widthOut) || 45;
        }
        if (alignment && alignment.id) {
            if (alignment.parallelAlignments[side] && alignment.parallelAlignments[side].length) {
                shift += this.getAlignmentShift(alignment.parallelAlignments[side][0], side);
            }
            if (alignment.parallelMullions[side] && alignment.parallelMullions[side].length) {
                shift += this.getMullionShift(alignment.parallelMullions[side][0], side);
            }
        }
        return shift;
    };
    /**
     * @return {?}
     */
    SashNode.prototype.getMullionsShift = /**
     * @return {?}
     */
    function () {
        var _this = this;
        var /** @type {?} */ shift = { top: 0, left: 0, right: 0, bottom: 0 };
        if (this.sash.nearMullions) {
            Object.keys(this.sash.nearMullions).map(function (side) {
                if (_this.sash.nearMullions[side] !== -1) {
                    shift[side] += _this.getMullionShift(_this.sash.nearMullions[side], side);
                }
            });
        }
        return shift;
    };
    /**
     * @param {?} mullionId
     * @param {?} side
     * @return {?}
     */
    SashNode.prototype.getMullionShift = /**
     * @param {?} mullionId
     * @param {?} side
     * @return {?}
     */
    function (mullionId, side) {
        var /** @type {?} */ mullion = this.mullions.find(function (o) { return o.id === mullionId; }) || {};
        var /** @type {?} */ mullionProfile = this.usedProfiles.find(function (o) { return o.id === mullion.profileId; }) || this.usedProfiles.find(function (o) { return o.type === 'divider'; }) || {};
        if (this.root.side !== 'outer') {
            return (Number(mullionProfile.width) || 45) / 2;
        }
        else {
            return (Number(mullionProfile.widthOut) || 90) / 2;
        }
    };
    return SashNode;
}(BaseNode));

var __extends$16 = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var SashFrameNode = (function (_super) {
    __extends$16(SashFrameNode, _super);
    function SashFrameNode(parentNode, childrenNodes, params, options) {
        if (parentNode === void 0) { parentNode = null; }
        if (childrenNodes === void 0) { childrenNodes = null; }
        if (params === void 0) { params = {}; }
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, parentNode, childrenNodes, params, options) || this;
        _this.frame = [];
        _this.lowThreshold = false;
        _this.mullions = [];
        _this.profiles = [];
        _this.sash = {};
        _this.usedProfiles = [];
        _this.polygons = [];
        _this.shift = [];
        _this.width = [];
        _this.parallelPoly = [];
        _this.parallelProfiles = [];
        _this.parentPoly = [];
        _this.parentRect = {};
        _this.sides = {
            'L': 'left',
            'R': 'right',
        };
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(_this, params);
        /** class: przygotowanie zestawu profili  */
        /** class: przygotowanie zestawu profili  */
        _this.setProfiles();
        var /** @type {?} */ outerSash = _this.usedProfiles.some(function (el) { return el.type === 'sash' && el.options && el.options.includes('outward_opening'); });
        var /** @type {?} */ outerSide = _this.root.side === 'outer';
        /** math: obliczenie odstępu na skrzydło */
        /** math: obliczenie odstępu na skrzydło */
        _this.parallelPoly = IccDrawMathService.getParallelPoly(_this.parent.poly, _this.parent.parent.poly);
        _this.parallelPoly.reduce(function (prev, outer, inner) {
            var /** @type {?} */ sashFrame = _this.profiles[inner] || _this.profiles[0] || {};
            var /** @type {?} */ sashFrameProfile = _this.usedProfiles.find(function (o) { return o.id === sashFrame.profileId; }) || _this.usedProfiles.find(function (o) { return o.type === 'sash'; }) || {};
            if (Number.isInteger(outer)) {
                var /** @type {?} */ frame_1 = _this.frame[outer] || _this.frame[_this.frame.length - 1] || _this.frame[0] || _this.frame || {};
                var /** @type {?} */ frameProfile = _this.usedProfiles.find(function (o) { return o.id === frame_1.profileId; }) || _this.usedProfiles.find(function (o) { return o.type === 'frame'; }) || {};
                _this.parallelProfiles[inner] = frame_1.profileId;
                if ((!_this.root.side && outerSash)
                    || outerSide !== outerSash
                    || (_this.lowThreshold && !_this.root.options.kickerLowThreshold && Number(inner) === 0)) {
                    _this.shift[inner] = Number(frameProfile.spaceSash || 60) - Number(frameProfile.widthOut || 70);
                }
                else {
                    _this.shift[inner] = Number(frameProfile.spaceSash || 60) - Number(frameProfile.width || 45);
                }
            }
            else {
                var /** @type {?} */ mullion_1 = _this.mullions.find(function (o) { return o.id === _this.sash.nearMullions[outer]; }) || {};
                var /** @type {?} */ mullionProfile = _this.usedProfiles.find(function (o) { return o.id === mullion_1.profileId; }) || _this.usedProfiles.find(function (o) { return o.type === 'divider'; }) || {};
                _this.parallelProfiles[inner] = mullion_1.profileId;
                if ((!_this.root.side && outerSash) || outerSide !== outerSash) {
                    _this.shift[inner] = Number(mullionProfile.spaceSash || 30) - Number(mullionProfile.widthOut || 90) / 2;
                }
                else {
                    _this.shift[inner] = Number(mullionProfile.spaceSash || 30) - Number(mullionProfile.width || 45) / 2;
                }
            }
            if ((!_this.root.side && outerSash) || outerSide) {
                _this.shift[inner] -= isFinite(sashFrameProfile.rebateWidthOut) ? Number(sashFrameProfile.rebateWidthOut) : 0;
                _this.width[inner] = Number(sashFrameProfile.widthOut) || 60;
            }
            else {
                _this.shift[inner] -= isFinite(sashFrameProfile.rebateWidth) ? Number(sashFrameProfile.rebateWidth) : 20;
                _this.width[inner] = Number(sashFrameProfile.width) || 100;
            }
            _this.shift[inner] += _this.width[inner];
        }, []);
        /** math: obliczenie współrzędnych figury */
        /** math: obliczenie współrzędnych figury */
        _this.poly = IccDrawMathService.getPolyShift(_this.parent.poly, _this.shift);
        _this.rect = IccDrawMathService.getRectFromPoly(_this.poly);
        /** math: odfiltrowanie zbliżonych punktów */
        /** math: odfiltrowanie zbliżonych punktów */
        _this.poly = _this.poly.filter(function (p, i) { return !i || Math.abs(p.x - _this.poly[i - 1].x) > 3 || Math.abs(p.y - _this.poly[i - 1].y) > 3; });
        /** math: przesunięcie figury względem rodzica */
        /** math: przesunięcie figury względem rodzica */
        _this.parentPoly = IccDrawMathService.getPolyShift(_this.poly, _this.width.map(function (e) { return -e; }));
        _this.parentRect = IccDrawMathService.getRectFromPoly(_this.parentPoly);
        /**
         * math: przygotowanie zestawów profili
         */
        var /** @type {?} */ jointAngle = _this.profiles.map(function (profile) { return profile.jointAngle || 'E'; });
        _this.polygons = IccDrawMathService.getPolygons(_this.parentPoly, _this.poly, jointAngle);
        // this.svg.paths.push(IccDrawSvgService.getPath(this.parentPoly, true, this.root.side, { fill: '#' + ((1<<24)*Math.random()|0).toString(16) }));
        // this.svg.paths.push(IccDrawSvgService.getPath(this.poly, true, this.root.side, { fill: '#' + ((1<<24)*Math.random()|0).toString(16) }));
        /** svg: rysowanie ścieżek */
        for (var _i = 0, _a = _this.polygons; _i < _a.length; _i++) {
            var polygon = _a[_i];
            _this.svg.paths.push(IccDrawSvgService.getPath(polygon, true, _this.root.side, {
                stroke: '#bbb',
                fill: "url('" + _this.root.uri + "#iccDraw-sash-" + _this.root.uuid + "')",
            }));
        }
        return _this;
    }
    /**
     * @param {?=} params
     * @return {?}
     */
    SashFrameNode.prototype.onClick = /**
     * @param {?=} params
     * @return {?}
     */
    function (params) {
        if (params === void 0) { params = {}; }
        return Object.assign({
            profiles: this.profiles,
            sash: this.sash,
        }, params);
    };
    /**
     * @return {?}
     */
    SashFrameNode.prototype.setProfiles = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.profiles && this.profiles['bottom']) {
            var /** @type {?} */ profiles = [];
            for (var /** @type {?} */ curr = 0, /** @type {?} */ next = 1; curr < this.parent.poly.length; ++curr, ++next, next %= this.parent.poly.length) {
                var side = IccDrawMathService.getLineInfo([this.parent.poly[curr], this.parent.poly[next]], this.parent.poly).side;
                profiles[curr] = this.profiles[side];
            }
            this.profiles = profiles;
        }
        if (!Array.isArray(this.profiles) || !this.profiles.length) {
            this.profiles = this.parent.poly.map(function () { return {}; });
        }
        if (this.profiles.length && this.profiles.length < this.parent.poly.length) {
            var /** @type {?} */ profiles_1 = [];
            this.parent.poly.forEach(function (v, i) { return profiles_1.push(_this.profiles[i] || _this.profiles[i - 1] || _this.profiles[0]); });
            this.profiles = profiles_1;
        }
    };
    return SashFrameNode;
}(BaseNode));

var __extends$17 = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var ShapeNode = (function (_super) {
    __extends$17(ShapeNode, _super);
    function ShapeNode(parentNode, childrenNodes, params, options) {
        if (parentNode === void 0) { parentNode = null; }
        if (childrenNodes === void 0) { childrenNodes = null; }
        if (params === void 0) { params = {}; }
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, parentNode, childrenNodes, params, options) || this;
        _this.shape = {
            d: 0,
            h1: 1500,
            h2: 0,
            h3: 1500,
            s1: 1500,
            s2: 0,
            s3: 0,
            shape: 'rect',
            type: null,
        };
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(_this, params);
        /** math: obliczenie współrzędnych figury */
        /** math: obliczenie współrzędnych figury */
        _this.poly = IccDrawMathService.getPolyFromShape(_this.shape);
        _this.rect = IccDrawMathService.getRectFromPoly(_this.poly);
        // this.svg.paths.push(IccDrawSvgService.getPath(this.poly, true, this.root.side, { fill: '#f00' }));
        return _this;
    }
    /**
     * @param {?=} params
     * @return {?}
     */
    ShapeNode.prototype.onClick = /**
     * @param {?=} params
     * @return {?}
     */
    function (params) {
        if (params === void 0) { params = {}; }
        return Object.assign({
            shape: this.shape,
        }, params);
    };
    return ShapeNode;
}(BaseNode));

var __extends$18 = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var ShutterNode = (function (_super) {
    __extends$18(ShutterNode, _super);
    function ShutterNode(parentNode, childrenNodes, params, options) {
        if (parentNode === void 0) { parentNode = null; }
        if (childrenNodes === void 0) { childrenNodes = null; }
        if (params === void 0) { params = {}; }
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, parentNode, childrenNodes, params, options) || this;
        _this.shutter = {};
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(_this, params);
        var /** @type {?} */ prevShutter = _this.parent.children[_this.parent.children.length - 2];
        /** math: obliczenie współrzędnych figury */
        /** math: obliczenie współrzędnych figury */
        _this.rect = {
            x: prevShutter ? prevShutter.rect.x + prevShutter.rect.width : 0,
            y: 0,
            width: Number(_this.shutter.width) || 0,
            height: Number(_this.shutter.height) || 0,
        };
        _this.poly = IccDrawMathService.getPolyFromRect(_this.rect);
        /** svg: rysowanie ścieżek */
        /** svg: rysowanie ścieżek */
        _this.svg.paths.push(IccDrawSvgService.getPath(_this.poly, true, _this.root.side, {
            fill: "url('" + _this.root.uri + "#iccDraw-shutter-" + _this.root.uuid + "')",
            stroke: '#fff',
        }));
        return _this;
    }
    /**
     * @param {?=} params
     * @return {?}
     */
    ShutterNode.prototype.onClick = /**
     * @param {?=} params
     * @return {?}
     */
    function (params) {
        if (params === void 0) { params = {}; }
        return Object.assign({
            shutter: this.shutter,
        }, params);
    };
    return ShutterNode;
}(BaseNode));

var __extends$19 = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var ShutterBoxNode = (function (_super) {
    __extends$19(ShutterBoxNode, _super);
    function ShutterBoxNode(parentNode, childrenNodes, params, options) {
        if (parentNode === void 0) { parentNode = null; }
        if (childrenNodes === void 0) { childrenNodes = null; }
        if (params === void 0) { params = {}; }
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, parentNode, childrenNodes, params, options) || this;
        _this.height = 0;
        _this.stripes = {
            polygons: [],
            poly: [],
            rect: {},
        };
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(_this, params);
        /** math: obliczenie współrzędnych figury */
        /** math: obliczenie współrzędnych figury */
        _this.rect = {
            x: _this.parent.rect.x,
            y: -_this.height,
            width: _this.parent.rect.width,
            height: _this.height,
        };
        _this.poly = IccDrawMathService.getPolyFromRect(_this.rect);
        /** math: poziome paski w rensonie */
        /** math: poziome paski w rensonie */
        _this.stripes.rect = Object.assign({}, _this.rect);
        _this.stripes.rect.height = _this.height;
        _this.stripes.poly = IccDrawMathService.getPolyFromRect(_this.stripes.rect);
        _this.stripes.poly = IccDrawMathService.getPolyShift(_this.stripes.poly, Math.round(_this.stripes.rect.height / 4));
        _this.stripes.rect = IccDrawMathService.getRectFromPoly(_this.stripes.poly);
        _this.stripes.polygons = [];
        [0, _this.stripes.rect.height / 2, _this.stripes.rect.height].map(function (height) {
            _this.stripes.polygons.push(IccDrawMathService.intersectPolyWithRect(_this.stripes.poly, {
                x: _this.stripes.rect.x,
                y: _this.stripes.rect.y + height,
                width: _this.stripes.rect.width,
                height: 0,
            }));
        });
        /** svg: rysowanie ścieżek */
        /** svg: rysowanie ścieżek */
        _this.svg.paths.push(IccDrawSvgService.getPath(_this.poly, true, _this.root.side, {
            fill: "#fff",
            stroke: '#bbb',
        }));
        _this.stripes.polygons.map(function (polygon) {
            _this.svg.paths.push(IccDrawSvgService.getPath(polygon, false, _this.root.side, {
                stroke: '#bbb',
                strokeDasharray: '5,5',
            }));
        });
        return _this;
    }
    /**
     * @param {?=} params
     * @return {?}
     */
    ShutterBoxNode.prototype.onClick = /**
     * @param {?=} params
     * @return {?}
     */
    function (params) {
        if (params === void 0) { params = {}; }
        return Object.assign({}, params);
    };
    return ShutterBoxNode;
}(BaseNode));

var __extends$20 = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var ShutterColorsNode = (function (_super) {
    __extends$20(ShutterColorsNode, _super);
    function ShutterColorsNode(parentNode, childrenNodes, params, options) {
        if (parentNode === void 0) { parentNode = null; }
        if (childrenNodes === void 0) { childrenNodes = null; }
        if (params === void 0) { params = {}; }
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, parentNode, childrenNodes, params, options) || this;
        _this.colors = {};
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(_this.colors, params.colors);
        /** svg: gradient szyby */
        /** svg: gradient szyby */
        _this.svg.gradients.push(IccDrawSvgService.getGradient({
            id: "iccDraw-shutter-" + _this.root.uuid,
            steps: [
                { color: '#ddd', offset: '0%' },
                { color: '#fff', offset: '100%' },
            ],
        }));
        return _this;
    }
    return ShutterColorsNode;
}(BaseNode));

var __extends$21 = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var ShutterDriveNode = (function (_super) {
    __extends$21(ShutterDriveNode, _super);
    function ShutterDriveNode(parentNode, childrenNodes, params, options) {
        if (parentNode === void 0) { parentNode = null; }
        if (childrenNodes === void 0) { childrenNodes = null; }
        if (params === void 0) { params = {}; }
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, parentNode, childrenNodes, params, options) || this;
        _this.nextShutter = {};
        _this.prevShutter = {};
        _this.shutter = {};
        _this.shift = 50;
        _this.side = null;
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(_this, params);
        /** class: sprawdzenie warunków */
        if (!_this.shutter.commonRail && (_this.shutter.controlSide === 'L' || !_this.nextShutter || !_this.nextShutter.commonRail)) {
            _this.side = _this.shutter.controlSide;
        }
        if (_this.shutter.commonRail && _this.prevShutter.controlSide === 'R' && (!_this.nextShutter || !_this.nextShutter.commonRail)) {
            _this.side = _this.prevShutter.controlSide;
        }
        if (_this.side) {
            /** math: obliczenie współrzędnych figury */
            /** math: obliczenie współrzędnych figury */
            _this.rect = {
                x: _this.side === 'L' ? _this.parent.rect.x + _this.shift : _this.parent.rect.x + _this.parent.rect.width - _this.shift,
                y: _this.parent.rect.y + _this.shift,
                width: 0,
                height: _this.parent.rect.height - _this.shift * 2,
            };
            _this.poly = IccDrawMathService.getPolyFromRect(_this.rect);
            /** svg: rysowanie ścieżek */
            /** svg: rysowanie ścieżek */
            _this.svg.paths.push(IccDrawSvgService.getPath(_this.poly, false, _this.root.side, {
                stroke: '#aaa',
                strokeDasharray: '5,10',
                strokeWidth: '5',
            }));
        }
        return _this;
    }
    /**
     * @param {?=} params
     * @return {?}
     */
    ShutterDriveNode.prototype.onClick = /**
     * @param {?=} params
     * @return {?}
     */
    function (params) {
        if (params === void 0) { params = {}; }
        return Object.assign({}, params);
    };
    return ShutterDriveNode;
}(BaseNode));

var __extends$22 = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var SillsNode = (function (_super) {
    __extends$22(SillsNode, _super);
    function SillsNode(parentNode, childrenNodes, params, options) {
        if (parentNode === void 0) { parentNode = null; }
        if (childrenNodes === void 0) { childrenNodes = null; }
        if (params === void 0) { params = {}; }
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, parentNode, childrenNodes, params, options) || this;
        _this.accessories = {};
        _this.shift = {
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
        };
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(_this, params);
        _this.rect = _this.parent.rect;
        _this.poly = _this.parent.poly;
        if (_this.accessories && _this.accessories.bottom && _this.accessories.bottom.some(function (e) { return e.type === 'windowsill'; })) {
            _this.accessories.bottom.filter(function (e) { return e.type === 'windowsill'; }).map(function (accessory) {
                _this.shift.bottom = -Number(accessory.height) || -30;
                /** math: obliczenie współrzędnych figury */
                /** math: obliczenie współrzędnych figury */
                _this.poly = IccDrawMathService.getPolyShift(_this.poly, _this.shift);
                _this.rect = IccDrawMathService.getRectFromPoly(_this.poly);
                /** svg: rysowanie ścieżek */
                /** svg: rysowanie ścieżek */
                _this.svg.paths.push(IccDrawSvgService.getPath(_this.poly, true, _this.root.side, {
                    fill: "url('" + _this.root.uri + "#iccDraw-frame-" + _this.root.uuid + "')",
                    stroke: '#bbb',
                }));
            });
        }
        return _this;
    }
    return SillsNode;
}(BaseNode));

var __extends$23 = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var SymbolNode = (function (_super) {
    __extends$23(SymbolNode, _super);
    function SymbolNode(parentNode, childrenNodes, params, options) {
        if (parentNode === void 0) { parentNode = null; }
        if (childrenNodes === void 0) { childrenNodes = null; }
        if (params === void 0) { params = {}; }
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, parentNode, childrenNodes, params, options) || this;
        _this.shift = 0;
        _this.type = {};
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(_this, params);
        var /** @type {?} */ polygons = [];
        /** math: obliczenie współrzędnych figury */
        if (_this.shift > 0) {
            var /** @type {?} */ shift = {
                top: _this.shift,
                left: _this.shift,
                right: _this.shift,
                bottom: _this.shift,
            };
            _this.poly = IccDrawMathService.getPolyShift(_this.parent.poly, shift);
        }
        else {
            _this.poly = _this.parent.poly;
        }
        _this.rect = IccDrawMathService.getRectFromPoly(_this.poly);
        /**
         * środek ciężkości figury
         */
        var /** @type {?} */ gravity = IccDrawMathService.getGravityFromPoly(_this.poly);
        /** stałe szklenie */
        if (_this.type.type === 'F') {
            var /** @type {?} */ length_1 = Math.ceil(Math.min(_this.rect.width, _this.rect.height) / 8);
            polygons.push([
                { x: gravity.x - length_1, y: gravity.y },
                { x: gravity.x + length_1, y: gravity.y },
            ]);
            polygons.push([
                { x: gravity.x, y: gravity.y - length_1 },
                { x: gravity.x, y: gravity.y + length_1 },
            ]);
        }
        /** stałe szklenie w ramie */
        if (_this.type.type === 'FF' || _this.type.type === 'OFF') {
            var /** @type {?} */ length_2 = Math.ceil(Math.min(_this.rect.width, _this.rect.height) / 8);
            var /** @type {?} */ gravity1 = { x: gravity.x, y: Math.ceil(gravity.y - 2 * length_2) };
            var /** @type {?} */ gravity2 = { x: gravity.x, y: Math.ceil(gravity.y + 2 * length_2) };
            polygons.push([
                { x: gravity1.x - length_2, y: gravity1.y },
                { x: gravity1.x + length_2, y: gravity1.y },
            ]);
            polygons.push([
                { x: gravity1.x, y: gravity1.y - length_2 },
                { x: gravity1.x, y: gravity1.y + length_2 },
            ]);
            polygons.push([
                { x: gravity2.x - length_2, y: gravity2.y },
                { x: gravity2.x + length_2, y: gravity2.y },
            ]);
            polygons.push([
                { x: gravity2.x, y: gravity2.y - length_2 },
                { x: gravity2.x, y: gravity2.y + length_2 },
            ]);
        }
        /** skrzydło z ruchomym słupkiem */
        if (['DS', 'ODS', 'DSH', 'ODSH', 'DSC', 'DRP', 'DOP'].some(function (e) { return e === _this.type.type; }) || (_this.type.type === 'PSK' && _this.type.passive)) {
            var /** @type {?} */ poly = void 0;
            if (_this.type.handlePosition === 'R') {
                poly = [
                    { x: _this.rect.x + _this.rect.width + 50, y: gravity.y - gravity.height },
                    { x: _this.rect.x + _this.rect.width + 50, y: gravity.y + gravity.height },
                ];
            }
            else {
                poly = [
                    { x: _this.rect.x - 50, y: gravity.y - gravity.height },
                    { x: _this.rect.x - 50, y: gravity.y + gravity.height },
                ];
            }
            _this.svg.paths.push(IccDrawSvgService.getPath(poly, false, _this.root.side, {
                stroke: '#bbb',
                strokeWidth: '4px',
            }));
            _this.svg.paths.push(IccDrawSvgService.getPath(poly, false, _this.root.side, {
                stroke: '#fff',
                strokeWidth: '4px',
                strokeDasharray: '5,5',
            }));
        }
        /** skrzydło rozwierne */
        if (['D', 'DK', 'DRA', 'DRP', 'DOA', 'DOP', 'DS', 'DSH', 'ODSH', 'DSC', 'OD', 'ODS', 'SWH'].some(function (e) { return e === _this.type.type; })) {
            if (_this.type.handlePosition === 'R') {
                polygons.push([
                    { x: _this.rect.x, y: gravity.y - gravity.height },
                    gravity.horizontal[1],
                    { x: _this.rect.x, y: gravity.y + gravity.height },
                ]);
            }
            else {
                polygons.push([
                    { x: _this.rect.x + _this.rect.width, y: gravity.y - gravity.height },
                    gravity.horizontal[0],
                    { x: _this.rect.x + _this.rect.width, y: gravity.y + gravity.height },
                ]);
            }
        }
        /** skrzydło uchylne */
        if (['DK', 'K', 'PSK'].some(function (e) { return e === _this.type.type; })) {
            polygons.push([
                { x: gravity.x - gravity.width / (_this.poly.length > 3 ? 1 : 2) + 5, y: _this.rect.y + _this.rect.height - 5 },
                { x: gravity.x, y: gravity.vertical[0].y && gravity.vertical[0].y < _this.rect.y + _this.rect.height / 2 ? gravity.vertical[0].y + 5 : _this.rect.y + 5 },
                { x: gravity.x + gravity.width / (_this.poly.length > 3 ? 1 : 2) - 5, y: _this.rect.y + _this.rect.height - 5 },
            ]);
        }
        /** skrzydło odchylne */
        if (['OKL'].some(function (e) { return e === _this.type.type; })) {
            polygons.push([
                { x: gravity.x - gravity.width, y: _this.rect.y },
                gravity.vertical[1],
                { x: gravity.x + gravity.width, y: _this.rect.y },
            ]);
        }
        /** skrzydło przesuwne */
        if (['PSK', 'S'].some(function (e) { return e === _this.type.type; })) {
            var /** @type {?} */ posX = gravity.x;
            var /** @type {?} */ posY = _this.rect.y + Math.ceil(_this.rect.height * 5 / 6);
            var /** @type {?} */ length_3 = Math.ceil(_this.rect.width / 6);
            polygons.push([
                { x: posX - length_3, y: posY },
                { x: posX + length_3, y: posY },
            ]);
            if (_this.type.handlePosition === 'R') {
                polygons.push([
                    { x: posX - length_3 / 3, y: posY - length_3 / 3 },
                    { x: posX - length_3, y: posY },
                    { x: posX - length_3 / 3, y: posY + length_3 / 3 },
                ]);
            }
            else {
                polygons.push([
                    { x: posX + length_3 / 3, y: posY - length_3 / 3 },
                    { x: posX + length_3, y: posY },
                    { x: posX + length_3 / 3, y: posY + length_3 / 3 },
                ]);
            }
        }
        /** skrzydło przesuwne w górę */
        if (_this.type.type === 'SU') {
            var /** @type {?} */ posX = gravity.x;
            var /** @type {?} */ posY = gravity.y;
            var /** @type {?} */ length_4 = Math.ceil(_this.rect.height / 6);
            polygons.push([
                { x: posX, y: posY - length_4 },
                { x: posX, y: posY + length_4 },
            ]);
            polygons.push([
                { x: posX - length_4 / 3, y: posY - length_4 / 3 },
                { x: posX, y: posY - length_4 },
                { x: posX + length_4 / 3, y: posY - length_4 / 3 },
            ]);
        }
        /** skrzydło przesuwne w dół */
        if (_this.type.type === 'SD') {
            var /** @type {?} */ posX = gravity.x;
            var /** @type {?} */ posY = gravity.y;
            var /** @type {?} */ length_5 = Math.ceil(_this.rect.height / 6);
            polygons.push([
                { x: posX, y: posY - length_5 },
                { x: posX, y: posY + length_5 },
            ]);
            polygons.push([
                { x: posX + length_5 / 3, y: posY + length_5 / 3 },
                { x: posX, y: posY + length_5 },
                { x: posX - length_5 / 3, y: posY + length_5 / 3 },
            ]);
        }
        /** skrzydło przechylne */
        if (_this.type.type === 'SWF') {
            polygons.push([
                { x: _this.rect.x, y: _this.rect.y + _this.rect.height / 2 },
                { x: _this.rect.x + _this.rect.width / 2, y: _this.rect.y },
                { x: _this.rect.x + _this.rect.width, y: _this.rect.y + _this.rect.height / 2 },
            ]);
            polygons.push([
                { x: _this.rect.x + _this.rect.width, y: _this.rect.y + _this.rect.height / 2 },
                { x: _this.rect.x + _this.rect.width / 2, y: _this.rect.y + _this.rect.height },
                { x: _this.rect.x, y: _this.rect.y + _this.rect.height / 2 },
            ]);
        }
        /** drzwi przesuwne */
        if (['HS'].some(function (e) { return e === _this.type.type; })) {
            var /** @type {?} */ posX = _this.rect.x + _this.rect.width / 2;
            var /** @type {?} */ posY = _this.rect.y + _this.rect.height / 2;
            var /** @type {?} */ length_6 = Math.ceil(_this.rect.width / 6);
            var /** @type {?} */ length2 = Math.ceil(_this.rect.height / 15);
            polygons.push([
                { x: posX - length_6, y: posY },
                { x: posX + length_6, y: posY },
            ]);
            if (_this.type.handlePosition === 'R') {
                polygons.push([
                    { x: posX - length_6 / 3, y: posY - length_6 / 3 },
                    { x: posX - length_6, y: posY },
                    { x: posX - length_6 / 3, y: posY + length_6 / 3 },
                ]);
                polygons.push([
                    { x: posX + length_6, y: posY },
                    { x: posX + length_6, y: posY + length2 },
                ]);
            }
            else {
                polygons.push([
                    { x: posX + length_6 / 3, y: posY - length_6 / 3 },
                    { x: posX + length_6, y: posY },
                    { x: posX + length_6 / 3, y: posY + length_6 / 3 },
                ]);
                polygons.push([
                    { x: posX - length_6, y: posY },
                    { x: posX - length_6, y: posY + length2 },
                ]);
            }
        }
        /** skrzydło obrotowe */
        if (['SWH'].some(function (e) { return e === _this.type.type; })) {
            var /** @type {?} */ posX = _this.rect.x;
            var /** @type {?} */ posY = _this.rect.y + _this.rect.height / 2;
            var /** @type {?} */ length_7 = Math.ceil(_this.rect.width);
            polygons.push([
                { x: posX - length_7, y: posY },
                { x: posX + length_7, y: posY },
            ]);
            polygons.push([
                { x: posX + length_7 / 12, y: posY - length_7 / 72 },
                { x: posX, y: posY },
                { x: posX + length_7 / 12, y: posY + length_7 / 72 },
                { x: posX, y: posY },
                { x: posX + length_7, y: posY },
                { x: posX + length_7 * 11 / 12, y: posY - length_7 / 72 },
                { x: posX + length_7, y: posY },
                { x: posX + length_7 * 11 / 12, y: posY + length_7 / 72 },
            ]);
        }
        /** drzwi harmonijkowe */
        if (['FD', 'FDO'].some(function (e) { return e === _this.type.type; })) {
            var /** @type {?} */ posX = _this.rect.x + _this.rect.width / 2;
            var /** @type {?} */ posY = _this.rect.y + _this.rect.height / 2;
            var /** @type {?} */ length_8 = Math.ceil(_this.rect.width / 6);
            polygons.push([
                { x: posX - length_8 * 2, y: posY },
                { x: posX + length_8 * 2, y: posY },
            ]);
            if (_this.type.handlePosition === 'L') {
                polygons.push([
                    { x: posX - length_8 / 3, y: posY - length_8 },
                    { x: posX - length_8 * 2, y: posY },
                    { x: posX - length_8 / 3, y: posY + length_8 },
                ]);
            }
            else {
                polygons.push([
                    { x: posX + length_8 / 3, y: posY - length_8 },
                    { x: posX + length_8 * 2, y: posY },
                    { x: posX + length_8 / 3, y: posY + length_8 },
                ]);
            }
        }
        /** math: przycinanie linii do krawędzi figury */
        for (var _i = 0, polygons_1 = polygons; _i < polygons_1.length; _i++) {
            var polygon = polygons_1[_i];
            for (var /** @type {?} */ curr = 0, /** @type {?} */ next = 1; next < polygon.length; curr++, next++) {
                var /** @type {?} */ line = IccDrawMathService.intersectLineWithPoly([polygon[curr], polygon[next]], _this.poly);
                polygon[curr] = line[0];
                polygon[next] = line[1];
            }
        }
        /** svg: rysowanie ścieżek */
        for (var _a = 0, polygons_2 = polygons; _a < polygons_2.length; _a++) {
            var polygon = polygons_2[_a];
            _this.svg.paths.push(IccDrawSvgService.getPath(polygon, false, _this.root.side, {
                stroke: '#bbb',
                strokeWidth: '4px',
            }));
            _this.svg.paths.push(IccDrawSvgService.getPath(polygon, false, _this.root.side, {
                stroke: '#fff',
                strokeWidth: '2px',
                strokeDasharray: (_this.root.side === 'outer') !== (['OKL', 'OD', 'ODS', 'ODSH', 'FDO', 'DOA', 'DOP'].some(function (e) { return e === _this.type.type; })
                    || (_this.type.type === 'SWF' && polygon === polygons[1])) ? '5,5' : null,
            }));
        }
        return _this;
    }
    return SymbolNode;
}(BaseNode));

var __extends$24 = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var VentilatorNode = (function (_super) {
    __extends$24(VentilatorNode, _super);
    function VentilatorNode(parentNode, childrenNodes, params, options) {
        if (parentNode === void 0) { parentNode = null; }
        if (childrenNodes === void 0) { childrenNodes = null; }
        if (params === void 0) { params = {}; }
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, parentNode, childrenNodes, params, options) || this;
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(_this, params);
        /** math: znalezienie górnego profilu */
        /** math: znalezienie górnego profilu */
        _this.poly = _this.parent.polygons.find(function (poly) { return IccDrawMathService.getLineInfo([poly[0], poly[1]], poly).side === 'top'; });
        if (_this.poly) {
            _this.rect = IccDrawMathService.getRectFromPoly(_this.poly);
            _this.position = _this.ventilator.position || _this.sash.width / 2;
            _this.width = _this.ventilator.width || _this.rect.width / 2;
            _this.height = _this.ventilator.height || _this.rect.height / 2;
            _this.rect = {
                x: _this.parent.parent.rect.x + _this.position - _this.width / 2,
                y: _this.rect.y + _this.rect.height / 2 - _this.height / 2,
                width: _this.width,
                height: _this.height,
            };
            _this.poly = IccDrawMathService.getPolyFromRect(_this.rect);
            /**
             * math: dodatkowy pasek w środku
             */
            var /** @type {?} */ stripe = IccDrawMathService.getPolyFromRect({
                x: _this.rect.x + 10,
                y: _this.rect.y + (_this.rect.height / 2),
                width: _this.rect.width - 20,
                height: 0,
            });
            /** svg: rysowanie ścieżek */
            /** svg: rysowanie ścieżek */
            _this.svg.paths.push(IccDrawSvgService.getPath(_this.poly, true, _this.root.side, {
                stroke: '#bbb',
                fill: '#fff',
            }));
            _this.svg.paths.push(IccDrawSvgService.getPath(stripe, false, _this.root.side, {
                stroke: '#bbb',
                strokeDasharray: '5,5',
            }));
        }
        return _this;
    }
    /**
     * @param {?=} params
     * @return {?}
     */
    VentilatorNode.prototype.onClick = /**
     * @param {?=} params
     * @return {?}
     */
    function (params) {
        if (params === void 0) { params = {}; }
        return Object.assign({
            sash: this.sash,
        }, params);
    };
    return VentilatorNode;
}(BaseNode));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var IccDrawSyncService = (function () {
    function IccDrawSyncService() {
    }
    /**
     * @param {?} sash
     * @return {?}
     */
    IccDrawSyncService.mapMuntins = /**
     * @param {?} sash
     * @return {?}
     */
    function (sash) {
        if (sash.muntins && (sash.muntins.horizontal || sash.muntins.vertical)) {
            Object.keys(sash.muntins).map(function (direction) { return sash.muntins[direction].map(function (muntin) { return muntin.direction = direction; }); });
            return [].concat.apply([], sash.muntins.horizontal.concat(sash.muntins.vertical));
        }
        else {
            return sash.muntins || [];
        }
    };
    /**
     * @param {?} details
     * @param {?} options
     * @return {?}
     */
    IccDrawSyncService.syncDetails = /**
     * @param {?} details
     * @param {?} options
     * @return {?}
     */
    function (details, options) {
        var /** @type {?} */ baseNode;
        if (details.type === 'roller_shutter' || options.extendedRollerInWindow === 'full') {
            baseNode = this.syncDetailsShutter(details, options);
        }
        else {
            baseNode = this.syncDetailsWindow(details, options);
        }
        if (baseNode && baseNode.children && options.dimensions && options.dimensions.type !== 'extended') {
            var /** @type {?} */ shapeNode = baseNode.children.find(function (o) { return o.constructor.name === 'ShapeNode'; });
            var /** @type {?} */ baseRect = Object.assign({}, options.dimensions.type === 'outer' || !shapeNode ? baseNode.rect : shapeNode.rect);
            /**
             * wymiary poziome
             */
            var /** @type {?} */ horizontalDimensionNode = new DimensionNode(baseNode, null, {
                details: details,
                baseRect: baseRect,
                shape: shapeNode,
                type: 'horizontal',
            }, Object.assign({}, options.dimensions, {
                extendedRollerInWindow: options.extendedRollerInWindow
            }));
            /**
             * wymiary pionowe
             */
            var /** @type {?} */ verticalDimensionNode = new DimensionNode(baseNode, null, {
                details: details,
                baseRect: baseRect,
                shape: shapeNode,
                type: 'vertical',
            }, Object.assign({}, options.dimensions, {
                extendedRollerInWindow: options.extendedRollerInWindow
            }));
        }
        return baseNode;
    };
    /**
     * @param {?} details
     * @param {?} options
     * @return {?}
     */
    IccDrawSyncService.syncDetailsShutter = /**
     * @param {?} details
     * @param {?} options
     * @return {?}
     */
    function (details, options) {
        if (!details || !details.rollerShutter || !details.rollerShutter.shutters || !details.rollerShutter.shutters.length) {
            return {};
        }
        /**
         * konstrukcja
         */
        var /** @type {?} */ baseNode = new BaseNode(null, null, {
            side: options.base.side,
        }, options.base);
        baseNode.rect = {
            x: 0,
            y: -Number(details.rollerShutter.boxHeight) || 0,
            width: Number(details.rollerShutter.boxWidth) || 0,
            height: Number(details.rollerShutter.boxHeight + details.rollerShutter.rollerHeight) || 0,
        };
        /**
         * kolory rolety
         */
        var /** @type {?} */ shutterColorsNode = new ShutterColorsNode(baseNode, null, {
            colors: details.rollerShutter.colors,
        }, options.shutterColors);
        var _loop_1 = function (shutter) {
            /**
             * roleta
             */
            var /** @type {?} */ shutterNode = new ShutterNode(baseNode, null, {
                shutter: shutter,
            }, options.shutter);
            /**
             * skrzynka rolety
             */
            var /** @type {?} */ shutterBoxNode = new ShutterBoxNode(shutterNode, null, {
                height: details.rollerShutter.boxHeight,
            }, options.shutterBox);
            /**
             * napęd rolety
             */
            var /** @type {?} */ shutterDriveNode = new ShutterDriveNode(shutterNode, null, {
                nextShutter: details.rollerShutter.shutters.find(function (o) { return o.id > shutter.id; }),
                prevShutter: details.rollerShutter.shutters.filter(function (o) { return o.id < shutter.id && !o.commonRail; }).pop(),
                shutter: shutter,
            }, options.shutterDrive);
        };
        for (var _i = 0, _a = details.rollerShutter.shutters; _i < _a.length; _i++) {
            var shutter = _a[_i];
            _loop_1(shutter);
        }
        return baseNode;
    };
    /**
     * @param {?} details
     * @param {?} options
     * @return {?}
     */
    IccDrawSyncService.syncDetailsWindow = /**
     * @param {?} details
     * @param {?} options
     * @return {?}
     */
    function (details, options) {
        if (!details || !details.shape || !details.sashes || !details.sashes.length) {
            return {};
        }
        /**
         * konstrukcja
         */
        var /** @type {?} */ baseNode = new BaseNode(null, null, {
            side: options.base.side,
        }, options.base);
        baseNode.rect = {
            x: Number(details.x) || 0,
            y: Number(details.y) || 0,
            width: Number(details.width) || 0,
            height: Number(details.height) || 0,
        };
        /**
         * kolory
         */
        var /** @type {?} */ colorsNode = new ColorsNode(baseNode, null, {
            colors: details.colors,
            muntins: details.muntins,
        }, options.colors);
        /**
         * kształt
         */
        var /** @type {?} */ shapeNode = new ShapeNode(baseNode, null, {
            shape: details.shape,
        }, options.shape);
        /**
         * rama
         */
        var /** @type {?} */ frameNode = new FrameNode(shapeNode, null, {
            lowThreshold: !!details.lowThreshold,
            profiles: details.frame,
            usedProfiles: details.usedProfiles,
        }, options.frame);
        /**
         * otwory pod dyble
         */
        var /** @type {?} */ dowelHolesNode = new DowelHolesNode(frameNode, null, {
            accessories: details.sideAccessories,
            sashes: details.sashes,
        }, options.dowelHoles);
        if (details.sashes && details.sashes.length) {
            var /** @type {?} */ sashesCopy_1 = details.sashes.concat();
            if (details.alignments && details.alignments.length) {
                for (var _i = 0, _a = details.alignments; _i < _a.length; _i++) {
                    var alignment = _a[_i];
                    /**
                     * wyrównanie w ramie
                     */
                    var /** @type {?} */ alignmentNode = new AlignmentNode(frameNode, null, {
                        alignment: alignment,
                        alignments: details.alignments,
                        mullions: details.mullions,
                        usedProfiles: details.usedProfiles,
                    }, options.alignments);
                }
            }
            /** kolejność rysowania kwater */
            if (details.layout && details.layout.sashes && details.layout.sashes.length) {
                details.layout.sashes.map(function (sash) {
                    if (sashesCopy_1.find(function (o) { return o.id === sash.id; })) {
                        sashesCopy_1.find(function (o) { return o.id === sash.id; }).level = sash.level;
                    }
                });
                sashesCopy_1.sort(function (a, b) { return a.level > b.level ? 1 : -1; });
            }
            var /** @type {?} */ sashNodes = [];
            var _loop_2 = function (sash) {
                /**
                 * kwatera w ramie
                 */
                var /** @type {?} */ sashNode = new SashNode(frameNode, null, {
                    alignments: details.alignments,
                    mullions: details.mullions,
                    sash: sash,
                    usedProfiles: details.usedProfiles,
                }, options.sash);
                if (sash.intSashes && sash.intSashes.length) {
                    /**
                     * skrzydło
                     */
                    var /** @type {?} */ sashFrameNode_1 = new SashFrameNode(sashNode, null, {
                        frame: details.frame,
                        level: sash.level,
                        lowThreshold: !!details.lowThreshold,
                        mullions: details.mullions,
                        profiles: sash.frame,
                        sash: sash,
                        usedProfiles: details.usedProfiles,
                    }, options.sashFrame);
                    if (sash.hardware && sash.hardware.length && options.base.ventilator) {
                        sash.hardware.filter(function (o) { return o.type === 'ventilator' || o.type === 'ventilator_hole'; }).map(function (ventilator) {
                            /**
                             * nawiewnik w skrzydle
                             */
                            var /** @type {?} */ ventilatorNode = new VentilatorNode(sashFrameNode_1, null, {
                                sash: sash,
                                ventilator: ventilator,
                            });
                        });
                    }
                    if (sash.intAlignments && sash.intAlignments.length) {
                        for (var _i = 0, _a = sash.intAlignments; _i < _a.length; _i++) {
                            var alignment = _a[_i];
                            /** wyrównanie w skrzydle */
                            intAlignmentNode = new AlignmentNode(sashFrameNode_1, null, {
                                alignment: alignment,
                                alignments: sash.intAlignments,
                                mullions: sash.intMullions,
                                sash: sash,
                                usedProfiles: details.usedProfiles,
                            }, options.alignments);
                        }
                    }
                    var /** @type {?} */ intSashNodes = [];
                    var _loop_3 = function (intSash) {
                        /**
                         * kwatera w skrzydle
                         */
                        var /** @type {?} */ intSashNode = new SashNode(sashFrameNode_1, null, {
                            alignments: sash.intAlignments,
                            mullions: sash.intMullions,
                            sash: intSash,
                            usedProfiles: details.usedProfiles,
                        }, options.sash);
                        /**
                         * pakiet szybowy
                         */
                        var /** @type {?} */ glazingNode = new GlazingNode(intSashNode, null, {
                            glazing: intSash.filling,
                            mullions: sash.intMullions,
                            renson: sash.hardware && intSash.y === 0 ? sash.hardware.find(function (o) { return o.type === 'renson'; }) : null,
                            sash: intSash,
                            usedProfiles: details.usedProfiles,
                        }, options.glazing);
                        /** szprosy */
                        this_1.mapMuntins(intSash).map(function (muntin) {
                            var /** @type {?} */ muntinNode = new MuntinNode(intSashNode, null, {
                                muntins: details.muntins,
                                muntin: muntin,
                                sash: intSash,
                                system: details.system,
                            }, options.muntins);
                        });
                        /**
                         * listwa przyszybowa
                         */
                        var /** @type {?} */ glazingBeadNode = options.base.side !== 'outer' ? new GlazingBeadNode(intSashNode, null, {
                            level: sash.level,
                            profiles: intSash.glazingBead,
                            sash: intSash,
                            usedProfiles: details.usedProfiles,
                        }, options.glazingBead) : null;
                        if (sash.hardware && sash.hardware.length && intSash.y === 0) {
                            sash.hardware.filter(function (o) { return o.type === 'renson'; }).map(function (renson) {
                                /**
                                 * nawiewnik w szybie
                                 */
                                var /** @type {?} */ rensonNode = new RensonNode(glazingBeadNode || glazingNode, null, {
                                    renson: renson,
                                    sash: intSash,
                                }, options.renson);
                            });
                        }
                        intSashNodes.push(intSashNode);
                    };
                    for (var _b = 0, _c = sash.intSashes; _b < _c.length; _b++) {
                        var intSash = _c[_b];
                        _loop_3(intSash);
                    }
                    if (sash.intMullions && sash.intMullions.length) {
                        for (var _d = 0, _e = sash.intMullions; _d < _e.length; _d++) {
                            var intMullion = _e[_d];
                            /**
                             * słupek w skrzydle
                             */
                            var /** @type {?} */ intMullionNode = new MullionNode(sashFrameNode_1, null, {
                                mullion: intMullion,
                                mullions: sash.intMullions,
                                sash: sash,
                                sashes: sash.intSashes,
                                sashNodes: intSashNodes,
                                usedProfiles: details.usedProfiles,
                            }, options.mullion);
                        }
                    }
                    /**
                     * symbol otwierania
                     */
                    var /** @type {?} */ symbolNode = new SymbolNode(sashFrameNode_1, null, {
                        shift: 20,
                        type: sash.type,
                    }, options.symbol);
                    /** klamka w skrzydle */
                    if (options.base.side !== 'outer') {
                        var /** @type {?} */ handleNode = new HandleNode(sashFrameNode_1, null, {
                            sash: sash,
                            sashes: sashesCopy_1,
                        }, options.handle);
                    }
                }
                else {
                    /**
                     * pakiet szybowy
                     */
                    var /** @type {?} */ glazingNode_1 = new GlazingNode(sashNode, null, {
                        glazing: sash.filling,
                        mullions: details.mullions,
                        renson: sash.hardware ? sash.hardware.find(function (o) { return o.type === 'renson'; }) : null,
                        sash: sash,
                        usedProfiles: details.usedProfiles,
                    }, options.glazing);
                    /** szprosy */
                    this_1.mapMuntins(sash).map(function (muntin) {
                        var /** @type {?} */ muntinNode = new MuntinNode(sashNode, null, {
                            muntins: details.muntins,
                            muntin: muntin,
                            sash: sash,
                            system: details.system,
                        }, options.muntins);
                    });
                    /**
                     * listwa przyszybowa
                     */
                    var /** @type {?} */ glazingBeadNode_1 = options.base.side !== 'outer' ? new GlazingBeadNode(sashNode, null, {
                        profiles: sash.glazingBead,
                        sash: sash,
                        usedProfiles: details.usedProfiles,
                    }, options.glazingBead) : null;
                    if (sash.hardware && sash.hardware.length) {
                        sash.hardware.filter(function (o) { return o.type === 'renson'; }).map(function (renson) {
                            /**
                             * nawiewnik w szybie
                             */
                            var /** @type {?} */ rensonNode = new RensonNode(glazingBeadNode_1 || glazingNode_1, null, {
                                renson: renson,
                                sash: sash,
                            }, options.renson);
                        });
                    }
                    /**
                     * symbol otwierania
                     */
                    var /** @type {?} */ symbolNode = new SymbolNode(glazingNode_1, null, {
                        type: sash.type,
                    }, options.symbol);
                }
                sashNodes.push(sashNode);
            };
            var this_1 = this, intAlignmentNode;
            for (var _b = 0, sashesCopy_2 = sashesCopy_1; _b < sashesCopy_2.length; _b++) {
                var sash = sashesCopy_2[_b];
                _loop_2(sash);
            }
            if (details.mullions && details.mullions.length) {
                for (var _c = 0, _d = details.mullions; _c < _d.length; _c++) {
                    var mullion = _d[_c];
                    /**
                     * słupek w ramie
                     */
                    var /** @type {?} */ mullionNode = new MullionNode(frameNode, null, {
                        mullion: mullion,
                        mullions: details.mullions,
                        sash: null,
                        sashes: sashesCopy_1,
                        sashNodes: sashNodes,
                        usedProfiles: details.usedProfiles,
                    }, options.mullion);
                }
            }
        }
        if (details.rollerShutter
            || details.sideProfiles
            || details.sideAccessories
            || details.lowThreshold) {
            /**
             * roleta
             */
            var /** @type {?} */ rollerShutterNode = new RollerShutterNode(shapeNode, null, {
                rollerShutter: details.rollerShutter,
            }, options.rollerShutter);
            Object.assign(baseNode.rect, rollerShutterNode.rect);
            /**
             * poszerzenia
             */
            var /** @type {?} */ extensionsNode = new ExtensionsNode(rollerShutterNode, null, {
                sideProfiles: details.sideProfiles,
                usedProfiles: details.usedProfiles,
            }, options.extensions);
            Object.assign(baseNode.rect, extensionsNode.rect);
            /**
             * parapety
             */
            var /** @type {?} */ sillsNode = new SillsNode(extensionsNode, null, {
                accessories: details.sideAccessories,
            }, options.sills);
            Object.assign(baseNode.rect, sillsNode.rect);
            /**
             * rama renowacyjna
             */
            var /** @type {?} */ renoNode = new RenoNode(sillsNode, null, {
                lowThreshold: !!details.lowThreshold,
                profiles: details.frame,
                usedProfiles: details.usedProfiles,
            }, options.reno);
            Object.assign(baseNode.rect, renoNode.rect);
        }
        if (options.indexes) {
            var /** @type {?} */ indexesNode = new IndexesNode(baseNode, null, {
                sashes: details.sashes,
            }, options.indexes);
        }
        return baseNode;
    };
    return IccDrawSyncService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var IccDrawComponent = (function () {
    function IccDrawComponent() {
        this.details = {};
        this.options = {};
        this.interfaceClicked = new EventEmitter();
        this.drawDetails = {};
        this.drawOptions = {};
        this.node = {};
        this.timestamp = 0;
        this.viewBox = '0 0 0 0';
    }
    /**
     * @return {?}
     */
    IccDrawComponent.prototype.style = /**
     * @return {?}
     */
    function () { };
    /**
     * @return {?}
     */
    IccDrawComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        setTimeout(function () { return _this.style = function () { return _this.dimensionsComponent.margins; }; }, 0);
    };
    /**
     * @return {?}
     */
    IccDrawComponent.prototype.ngDoCheck = /**
     * @return {?}
     */
    function () {
        if (this.details && this.details.timestamp !== this.timestamp) {
            this.timestamp = this.details.timestamp;
            this.drawDetails = new IccDrawDetails(this.details);
            this.drawOptions = new IccDrawOptions(this.options);
            this.interfaceComponent.move.inputs.ratio = this.drawOptions.dimensions.ratio || 1;
            this.node = IccDrawSyncService.syncDetails(this.drawDetails, this.drawOptions);
            if (this.node && this.node.children) {
                // const viewBox = IccDrawService.getViewBox(this.node, this.drawOptions.side);
                var /** @type {?} */ viewBox = this.node.rect;
                if (this.node.side !== 'outer') {
                    this.viewBox = viewBox.x + " " + viewBox.y + " " + viewBox.width + " " + viewBox.height;
                }
                else {
                    this.viewBox = -viewBox.width + " " + viewBox.y + " " + (viewBox.width - viewBox.x) + " " + viewBox.height;
                }
            }
        }
    };
    IccDrawComponent.decorators = [
        { type: Component, args: [{
                    selector: 'icc-draw',
                    styles: [":host * { box-sizing: border-box; margin: 0; padding: 0; } .icc-draw { clear: both; position: relative; -webkit-touch-callout: none; -webkit-user-select: none; -khtml-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none; } .icc-draw-svg { display: block; } .icc-draw-indexes { position: absolute; } "],
                    template: "<div class=\"icc-draw\" [ngStyle]=\"style()\"> <svg #svg [attr.viewBox]=\"viewBox\" class=\"icc-draw-svg\" preserveAspectRatio=\"xMidYMid meet\" width=\"100%\" height=\"100%\" > <svg icc-draw-svg [node]=\"node\"></svg> </svg> <icc-draw-dimensions [details]=\"drawDetails\" [node]=\"node\" [options]=\"drawOptions.dimensions\"></icc-draw-dimensions> <icc-draw-interface [node]=\"node\" [options]=\"drawOptions.interface\" [interfaceClickHandler]=\"drawOptions.onInterfaceClick\" [svg]=\"svg\"></icc-draw-interface> </div> ",
                },] },
    ];
    /** @nocollapse */
    IccDrawComponent.ctorParameters = function () { return []; };
    IccDrawComponent.propDecorators = {
        "details": [{ type: Input },],
        "options": [{ type: Input },],
        "interfaceClicked": [{ type: Output },],
        "dimensionsComponent": [{ type: ViewChild, args: [IccDrawDimensionsComponent,] },],
        "interfaceComponent": [{ type: ViewChild, args: [IccDrawInterfaceComponent,] },],
    };
    return IccDrawComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var IccDrawSvgComponent = (function () {
    function IccDrawSvgComponent() {
        this.node = {};
    }
    /**
     * @return {?}
     */
    IccDrawSvgComponent.prototype.ngDoCheck = /**
     * @return {?}
     */
    function () {
        this.nodes = [];
        this.getNodes();
        this.sortNodes();
    };
    /**
     * @param {?=} node
     * @return {?}
     */
    IccDrawSvgComponent.prototype.getNodes = /**
     * @param {?=} node
     * @return {?}
     */
    function (node) {
        var _this = this;
        if (node === void 0) { node = this.node; }
        if (node && node.svg) {
            this.nodes.push(node);
        }
        if (node && node.children && node.children.length) {
            node.children.map(function (child) { return _this.getNodes(child); });
        }
    };
    /**
     * @return {?}
     */
    IccDrawSvgComponent.prototype.sortNodes = /**
     * @return {?}
     */
    function () {
        var /** @type {?} */ index = {};
        var /** @type {?} */ order = [
            'ColorsNode',
            'ShutterColorsNode',
            'BaseNode',
            'ShapeNode',
            'ShutterNode',
            'ShutterBoxNode',
            'ShutterDriveNode',
            'RenoNode',
            'SillsNode',
            'ExtensionsNode',
            'RollerShutterNode',
            'GlazingNode',
            'MuntinNode',
            'FrameNode',
            'DowelHolesNode',
            'SashNode',
            'AlignmentNode',
            'MullionNode',
            'SashFrameNode',
            'GlazingBeadNode',
            'RensonNode',
            'VentilatorNode',
            'SymbolNode',
            'HandleNode',
            'DimensionNode',
            'IndexesNode',
        ];
        for (var /** @type {?} */ i = 0; i < order.length; i++) {
            index[order[i]] = i;
        }
        this.nodes.sort(function (a, b) { return (a.level - b.level) || (index[a.constructor.name] - index[b.constructor.name]) || -1; });
    };
    IccDrawSvgComponent.decorators = [
        { type: Component, args: [{
                    selector: 'svg [icc-draw-svg]',
                    styles: [":host { overflow: visible; } g.group-hover:hover > path, g.single-hover > path:hover { cursor: pointer; fill: #eee; } "],
                    template: "<svg:g *ngFor=\"let node of nodes\" [attr.class]=\"node.constructor.name\" > <svg:defs *ngIf=\"node.svg.gradients.length || node.svg.patterns.length\"> <svg:linearGradient *ngFor=\"let svgGradient of node.svg.gradients\" [attr.id]=\"svgGradient.id\" x1=\"0.5\" x2=\"0\" y1=\"1\" y2=\"0\" > <svg:stop *ngFor=\"let svgGradientStep of svgGradient.steps\" [attr.offset]=\"svgGradientStep.offset\" [attr.stop-color]=\"svgGradientStep.color\" ></svg:stop> </svg:linearGradient> <!--patternUnits=\"objectBoundingBox\"--> <svg:pattern *ngFor=\"let svgPattern of node.svg.patterns\" [attr.id]=\"svgPattern.id\" [attr.patternTransform]=\"svgPattern.patternTransform\" [attr.patternUnits]=\"svgPattern.patternUnits\" [attr.width]=\"svgPattern.width\" [attr.height]=\"svgPattern.height\" [attr.x]=\"svgPattern.x\" [attr.y]=\"svgPattern.y\" > <svg:rect *ngIf=\"svgPattern.color\" [attr.fill]=\"svgPattern.color\" [attr.width]=\"svgPattern.width\" [attr.height]=\"svgPattern.height\" [attr.x]=\"0\" [attr.y]=\"0\" /> <svg:image *ngIf=\"svgPattern.image\" [attr.xlink:href]=\"svgPattern.image\" [attr.width]=\"svgPattern.width\" [attr.height]=\"svgPattern.height\" [attr.x]=\"0\" [attr.y]=\"0\" preserveAspectRatio=\"none\" /> </svg:pattern> </svg:defs> <svg:g *ngIf=\"node.svg.paths.length || node.svg.texts.length\" (click)=\"node.options.actions && node.options.actions.onHover === 'group-hover' ? node.options.actions.onClick(node.onClick({index: 'all'})) : null\" [ngClass]=\"node.options.actions ? node.options.actions.onHover : null\" attr.pointer-events=\"{{node.options.actions && node.options.actions.onHover ? 'all' : 'none'}}\" > <svg:path *ngFor=\"let svgPath of node.svg.paths; let i = index\" (click)=\"node.options.actions && node.options.actions.onHover === 'single-hover' ? node.options.actions.onClick(node.onClick({index: i})) : null\" [attr.d]=\"svgPath.d\" [attr.fill]=\"svgPath.fill\" [attr.stroke]=\"svgPath.stroke\" [attr.stroke-dasharray]=\"svgPath.strokeDasharray\" [attr.stroke-width]=\"svgPath.strokeWidth\" [attr.vector-effect]=\"svgPath.vectorEffect\" attr.pointer-events=\"{{node.options.actions && node.options.actions.onHover ? 'all' : 'none'}}\" /> <svg:text *ngFor=\"let svgText of node.svg.texts\" [attr.dominant-baseline]=\"svgText.dominantBaseline\" [attr.fill]=\"svgText.fill\" [attr.font-size]=\"svgText.fontSize\" [attr.stroke]=\"svgText.stroke\" [attr.stroke-width]=\"svgText.strokeWidth\" [attr.text-anchor]=\"svgText.textAnchor\" [attr.transform]=\"svgText.transform\" [attr.x]=\"svgText.x\" [attr.y]=\"svgText.y\" font-family=\"sans-serif\" >{{svgText.value}}</svg:text> </svg:g> </svg:g> ",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                },] },
    ];
    /** @nocollapse */
    IccDrawSvgComponent.ctorParameters = function () { return []; };
    IccDrawSvgComponent.propDecorators = {
        "node": [{ type: Input },],
    };
    return IccDrawSvgComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var IccDrawModule = (function () {
    function IccDrawModule() {
    }
    IccDrawModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        FormsModule,
                    ],
                    declarations: [
                        IccDrawComponent,
                        IccDrawDimensionsComponent,
                        IccDrawInterfaceComponent,
                        IccDrawSvgComponent,
                    ],
                    entryComponents: [
                        IccDrawComponent,
                        IccDrawDimensionsComponent,
                        IccDrawInterfaceComponent,
                        IccDrawSvgComponent,
                    ],
                    exports: [
                        IccDrawComponent,
                        IccDrawDimensionsComponent,
                        IccDrawInterfaceComponent,
                        IccDrawSvgComponent,
                    ],
                },] },
    ];
    return IccDrawModule;
}());

export { IccDrawModule, IccDrawComponent, IccDrawDimensionsComponent, IccDrawInterfaceComponent, IccDrawSvgComponent, IccDrawMathService, IccDrawSyncService, IccDrawDetails };
